export default {
  common: {
    noFace: 'မြင်းချိုးမရှိပါ',
    noPermissionTip: 'ဤဝန်ဆောင်မှုကို အသုံးပြုနိူင်သည်မဟုတ်ပါ။ ပြီးပါးပြီး အသုံးပြုပါ။',
    selected: 'ရွေးချယ်ထားသည်',
    continue: 'ဆက်လက်',
    open1: 'ဖွင့်ပါ',
    doubleClick: 'နှစ်ချက်နှိပ်ပါ',
    inputKeywordSearch: 'သော့ချက်ကိုရိုက်ထည့်၍ ရှာဖွေပါ',
    inputKeywordStartSearch: 'ရှာဖွေမှုစတင်ရန် သော့ချက်ထည့်ပါ',
    searchHistory: 'ရှာဖွေမှုသမိုင်း',
    clearHistory: 'သမိုင်းဖျက်ပါ',
    notFoundRelatedResults: 'ဆက်စပ်ရလဒ်မတွေ့ပါ',
    switch: 'ပြောင်းလဲပါ',
    searchProductionLine: 'ထုတ်လုပ်ရေးလိုင်း',
    selectProductionLine: 'ထုတ်လုပ်ရေးလိုင်းရွေးချယ်ပါ',
    rotateAngleTip: '{angle} လည်ပတ်ပါ',
    plankText: 'ပေါ်ဒ်',
    sendToEzSort: 'EzSort သို့ပေးပို့ပါ',
    downloadEzSort: 'EzSort ဒေါင်းလုပ်လုပ်ပါ',
    notDownloadTip: 'EzSort ပုံမှန်မဖွင့်နိုင်ပါက ဒေါင်းလုပ်မလုပ်ရသေးနိုင်ပါ။ EzSort ဒေါင်းလုပ်လုပ်ရန် အောက်ပါခလုတ်ကိုနှိပ်ပါ',
    updateTip: 'ဆော့ဖ်ဝဲအပ်ဒိတ်တွေ့ပါ၊ Guigui ပြန်ဖွင့်ပါ!',
    betaTest: 'Beta စစ်ဆေးမှုကာလ အခမဲ့',
    ersortSpecail: 'Color Label အတွက်သီးသန့်',
    exclusiveFeature: 'သီးသန့်လုပ်ဆောင်ချက်',
    elementCanBeDragTip: 'အရာဝတ္ထုကို ဆွဲသွားနိုင်သည်',
    checkPlankIsConflict: 'ပေါ်ဒ်အခြေအနေစစ်ဆေးနေသည်',
    preferenceSaveErr: 'ကြိုက်နှစ်သက်မှုသိမ်းဆည်းမှုအမှားရှိ',
    guimen: 'ဗီရိုတံခါး',
    preferenceLoadTip: 'သင်၏ကြိုက်နှစ်သက်မှုဆက်တင်တင်နေသည်',
    preferenceLoadErrTip: 'ကြိုက်နှစ်သက်မှုဆက်တင်တင်ရောက်မအောင်မြင်ပါ၊ ပြန်လည်စစ်ဆောင်းကြည့်ပါ!',
    localFileIsBeingWrite: 'ဒေသတွင်းဖိုင်ကို ရေးသွင်းနေသည်',
    unnamedFile: 'အမည်မသိဖိုင်',
    taskMonitor: 'လုပ်ဆောင်ချက်စောင့်ကြည့်မှု',
    downloadByType: '{type} ဒေါင်းလုပ်လုပ်ပါ',
    slotKnifeErr: 'ကြိုးသတ်မှတ်ကိရိယာမပါ၊ ထုတ်လုပ်ရေးလိုင်းဆက်တင်ကိုစစ်ဆေးပါ! 【{msg}】',
    anewChooseCatalog: 'လမ်းညွှန်ကိုပြန်ရွေးပါ',
    downloadSetting: 'ဒေါင်းလုပ်ဆက်တင်',
    attention: 'သတိပြုပါ',
    unit: 'ခု',
    defaultUse: 'မူလအသုံးပြုမှု',
    defaultChooseUse: 'မူလရွေးချယ်မှု',
    requestFail: 'တောင်းဆိုမှုမအောင်မြင်',
    downloadDoneByType: '{type} ဒေါင်းလုပ်ပြီးစီးပါပြီ',
    sysTip: 'စနစ်အကြောင်းကြားချက်',
    pleaseChoose: 'ကျေးဇူးပြု၍ ရွေးချယ်ပါ',
    confirmDelete: 'ဖျက်ရန်အတည်ပြုပါ',
    notDataTipByType: 'ဒေတာမရှိသေး၊ ကျေးဇူးပြု၍ {msg} ဦးစွာလုပ်ပါ',
    paginationTotalTip: '{current}-{page} /{total} ခုလုံး',
    chooseAmountData: '{number} ဒေတာများကိုရွေးချယ်ပြီး',
    moreOperate: 'ပိုမို',
    transferByType: '{type} လွှဲပြောင်းပါ',
    clickCopy: '{type} ကူးယူရန် နှိပ်ပါ',
    currentLine: 'လက်ရှိတန်း',
    remark: 'မှတ်ချက်',
    customFunction: 'စိတ်ကြိုက်လုပ်ဆောင်ချက်',
    limitedTimeTrial: 'Limited Free',
    startDate: 'စတင်ရက်စွဲ',
    endDate: 'ပြီးဆုံးရက်စွဲ',
    startTime: 'စတင်အချိန်',
    endTime: 'ပြီးဆုံးအချိန်',
    lastMonth: 'ပြီးခဲ့သောတစ်လ',
    lastSixMonth: 'ပြီးခဲ့သောခြောက်လ',
    lastYear: 'ပြီးခဲ့သောတစ်နှစ်',
    searchByType: 'ရှာဖွေရန် {type} ထည့်ပါ',
    addTime: 'အချိန်ထည့်ပါ',
    startArrange: 'ပြင်ဆင်မှုစတင်ပါ',
    select: 'ရွေးပါ',
    search: 'ရှာဖွေ',
    name: 'အမည်',
    plankNo: 'ပေါ်ဒ်နံပါတ်',
    plankName: 'ပေါ်ဒ်အမည်',
    orderNo: 'အော်ဒါနံပါတ်',
    order: 'အော်ဒါ',
    partNameWithoutRoomCabinet: 'ပေါ်ဒ်အမည် (အခန်း/ဗီရိုမပါ)',
    plankRemark: 'ပေါ်ဒ်မှတ်ချက်',
    room: 'အခန်း',
    orderAddress: 'ပရောဂျက်လိပ်စာ',
    matCode: 'ပစ္စည်းကုဒ်',
    matCode2: 'ပစ္စည်း',
    plankMatCode: 'ပေါ်ဒ်ပစ္စည်း',
    count: 'အရေအတွက်',
    customer: 'ဖောက်သည်',
    customerInfo: 'ဖောက်သည်သတင်းအချက်အလက်',
    factoryOrderNo: 'စက်ရုံအော်ဒါနံပါတ်',
    roomName: 'အခန်းအမည်',
    color: 'အရောင်',
    plankColor: 'ပေါ်ဒ်အရောင်',
    plankThick: 'ပေါ်ဒ်အထူ',
    plankHighGloss: 'ဂုဏ်သတ္တိမြင့်မားသောအလင်းတန်း',
    thick: 'အထူ',
    front: 'ရှေ့ဘက်မျက်နှာ',
    back: 'နောက်ဘက်မျက်နှာ',
    slot: 'ကြိုး',
    hole: 'ပေါက်',
    hsInfo: '{hole} ပေါက် {slot} ကြိုး',
    diameter: 'အချင်း',
    finishedWidth: 'ပြီးစီးသောပစ္စည်းအကျယ်',
    finishedHeight: 'ပြီးစီးသောပစ္စည်းအရှည်',
    finishedArea: 'ပြီးစီးသောပစ္စည်းဧရိယာ (㎡)',
    remarks: 'မှတ်ချက်',
    remark1: 'မှတ်ချက် 1',
    remark2: 'မှတ်ချက် 2',
    remark3: 'မှတ်ချက် 3',
    remark4: 'မှတ်ချက် 4',
    remark5: 'မှတ်ချက် 5',
    remark6: 'မှတ်ချက် 6',
    remark7: 'မှတ်ချက် 7',
    remark8: 'မှတ်ချက် 8',
    remark9: 'မှတ်ချက် 9',
    remark10: 'မှတ်ချက် 10',
    remark11: 'မှတ်ချက် 11',
    remark12: 'မှတ်ချက် 12',
    remark13: 'မှတ်ချက် 13',
    remark14: 'မှတ်ချက် 14',
    remark15: 'မှတ်ချက် 15',
    remark16: 'မှတ်ချက် 16',
    texture: 'ကြောင်းအမျိုးအစား',
    normal: 'ဒေါင်လိုက်ကြောင်း',
    reverse: 'အလျားလိုက်ကြောင်း',
    notCare: 'ကြောင်းမရှိ',
    holeSlotsStastic: 'ပေါက်နှင့်ကြိုးအရေအတွက်',
    edge: {
      title: 'အနားပိတ်',
      info: 'အနားပိတ်သတင်းအချက်အလက်',
      front: 'ရှေ့အနားပိတ်',
      back: 'နောက်အနားပိတ်',
      left: 'ဘယ်အနားပိတ်',
      right: 'ညာအနားပိတ်',
      up: 'အပေါ်အနားပိတ်',
      down: 'အောက်အနားပိတ်'
      },
    isSpecial: 'အထူးပုံသဏ္ဍာန်',
    notSpecial: 'ပုံမှန်ပုံသဏ္ဍာန်',
    textOfDoorPlank: 'တံခါးပေါ်ဒ်',
    textOfNotDoorPlank: 'တံခါးမဟုတ်သောပေါ်ဒ်',
    isDoorPlank: 'တံခါးပေါ်ဒ်',
    notDoorPlank: 'တံခါးပေါ်ဒ်မဟုတ်',
    width: 'အကျယ်',
    long: 'အရှည်',
    plankWidth: 'ပေါ်ဒ်အကျယ်',
    plankHeight: 'ပေါ်ဒ်အရှည်',
    shortLong: 'တိုသောဘက်အရှည်',
    shortWidth: 'တိုသောဘက်အကျယ်',
    plankShape: 'ပေါ်ဒ်ပုံသဏ္ဍာန်',
    detail: 'အသေးစိတ်',
    cancel: 'ပယ်ဖျက်ပါ',
    confirm: 'အတည်ပြုပါ',
    alreadyKnow: 'ကျွန်တော်သိပြီ',
    Noprompts: 'နောက်ထပ်မပြတော့',
    deep: 'နက်သောနေရာ',
    other: 'အခြား',
    heighGloss: 'မြင့်မားသောဂလော့',
    heighGlossPlank: 'မြင့်မားသောဂလော့ပေါ်ဒ်',
    heighGlossSide: 'မြင့်မားသောဂလော့ပေါ်ဒ်',
    notHeighGloss: 'မြင့်မားသောဂလော့မဟုတ်',
    notHeighGlossPlank: 'မြင့်မားသောဂလော့ပေါ်ဒ်မဟုတ်',
    saveSuccess: 'သိမ်းဆည်းအောင်မြင်',
    deleteSuccess: 'ဖျက်ဆီးအောင်မြင်',
    addSuccess: 'ထည့်သွင်းအောင်မြင်',
    editSuccess: 'တည်းဖြတ်အောင်မြင်',
    engraving: 'အမြစ်ချစက်',
    electronicSaw: 'ဒီဂျစ်တယ်မြဲ',
    glassEquip: 'မှန်ဖြတ်စက်',
    labelingMachine: 'တံဆိပ်ကပ်စက်',
    copy: 'ကူးယူပါ',
    paste: 'ကပ်ပါ',
    undo: 'ပြန်ဖျက်ပါ',
    move: 'ရွှေ့ပါ',
    PTP: 'PTP',
    dock56FDrill: 'ငါး/ခြောက်မျက်နှာဖောက်',
    sideHoleDrill: 'ဘေးပေါက်ဖောက်စက်',
    combination: 'ပေါင်းစပ်ကိရိယာ',
    integration: 'ပေါင်းစပ်ထားသောစက်',
    standardPlank: 'ပုံမှန်ကြီးသောပေါ်ဒ်',
    standardMaterial: 'ပုံမှန်ပေါ်ဒ်ပစ္စည်း',
    standardMaterialTip: 'မှတ်ချက်- ကြီးသောပေါ်ဒ်သတင်းအချက်အလက်ပြင်ဆင်ပြီးနောက် ကာဘင်နက်ပြင်ဆင်မှုထုတ်လုပ်မှုအသုံးပြုသောသုံးစွဲသူများသည် နောက်ဆုံးပြောင်းလဲမှုများကိုကျင့်သုံးရန် ကာဘင်နက်ဖောက်သည်ကိုပြန်ဖွင့်ရမည်!',
    specialMaterial: 'အထူးပေါ်ဒ်ပစ္စည်း',
    specialPlank: 'အထူးကြီးသောပေါ်ဒ်',
    singlePlank: 'တစ်ဖက်ပေါ်ဒ်',
    previous: 'ယခင်',
    plankInfo: 'ကြီးသောပေါ်ဒ်အသေးစိတ်',
    moreResult: 'ပိုမိုသောပြင်ဆင်မှုပြားများ',
    moreResultTip: 'ကြီးသောပေါ်ဒ်တွင် ကြိုးပြင်ဆင်မှုရှိသောကြောင့် ကြီးသောပေါ်ဒ်ကိုပြန်ပြင်ဆင်မည်မဟုတ်',
    ok: 'အတည်ပြုပါ',
    dispersePaibanTip: 'အချို့ကြီးသောပေါ်ဒ်များကိုဖြန့်ကြက်ပြင်ဆင်၍မရနိုင်ပါ၊ ဖြစ်နိုင်ပါကဆက်တင်ကိုပြင်ဆင်ပါ!',
    next: 'နောက်တစ်ခု',
    rate: 'အသုံးပြုမှုနှုန်း',
    paibanBatch: 'ပြင်ဆင်မှုအစု',
    return: 'ပြန်သွားပါ',
    FGNo: 'စာချုပ်နံပါတ်',
    refresh: 'ပြန်တင်ပါ',
    inde: 'အမျိုးအစားနံပါတ်',
    productionLine: 'ထုတ်လုပ်ရေးလိုင်း',
    operation: 'လုပ်ဆောင်ချက်',
    colorPlaceHolder: 'Enter နှိပ်၍ အရောင်ကတ်အလိုအလျောက်ဖန်တီးပါ',
    saveAndContinue: 'သိမ်းဆည်းပြီး ဆက်လက်လုပ်ဆောင်ပါ',
    reset: 'ပြန်သတ်မှတ်ပါ',
    check: 'မေးမြန်းပါ',
    inputPlaceholder: 'ကျေးဇူးပြု၍ ထည့်ပါ',
    filter: 'စစ်ထုတ်ပါ',
    all: 'အားလုံး',
    exportPDF: 'PDF ထုတ်ပါ',
    exportPic: 'ဓာတ်ပုံထုတ်ပါ',
    add: 'ထည့်ပါ',
    edit: 'တည်းဖြတ်ပါ',
    delete: 'ဖျက်ပါ',
    restore: 'ပြန်လည်ပါ',
    save: 'သိမ်းဆည်းပါ',
    saveSetting: 'ဆက်တင်သိမ်းဆည်းပါ',
    isHeightGloss: 'မြင့်မားသောဂလော့ပေါ်ဒ်ဖြစ်မဖြစ်ရွေးချယ်ပါ',
    noSync: 'စင်ခ်မဆောင်ရွက်ဘဲ',
    sync: 'စင်ခ်ဆောင်ရွက်သည်',
    formatSuccess: '{type} အောင်မြင်',
    dataLoading: 'ဒေတာတင်နေသည်......',
    warmTip: 'ကြင်နာသောအကြောင်းကြားချက်',
    importantTip: 'အရေးကြီးသောအကြောင်းကြားချက်',
    wellcome: 'Cloud Layout သို့ကြိုဆိုပါသည်',
    timeOut: 'ပြင်ဆင်မှုကာလကုန်ဆုံးပြီ၊ ပြန်ပြင်ဆင်မည်လား',
    notSawKnifeTip: 'သတိပြုပါ- ဖြတ်ညွတ်စက်တွင် "အလျားဖြတ်ဘလေဒ်" မသတ်မှတ်ထားသောကြောင့် ပြင်ဆင်၍မရ၊ ထည့်သွင်းပါ!',
    doorFrameKnifeRadiusErr: 'သင်သည် "ဖြတ်ညွှတ်စက်-တံခါးဘောင်ဖြတ်ခြင်း" လုပ်ဆောင်ချက်ကို ဖွင့်ထားပြီး၊ ဖြတ်ဓားအချင်းသည် ဆောက်ဓားအထူးထက် ကြီးနေသောကြောင့် ပြင်ဆင်၍မရပါ!',
    doorFrameIrregularPlankErr: 'သင်သည် "ဖြတ်ညွှတ်စက်-တံခါးဘောင်ဖြတ်ခြင်း" လုပ်ဆောင်ချက်ကို ဖွင့်ထားပြီး၊ ဤလုပ်ဆောင်ချက်သည် မမှန်သော ပလက်အမျိုးအစား ပြင်ဆင်မှုကို ယာယီမပံ့ပိုးပါ!',
    warning: 'သတိပေးချက်',
    export: 'ထုတ်ပါ',
    mark: 'မှတ်သားပါ',
    noMark: 'မမှတ်သားဘဲ',
    sawArrange: 'ဖြတ်ပြင်ဆင်မှု',
    directArrange: 'တိုက်ရိုက်ပြင်ဆင်မှု',
    area: 'ဧရိယာ',
    plankNum: 'ပေါ်ဒ်ဘာကုဒ်',
    loc: 'ဗီရို',
    cutHeight: 'ဖြတ်ထားသောအရှည်',
    cutWidth: 'ဖြတ်ထားသောအကျယ်',
    defaultProduction: 'မူလထုတ်လုပ်ရေးလိုင်း',
    surplusNum: 'ပိုလျှံပစ္စည်းဘာကုဒ်',
    tip: 'အကြောင်းကြားချက်',
    history: 'မှတ်တမ်း',
    hinge: 'ဟင်းချဉ်ပေါက်',
    hingeScrew: 'ဟင်းချဉ်တံခါးပေါ်ဒ်ဖောက်ပေါက်',
    CCPXHole: 'သုံးပေါင်းတစ်ညာသောပေါက်',
    stretchHinge: 'ဆွဲဖြောင့်ကြိုးနှင့်ဟင်းချဉ်ခွက်ပေါက်',
    stretch: 'ဆွဲဖြောင့်ကိရိယာ',
    stretcher: 'ဆွဲဖြောင့်ကြိုး',
    eccHole: 'ညာသောပေါက်',
    preHole: 'ကြိုတင်မြှပ်ထားသောပေါက်',
    clothole: 'အဝတ်ဆောင်ပေါက်',
    backPlank: 'နောက်ပေါ်ဒ်ကြိုး',
    ALS: 'မမြင်ရသောဆွဲသည့်ကြိုး',
    doorSlot: 'တံခါးသတ္တုကြိုး',
    drawerSlot: 'ဆွဲဆောင်သတ္တုကြိုး',
    lkSlot: 'လော့ကြိုး',
    KC: 'ဘောင်းဘီဆွဲပေါက်',
    stealth: 'မမြင်နိုင်သောအစိတ်အပိုင်း',
    lightSlot: 'မီးရောင်ကြိုး',
    ConventionalHole: 'ပုံမှန်ပေါက်',
    Keyhole: 'သော့ပေါက်',
    allHole: ' အထူးပုံပေါ်ဒ်ပေါ်ရှိ ပေါက်အားလုံး',
    allSlot: ' အထူးပုံပေါ်ဒ်ပေါ်ရှိ ကြိုးအားလုံး',
    freedomAllHoleSlot: ' အထူးပုံပေါ်ဒ်ပေါ်ရှိ ပေါက်အားလုံးနှင့် ကြိုးအားလုံး',
    freedomAllHoleSlotTip: ' အထူးပုံပေါ်ဒ်: မြှောက်တန်းတစ်ခုအပြင်အဆင်မရှိသော ပုံပေါ်ဒ်',
    millInfo: 'နွားချောင်းဆွဲလက်ကိုင်',
    haiTang: 'ဘီဂိုနိုယာထောင့်',
    FSDrill: 'ငါး/ခြောက်မျက်နှာဖောက်',
    engraving2: 'ပစ္စည်းဖြတ်စက်',
    xyReverse: 'XY ဝင်ရိုးပြောင်းလဲ',
    autoXYReverse: 'အထူးပုံပေါ်ဒ်ပေါ်ရှိ ကြိုးအားလုံး',
    autoXYReverseTip: 'ငါး/ခြောက်မျက်နှာဖောက် နှင့် ကြိုးအားလုံး ပေါ်ဒ်ပေါ်ရှိ ကြိုးအားလုံး',
    autoXYReverseTip2: 'မှတ်ချက်: PTP မှားနေပါသည်',
    xyReverseTip: 'XY ဝင်ရိုးပြောင်းလဲလုပ်ဆောင်ချက်သည် L ပုံပစ္စည်းနှင့်မကိုက်ညီသေး၊ သတိဖြင့်သုံးပါ',
    rect: 'ထောင့်မှန်စတုဂံ',
    Ltype: 'L ပုံသဏ္ဍာန်',
    archive: 'Archive',
    tellPlaceholder: 'ဖုန်းနံပါတ်ထည့်ပါ',
    knivesStore: 'ဓားသိုလှောင်ကိုင်',
    roll: 'ပေါ်ဒ်ကိုပြောင်းဘက်',
    pause: 'ခဏရပ်ပါ',
    editTrans: 'ဘာသာပြန်တည်းဖြတ်',
    translateManager: 'ဘာသာပြန်စီမံ',
    grating: 'မျက်နှာကျင်းတော',
    addressEditErr: 'အော်ဒါများ၌ ပရောဂျက်လိပ်စာ ပြင်ဆင်မှုကိုယာယီမလုပ်နိုင်',
    customerEditErr: 'အော်ဒါများ၌ ဖောက်သည်သတင်းမပြင်နိုင်',
    factoryEditErr: 'အော်ဒါများ၌ စက်ရုံအော်ဒါနံပါတ်မပြင်နိုင်',
    roomNameEditErr: 'အော်ဒါများ၌ အခန်းအမည်မပြင်နိုင်',
    remarkEditErr: 'အော်ဒါများ၌ မှတ်ချက်မပြင်နိုင်',
    toMaterialList: 'ပစ္စည်းစာရင်းသွားပါ',
    deleteFail: 'ဖျက်ဆီးမအောင်မြင်ပါ၊ နောက်မှ ပြန်ကြိုးစားပါ!',
    batchRestore: 'အစုလိုက်ပြန်လည်ထားရှိပါ',
    batchDelete: 'အစုလိုက်ဖျက်ပါ',
    workShop: 'ဝပ်ရှော့ထုတ်လုပ်မှု',
    FGAdrress: 'ပရောဂျက်လိပ်စာ/စာချုပ်နံပါတ်',
    cuttingSize: 'ဖြတ်ထားသောအရွယ်အစား',
    finishedSize: 'ပြီးစီးသောပစ္စည်းအရွယ်အစား',
    labelImg: 'တံဆိပ်ကပ်ပုံ',
    layoutImg: 'ပြင်ဆင်မှုပုံ',
    file: 'ဖိုင်',
    folder: 'ဖိုင်ဆောင်',
    reName: 'အမည်ပြောင်းပါ',
    to: 'ကို',
    plankUnit: 'ချပ်',
    tagTemp: 'တံဆိပ်ပုံစံ',
    roomRemark: 'အခန်းမှတ်ချက်',
    noModificationPermission: 'ပြင်ဆင်ခွင့်မရှိ',
    modificationRecord: 'ပြင်ဆင်မှုမှတ်တမ်း',
    page: 'စာမျက်နှာ',
    strip: 'ကြောင်း',
    jump: 'ခုန်ပါ',
    freeAgreement: 'ဆော့ဖ်ဝဲမြသင်ကောင်းကြောင်းကာလ',
    preStep: 'ယခင်အဆင့်',
    nextStep: 'နောက်အဆင့်',
    upload: 'တင်ပြပါ',
    uploading: 'တင်ပြနေသည်',
    iAgree: 'ကျွန်တော်သဘောတူသည်',
    pleaseSelectPlank: 'အနည်းဆုံးပေါ်ဒ်တစ်ခုရွေးပါ',
    saveToStoreTip: 'အနည်းဆုံးဖြတ်မထားသောပေါ်ဒ်တစ်ခုရွေးပါ',
    fileIsNotExist: 'ဖိုင်မရှိပါ',
    selectAll: 'အားလုံးရွေးပါ',
    pdfTag: 'PDF တံဆိပ်',
    tagImage: 'တံဆိပ်ပုံ',
    guigui: 'Guigui',
    gratingSlot: 'မျက်နှာကျင်းကြိုး',
    deleteTip: 'ဒေတာဖျက်ပြီးမပြန်ရနိုင်ပါ၊ ဖျက်ရန်အတည်ပြုမည်လား?',
    deleteError: 'မသိသောအမှားဖြစ်ပွားပြီး ဖျက်မအောင်မြင်',
    cancelDelete: 'ဖျက်ဆီးမှုပယ်ဖျက်ပြီ',
    confirmDeleteTip: 'ဖျက်ပြီးနောက် ပေါ်ဒ်သည် "ပြင်ဆင်ရမည့်ဘောင်-မသွင်းရသေး"တွင် ဝင်မည်၊ ဒေတာဖျက်ရန်အတည်ပြုမည်လား?',
    confirmDeleteBujianTip: 'ဖျက်ပြီးနောက် အစိတ်အပိုင်းသည် "အစိတ်အပိုင်းများ စာကြည့်တိုက်" တွင် ထည့်သွင်းမည်၊ ဒေတာဖျက်ရန် အတည်ပြုမည်လား?',
    confirmSureDeleteTip: 'လက်ရှိပြင်ဆင်ရမည့်ဘောင်တွင် ဆင်တူပစ္စည်းကိုင်ပေါ်ဒ်ငယ်ရှိပါသည်၊ ဤပေါ်ဒ်ကြီးဆက်ဖျက်ရန်အတည်ပြုမည်လား?',
    deleteEmptyTip: 'ဤပေါ်ဒ်ကြီးကိုဖျက်မည်လား',
    notCanDelete: 'ဖြတ်ထားသောပိုလျှံပစ္စည်းကိုသိုလှောင်မှုမှမထည့်နိုင်',
    new: 'New',
    innerBluneFailure: 'ထည့်သွင်းထားသောCloud Layoutသည်ဤလုပ်ဆောင်ချက်ကိုမကျင့်သုံးနိုင်',
    deleteBigPlankTip: 'နောက်ဆုံးပေါ်ဒ်ကြီးတွင် ပေါ်ဒ်ငယ်ရှိ၍မဖျက်နိုင်!',
    continueExport: 'လျစ်လျူရှုပြီး ဖိုင်ထုတ်မည်',
    toCheck: 'စစ်ဆေးသွားပါ',
    pleaseCheck: 'လက်ရှိပြင်ဆင်မှုတွင် ပေါက်ကြိုးပဋိပက္ခ/ပေါ်ဒ်ငယ်ထွက်ခြင်း/နက်မှုပုံမမှန်ရှိ၊ စစ်ဆေးပါ!',
    clampHandCheck: 'ပေါ်ဒ်တချို့၏ပေါက်ကြိုးများသည် ကိုင်ဆွဲနေရာ ရှောင်မနိုင်ကြောင်းတွေ့ပါ၊ ကိုယ်တိုင်ညှိပါ',
    conflictPartDetail: 'ပဋိပက္ခဖြစ်နေသောပေါ်ဒ်အသေးစိတ်',
    colorNotUndefined: 'အရောင်ကိုဗလာမထားနိုင်',
    materialNotUndefined: 'ပစ္စည်းကိုဗလာမထားနိုင်',
    newSetting: 'လုပ်ဆောင်ချက်အသစ်',
    downImageErrTip: 'ပုံထုတ်မအောင်မြင်ပါ၊ တံဆိပ်ပုံချပ်ပြီး ဖိုင်ဆောင်ခွဲပြင်ဆင်မှာ ပေါ်ဒ်ငယ်တံဆိပ်ကိုပါထည့်ပါ',
    downNcErrTip: 'NC ဒေါင်းလုဒ်မအောင်မြင်ပါ၊ တံဆိပ်ပုံချပ်ပြီး ဖိုင်ဆောင်ခွဲပြင်ဆင်မှာ ပေါ်ဒ်ငယ်တံဆိပ်ကိုပါထည့်ပါ',
    downNcErrTipForSurFolder: 'NC ဒေါင်းလုဒ်မအောင်မြင်ပါ၊ တံဆိပ်ပုံဖိုင်ဆောင်ခွဲနှင့် ပိုလျှံပစ္စည်းဖိုင်သတ်မှတ်ချက် တပြိုင်နက်ဖွင့်၍မရ',
    yes: 'ဟုတ်ကဲ့',
    no: 'မဟုတ်ပါ',
    checkColorPrint: 'လောလောဆယ် အရောင်တံဆိပ်ဖွင့်ထားသည်၊ အရောင်ပရင်တာသုံး၍ပုံနှိပ်ပါ~',
    colorRules: 'အရောင်တံဆိပ်ထုတ်ပြည်ပြီးနောက် အော်ဒါ/အခန်း/ဗီရို/တံခါးသည် အရောင်အလိုက်ခွဲခြားမည်၊ တူညီသောဒေတာအမျိုးအစားတွင် အများဆုံး ၁၂ ခုအထိ ပံ့ပိုးသည်',
    greyPart: 'ညာဘက်တံဆိပ်တွင် မီးခိုးရောင်အပိုင်းမှာ',
    region: 'ဒေသ',
    notSame: 'မတူညီသော {regionName} ဒေသ အရောင်မတူ',
    doorTip: 'မီးခိုးရောင်မှာ တံခါးပေါ်ဒ်၊ အဖြူရောင်မှာ တံခါးမဟုတ်သောပေါ်ဒ်',
    exist: 'ရှိပါသည်',
    limitNotEffect: 'ဒေတာ ၁၂ ထက်ကျော်ပါက အရောင်တံဆိပ်မကျင့်သုံးနိုင်',
    hoverTip: 'လောလောဆယ် bmp နောက်ဆက်ပါသောပုံ၊ ကုဒ်ဖော်မတ်မှာ အမဲဖြူ၊ အရောင်တံဆိပ်ပုံမထုတ်နိုင်',
    lock: 'လော့ပါ',
    unlock: 'ဖွင့်ပါ',
    batchLock: 'အစုလိုက်လော့/ဖွင့်',
    surplusLock: 'ပိုလျှံပစ္စည်းလော့',
    surplusUnlock: 'ပိုလျှံပစ္စည်းဖွင့်',
    is: 'ဟုတ်ကဲ့',
    not: 'မဟုတ်ပါ',
    savingHistory: 'မှတ်တမ်းဖိုင်သိမ်းနေသည်',
    saveHistorySuccess: 'မှတ်တမ်းဖိုင်သိမ်းဆည်းမှုအောင်မြင်သည်',
    saveHistoryFail: 'မှတ်တမ်းဖိုင်သိမ်းဆည်းမှုမအောင်မြင်',
    bw: 'အမဲဖြူတံဆိပ်ထုတ်ရန်',
    modular: 'ယူနစ်ဗီရို',
    autoAdjust: 'အလိုအလျောက်ညှိ',
    cutOrderTip: 'သင်၏ 【{errorCutOrdersString}နံပါတ်ပေါ်ဒ်ကြီး】 ဖြတ်တောက်မှုအစဉ်တွင် အမှားရှိပါသည်! NC ဖိုင်ဒေါင်းလုဒ်မပြုမီ ညှိပြင်ပါ',
    lockedCutOrderTip: '【{errorCutOrdersString}নံပါတ်ပေါ်ဒ်ကြီး】 လော့ချထားပြီ၊ ကိုယ်တိုင်ပြင်ဆင်ရန်သွားပါ',
    paibanImgCutOrderTip1: 'သင်၏',
    paibanImgCutOrderTip: 'ဖြတ်တောက်မှုအစဉ်တွင် အမှားရှိ! ပြင်ဆင်မှုပုံဖိုင်ထုတ်မပြုမီ ပြင်ဆင်မှုစာမျက်နှာသွားညှိပါ',
    goAdjust: 'ညှိပြင်သွားပါ',
    autoAdjustWarning: 'လက်ရှိပြင်ဆင်မှုရလဒ်သည် အလိုအလျောက်ညှိကိုမပံ့ပိုး',
    checkNetwork: 'ကွန်ရက်စစ်ဆေးပါ',
    moreInfo: 'နောက်ထပ်သတင်းအချက်အလက်ကြည့်ပါ',
    continueLayout: 'ပြင်ဆင်မှုဆက်လုပ်ပါ',
    adjustPosition: 'ဆက်တင်ညှိပါ',
    specialAndFiveSix: 'ငါး/ခြောက်မျက်နှာဖောက်ဖြင့် အထူးပုံပေါ်ဒ်ထုတ်ပြုစဉ် အထူးပုံနှင့်ပေါင်းစပ်မှုဖွင့်ပါက ပေါ်ဒ်ကိုဖြတ်မိနိုင်သည်၊ ဆက်ပြင်ဆင်မည်လားအတည်ပြုပါ?',
    plankPathErr: 'ပေါ်ဒ်ထဲ အထူးပုံဒေတာမှားနေသည်၊ ဓားသတ်မှတ်ချက်နှင့်ကိုက်ညီမညီစစ်ဆေးပါ! ပေါ်ဒ်နံပါတ်【{plankIDList}】',
    edgeCheck: 'ပေါ်ဒ်ကြီး၏ ဘေးဖြတ်မှုပြင်ဆင်ထားကြောင်းစနစ်ရှာဖွေတွေ့ရသည်၊ ထုတ်လုပ်မှုတိကျမှုသေချာစေရန် ပြန်ပြင်ဆင်ပါ',
    iKnow: 'သိပြီပါပြီ',
    versionErrTip: 'ဗီရိုဆော့ဖ်ဝဲကို နောက်ဆုံးဗားရှင်းသို့ အပ်ဒိတ်ပြုပါ!',
    annualFeeExpired: 'သင်၏နှစ်စဉ်ကြေးကုန်ဆုံးပြီ၊ သက်တမ်းတိုးပါ!',
    holeEquipment: 'အပေါက်ဖောက်ကိရိယာ {num}',
    customizedService: 'စိတ်ကြိုက်ပြင်ဆင်မှုဝန်ဆောင်မှုပံ့ပိုး၊ သင်၏ထူးခြားသောထုတ်လုပ်မှုစီမံချက်ဖန်တီးပါ',
    exampleCombination1: 'နှိပ်ချပ်စက် + ငါး/ခြောက်မျက်နှာဖောက် + ဘေးပေါက်ဖောက်စက် ပေါင်းစပ်မှု',
    exampleCombination2: 'ဓားပုတ်မြောင်းစက် + ငါး/ခြောက်မျက်နှာဖောက် + ဘေးပေါက်ဖောက်စက် ပေါင်းစပ်မှု',
    exampleCombination3: 'အပြည့်အဝအလိုအလျောက်ထုတ်လုပ်မှုလိုင်း + ငါး/ခြောက်မျက်နှာဖောက် ပေါင်းစပ်မှု',
    feedback: 'သင်၏လိုအပ်ချက်ကို Guigui ဆော့ဖ်ဝဲရောင်းချသူ သို့မဟုတ် ဝန်ဆောင်မှုဝန်ထမ်းသို့တိုက်ရိုက်အကြောင်းကြားနိုင်သည်',
    markModifiedBoards: 'ပြင်ဆင်ထားသောပေါ်ဒ်ငယ်ကိုမှတ်သားပါ',
    showMoveStep: 'ငိုင်းကူးကိုက်လိုက်ကိုက်အောင်မြင်စွာဖောင့်ပါ',
    moveStep: 'ငိုင်းကူးကိုက်လိုက်ကိုက်အောင်မြင်စွာဖောင့်ပါ',
    existChangeBoards: 'ပြောင်းလဲမှုရှိသောပေါ်ဒ်ငယ်ရှိပါသည်',
    crossMaterialBoard: 'ဖြတ်ကျော်ပစ္စည်းနှင့် အရောင်ဘုတ်',
    skipCrossMaterialTip: 'ဤအထွက်တွင် နောက်တစ်ကြိမ် မပြသပါ',
    crossMaterialConfirmTip: 'သင်သည် မတူညီးသော ပစ္စည်းများ သို့မဟုတ် အရောင်များဖြတ်ကျော်၍ အသေးစားဘုတ်ကို ရွှေ့နေသည်။ {highlight} ဆက်လုပ်မလား?',
    crossMaterialConfirmTipHighlight: 'ထုတ်လုပ်ထားသော ဘုတ်သည် ခွဲခြမ်းစာတမ်းနှင့် မကိုက်ညီဖြစ်နိုင်သည်',
    exportHoleSlotPDF: 'ပေါက်ကြိုးဇယားထုတ်ပါ',
    pdfFormat: 'PDF ဖော်မတ်',
    dxfFormat: 'DXF ဖော်မတ်',
    specialShapeKnivesInfo: 'အထူးပုံဓားရွေးချယ်မှုအကြောင်းကြားချက်',
    specialShapeKnivesInfoTips: '{stockNum} နံပါတ်ပေါ်ဒ်:',
    specialShapeKnivesInfoTips2: 'အထူးပုံအလိုအလျောက်ဓားရွေးချယ်မှုဖွင့်ထားပြီး ပြင်ဆင်မှုဒေတာမမှန်ကန်ပါ၊ ဖြတ်တောက်စာရင်းမှ ပြန်ပြင်ဆင်ပါ သို့မဟုတ် အထူးပုံဓားအလိုအလျောက်ရွေးချယ်မှုပိတ်ပါ',
    default: 'မူလ',
    exportLanguage: 'ထုတ်ပြည်ဘာသာစကား',
    exportLanguageTip: 'သတိ: PDF ထုတ်ပြည်တွင် စာသားတချို့ကိုဘာသာမပြန်နိုင်',
    highGlossNameTip: 'ဗီရိုမှ Sync လုပ်ထားသောဟိုင်းဂလော့ပေါ်ဒ်ကို အခြားစာသားဖြင့်ဖော်ပြနိုင်သည်၊ ဟိုင်းဂလော့ဂုဏ်သတ္တိကိုမထိခိုက်',
    mixPaibanPlanSetting: 'ပေါင်းစပ်ပြင်ဆင်မှုစီမံချက်သတ်မှတ်ချက်',
    mixPaibanPlanSettingTip: 'ပေါင်းစပ်ပြင်ဆင်မှုစီမံချက်သတ်မှတ်ချက်ပြောင်းလဲကြောင်းစနစ်ရှာဖွေတွေ့ရသည်၊ ဤကြိမ်ပေါင်းစပ်ပြင်ဆင်မှုစီမံချက်ပြန်ရွေးပါ!',
    mixPaibanPlanSettingOk: 'ပေါင်းစပ်ပြင်ဆင်မှုစီမံချက်သတ်မှတ်ပါ',
    mixPaibanPlanSettingCancel: 'မလိုဘဲ တိုက်ရိုက်ပြင်ဆင်ပါ',
    noMixPaibanPlan: 'အသုံးပြုနိုင်သောပေါင်းစပ်ပြင်ဆင်မှုစီမံချက်မရှိ',
    mixColors: 'အရောင်ရောပြင်ဆင်မှု',
    mixPai: 'ရောပြင်ဆင်',
    plan: 'စီမံချက်',
    mixPaibanTitle: 'မတူညီသောအရောင်ပေါ်ဒ်ငယ်ကိုတပြိုင်နက်ပြင်ဆင်ပါ',
    mixColorsTip: 'မည်သည့်အရောင်ပေါ်ဒ်ကိုတူညီသောအရောင်အဖြစ် ပေါ်ဒ်ကြီးပေါ်တွင်ထုတ်လုပ်နိုင်သည်ကိုသတ်မှတ်နိုင်သည်၊ ပေါ်ဒ်၏ မူလအရောင်သတင်းကိုမပြောင်းသော',
    mixColorsTip2: 'စီမံချက်ထည့်ပြီးနောက် ဖြတ်တောက်စာရင်းတွင်ဖွင့်မှသာ အကျိုးသက်ရောက်မည်',
    mixColorsTip3: 'ကွဲပြားသောအရောင်ဘေးပိတ်ဆို့လုပ်ဆောင်ချက်တွင် ပဋိပက္ခရှိ၍ တပြိုင်နက်မကျင့်သုံးနိုင်',
    mixErrTip: 'ပေါင်းစပ်ပြင်ဆင်မှုစီမံချက်တွင် မဖြစ်မနေဖြည့်ရမည့်အကွက်လျော့ပါ',
    addPlan: 'စီမံချက်ထည့်ပါ',
    chooseMatcode: 'ပစ္စည်းရွေးပါ',
    chooseColor: 'အရောင်ရွေးပါ',
    defineColor: 'ရွေးချယ်ထားသောအရောင်ကို သတ်မှတ်ပါ',
    confirmDeletePlan: 'ဤစီမံချက်ကိုဖျက်ရန်သေချာပါသလား',
    trimmingMethod: 'ဘေးဖြတ်နည်းလမ်း',
    followStandardTrim: 'မူရင်းချပ်ရှိ စံပေါ်ဒ်၏ ဘေးဖြတ်တန်ဖိုးကိုလိုက်ပါ',
    trimToast: 'သတိ: ပိုလျှံပစ္စည်းကိုယ်တိုင်ဘေးဖြတ်ချက်လုပ်ဆောင်မှုသုံးနေ၊ ဓားပုတ်မြောင်းပြင်ဆင်မှုသာရွေးနိုင်',
    individualTrimValue: 'ဘေးဖြတ်တန်ဖိုးသီးခြားသတ်မှတ်ပါ',
    topTrimEmptyToast: 'အပေါ်ဘေးဖြတ်မှုဗလာမဖြစ်ရ!',
    bottomTrimEmptyToast: 'အောက်ဘေးဖြတ်မှုဗလာမဖြစ်ရ!',
    leftTrimEmptyToast: 'ဘယ်ဘေးဖြတ်မှုဗလာမဖြစ်ရ!',
    rightTrimEmptyToast: 'ညာဘေးဖြတ်မှုဗလာမဖြစ်ရ!',
    topTrimBlurToast: 'အပေါ်ဘေးဖြတ်တန်ဖိုးထည့်ပါ',
    bottomTrimBlurToast: 'အောက်ဘေးဖြတ်တန်ဖိုးထည့်ပါ',
    leftTrimBlurToast: 'ဘယ်ဘေးဖြတ်တန်ဖိုးထည့်ပါ',
    rightTrimBlurToast: 'ညာဘေးဖြတ်တန်ဖိုးထည့်ပါ',
    effectToast: '၁.ကိုယ်တိုင်ဘေးဖြတ်လုပ်ဆောင်မှုသည် ဂေါ်ဒင်ပေါ်ဒ်ကိုသာ အကျိုးသက်ရောက်မည်',
    defaultTrimSetting: 'ပိုလျှံပစ္စည်းမူလဘေးဖြတ်သတ်မှတ်ချက်',
    enterHere: 'ဤနေရာတွင်ထည့်ပါ',
    permissionTipExportDxf: 'DXF အပေါက် slot ပုံစံထုတ်ယူပါ',
    permissionTipSurplusRecycleBin: 'ကြွင်းဆည်းပစ္စည်းပြန်လည်သုံးစွဲရေးစခန်း',
    permissionTipAdvancedNesting: 'အဆင့်မြင့်မညီသဏ္ဍာန်ထပ်တွက်ခြင်း',
    permissionTipPanelGrainAlign: 'ပေါ်ဒ်ဖွဲ့စည်းမှုတန်းညှပ်ခြင်း',
    permissionSeparator: ', ',
    missingPermissionTip: 'အောက်ပါခွင့်များမရှိပါ: {permissions}'
    },
  home: {
    head: {
      production: 'ကုန်ပစ္စည်းမိတ်ဆက်',
      resolve: 'ဖြေရှင်းချက်',
      about: 'ကျွန်ုပ်တို့အကြောင်း',
      equipment: 'စက်ကိရိယာ',
      tell: 'တိုင်ကြားဖုန်းနံပါတ်',
      enter: 'Cloud Layout ကိုဝင်ပါ'
      },
    swiper: {
      case1: {
        tag: 'အသစ်အဆင့်မြှင့်ဗားရှင်း',
        subTitle: 'စက်ကိရိယာ၏ ဉာဏ်ကြီးရှင်',
        description: 'လုပ်ငန်းကို ပြောင်းလဲနေသော Cloud အွန်လိုင်းပြင်ဆင်မှုဆော့ဖ်ဝဲ'
        },
      case2: {
        title: 'ဗီရိုထုတ်လုပ်မှု',
        subTitle: 'နည်းပညာဆန်းသစ်ထွင်မှု',
        description: 'တံဆိပ်ကပ်စက်၊ ဖြတ်တောက်စက်၊ ဘေးပေါက်ဖောက်စက်၊ ငါးမျက်နှာ PTP၊ ငါး/ခြောက်မျက်နှာဖောက်ပေါင်းစပ်မှုကိုပံ့ပိုး'
        },
      case3: {
        title: 'စက်မှုဦးနှောက်',
        subTitle: 'ဖြေရှင်းချက်',
        description: 'ဉာဏ်ပညာပြင်ဆင်မှုအယ်လဂိုရီသမ်ဖြင့် ပေါ်ဒ်အသုံးချမှုနှုန်းပိုမြင့်'
        }
      },
    statistics: {
      today: 'ယနေ့ပြင်ဆင်မှုအရေအတွက်',
      toMounth: 'ဤလ ပြင်ဆင်မှုအရေအတွက်',
      outturn: 'ပစ္စည်းထွက်နှုန်း',
      cumulative: 'စုစုပေါင်းအသုံးပြုသူ'
      },
    intro: {
      title: 'ကုမ္ပဏီအဆင့်빅ဒေတာ Cloud အွန်လိုင်းပြင်ဆင်မှုဆော့ဖ်ဝဲ',
      subTitle: 'လုပ်ငန်းလမ်းကြောင်းကိုနားလည်ပြီး ဖောက်သည်လိုအပ်ချက်ကိုဦးတည်ကာ ကုမ္ပဏီဒစ်ဂျစ်တယ်အပြောင်းအလဲကိုခွန်အားပေးကာ AI ကူညီသောအယ်လဂိုရီသမ်ဖြင့် ကုမ္ပဏီတိုးတက်မှုအသစ်ကိုဆက်လက်ပံ့ပိုး',
      menue: {
        case1: {
          title: 'အွန်လိုင်းပြင်ဆင်မှု',
          subTitle: 'မည်သည့်အချိန်မဆိုပြင်ဆင်နိုင်',
          description: 'ဆော့ဖ်ဝဲဒေါင်းလုဒ်မလိုဘဲ မည်သည့်အချိန်မဆိုပြင်ဆင်နိုင်၊ ကွန်ပျူတာပေါ်မမှီခို'
          },
        case2: {
          title: 'မျောမည်းထုတ်လုပ်မှု',
          subTitle: 'ထုတ်လုပ်မှုလိုင်းမြန်မြန်ပြောင်း',
          description: 'တပြိုင်နက်ထုတ်လုပ်မှုလိုင်းများကိုပံ့ပိုး၊ ထုတ်လုပ်မှုလိုင်းများကြားမြန်မြန်ပြောင်းနိုင်'
          },
        case3: {
          title: 'တိကျသောထုတ်လုပ်မှု',
          subTitle: 'တိကျသောပြင်ဆင်မှု၊ တိကျသောဘောင်သတ်မှတ်ချက်',
          description: 'တိကျသောပြင်ဆင်မှုနှင့် တိကျသောဘောင်သတ်မှတ်ချက်ဖြင့် ပေါ်ဒ်ထုတ်လုပ်မှုပိုတိကျ'
          },
        case4: {
          title: 'ကိုယ်ပိုင်ပုံစံထုတ်လုပ်မှု',
          subTitle: 'ကိုယ်ပိုင်တံဆိပ်၊ ငါး/ခြောက်မျက်နှာဖောက်၊ ပိုလျှံပစ္စည်းပုံသဏ္ဍာန်',
          description: 'ကိုယ်ပိုင်တံဆိပ်၊ ကိုယ်ပိုင်ငါး/ခြောက်မျက်နှာဖောက်၊ ကိုယ်ပိုင်ပိုလျှံပုံသဏ္ဍာန်၊ ပေါင်းစပ်ကိရိယာထုတ်လုပ်မှု'
          }
        }
      },
    fangan: {
      title: 'လုပ်ငန်းကျွမ်းကျင်သောဖြေရှင်းချက်',
      subTitle: 'ကုန်ကျစရိတ်နည်း၊ ထုတ်ကုန်တန်ဖိုးမြင့်၊ ဉာဏ်ပညာအယ်လဂိုရီသမ်ဖြင့် ပေါ်ဒ်အသုံးချမှုနှုန်းတိုးတက်ကာ ဒီဇိုင်းဆော့ဖ်ဝဲများနှင့်ကိုက်ညီ',
      menue: {
        case1: {
          title: 'အွန်လိုင်းအော်ဒါ-ထုတ်လုပ်မှုပေါင်းစပ်',
          description: 'ဝေးလဲသောအွန်လိုင်းလုပ်ဆောင်မှု၊ အချိန်မရွေးအော်ဒါကိုစက်ရုံသို့ပေးပို့နိုင်၊ ဒီဇိုင်းနှင့်ထုတ်လုပ်မှုတပြိုင်နက်ပြီးဆုံး'
          },
        case2: {
          title: 'တစ်ချက်နှိပ်ပြောင်းထုတ်လုပ်မှုလိုင်း',
          description: 'ကိုယ်ပိုင်ထုတ်လုပ်မှုလိုင်း၊ ထုတ်လုပ်မှုလိုင်းများနှင့် ကိရိယာအမျိုးအစားများပံ့ပိုး'
          },
        case3: {
          title: 'ဉာဏ်ပညာအယ်လဂိုရီသမ်ဖြင့် ပေါ်ဒ်အသုံးချမှုနှုန်းတိုး',
          description: 'ရိုးရာအယ်လဂိုရီသမ်ပေါ်ဒ်အသုံးချမှုနှုန်းနိမ့်၊ ဉာဏ်ပညာအယ်လဂိုရီသမ်တိကျသောဘောင်သတ်မှတ်ချက်ဖြင့် ကိုယ်ပိုင်ထုတ်လုပ်မှုစီမံချက်'
          },
        case4: {
          title: 'ကျွမ်းကျင်သောဖြတ်တောက်မှုစီမံချက်',
          description: 'ဖြတ်တောက်မှုအစဉ်နှင့် ဖြတ်တောက်မှုနေရာကိုကောင်းမွန်အောင်ပြုလုပ်ပြီး လမ်းကြောင်းပိုတိုကာ ဖြတ်တောက်မှုပိုတည်ငြိမ်'
          }
        }
      },
    aboutUs: {
      title1: 'Xingeer မানবဂေဟာနည်းပညာ',
      subTitle: 'မိုဘိုင်ထုတ်လုပ်မှုလုပ်ငန်းပြောင်းလဲမှုဦးဆောင်သူ',
      description: 'Xingeer ကုမ္ပဏီ၊ ရိုးရာမိုဘိုင်ထုတ်လုပ်မှုလုပ်ငန်း၏ ဆက်သွယ်ရေးအပြောင်းအလဲကိုဦးတည်',
      culture: {
        case1: {
          title: 'ကုမ္ပဏီမူရင်းရည်ရွယ်ချက်',
          subTitle: 'စက်ရုံကိုကူညီ၊ သုံးဆတိုးတက်'
          },
        case2: {
          title: 'ယဉ်ကျေးမှုတန်ဖိုးများ',
          subTitle: 'ဖောက်သည်ကိုဗဟိုပြု၊ ကြိုးစားသူကိုအခြေပြု၊ ကြိုးကြိုးစားစားလုပ်ဆောင်ကာ လူမှုဖူလုံရေးဆောင်ရွက်'
          },
        case3: {
          title: 'လမ်းညွှန်အတွေးအခေါ်',
          subTitle: 'ပြည်သူ့လမ်းကြောင်း၊ ရောင်းချမှုကြိုးကြိုးစားစား၊ ထုတ်ကုန်ကြိုးကြိုးစားစား၊ ဖွဲ့စည်းမှုကြိုးကြိုးစားစားဖြင့် ထူးချွန်ဆဲဆဲအဖွဲ့တည်ဆောက်'
          }
        },
      feature: {
        case1: 'ကျွမ်းကျင်သောအဖွဲ့ထိန်းသိမ်း',
        case2: 'ဆက်လက်အပ်ဒိတ်ပြောင်းလဲ',
        case3: 'တစ်ဆက်တစ်တည်းဝန်ဆောင်မှု',
        case4: 'လုပ်ဆောင်ချက်ကိုယ်ပိုင်ဝန်ဆောင်မှု'
        }
      },
    cooperation: {
      title: 'ပေါင်းစပ်ဆောင်ရွက်ပြီး အနာဂတ်ဖန်တီး',
      subTitle: 'ဆက်ချိတ်ကိရိယာဘရင်ဒ်သည် ပြည်တွင်းဆောင်ပြိုးကိရိယာ ၉၀% ကိုခြုံငုံ၊ ကုန်သည် ၁၀၇,၅၅၄ ဦးနှင့်အတူ'
      },
    footer: {
      contact: {
        title: 'ကျွန်ုပ်တို့ကိုဆက်သွယ်ပါ',
        adrres: 'လိပ်စာ - Jiangsu ပြည်နယ် Wuxi မြို့ Binhu ဒေသ Xiuxi အမှတ် ၅၀',
        subAdrres: 'K-park ဝန်ဆောင်မှုဌာန အဆောင် ၁ ၁၆ ထပ်',
        tell: 'ဖုန်းနံပါတ်'
        },
      business: {
        title: 'Xingeer အဓိကလုပ်ငန်း',
        department1: 'တံခါး-ဝင်းဒိုးဆော့ဖ်ဝဲဌာန',
        department2: 'မိုဘိုင်ဆော့ဖ်ဝဲဌာန',
        department3: 'ပြင်ဆင်တပ်ဆင်ဆောက်လုပ်ရေးဌာန',
        department4: 'Xingeer 本部官方ဝက်ဘ်ဆိုဒ်'
        },
      brand: {
        title: 'Xingeer ဘရင်ဒ်များ',
        brand1: 'Cai Shen Jin Fu',
        brand2: 'Mentu.com',
        brand3: 'Ding Xin ရင်းနှီးမြှုပ်နှံမှု',
        brand4: 'San Zhang Tu နည်းပညာ',
        brand5: 'Shanghai Fen Mo နည်းပညာ'
        },
      organization: {
        title: 'Xingeer ကမ္ဘာတစ်ဝှမ်းဌာနများ',
        organization1: 'Xingeer-দক္ষিণ ဘ​ပ​ (Foshan ဌာနခွဲ)',
        organization2: 'Xingeer-မြောက် ဘ​ပ​ (Linyi ဌာနခွဲ)',
        organization3: 'Xingeer-အနောက်တောင် ဘ​ပ​ (Chengdu ဌာနခွဲ)',
        organization4: 'Xingeer-ဗီရို အနောက်ဝန်ဆောင်မှုဌာန',
        organization5: 'Xingeer-ဗီရို အရှေ့ဝန်ဆောင်မှုဌာန',
        organization6: 'Xingeer-ကိုယ်စားလှယ်အုပ်စု',
        organization7: 'Xingeer-နိုင်ငံတကာဈေးကွက်ဌာန'
        },
      follow: {
        title: '"ဗီရိုကိုကြည့်ရှုရန်" စကင်ဖတ်ပါ'
        },
      friendLink: {
        link1: 'Xingeer ဆော့ဖ်ဝဲ',
        link2: 'K Show ဆိုင်ပြသည့်ဆော့ဖ်ဝဲ',
        link3: 'Mentu.com',
        link4: 'ဗီရိုအလုံးစုံ အလူမီနမ်ဆော့ဖ်ဝဲ',
        link5: 'ZOL ဆော့ဖ်ဝဲဒေါင်းလုဒ်',
        link6: 'Hua Jun ဆော့ဖ်ဝဲပတ်ဝန်းကျင်',
        link7: 'ဒေါင်းလုဒ်အိမ်',
        link8: 'ZOL ဆော့ဖ်ဝဲဒေါင်းလုဒ်',
        link9: 'အစိမ်းရောင်အရင်းအမြစ်ကွန်ယက်',
        link10: 'အဝတ်သေတ္တာပါဝင်',
        link11: 'အိမ်မိုဘိုင်ပါဝင်',
        link12: 'ရေချိုးခန်းပါဝင်'
        }
      }
    },
  login: {
    title: 'ဝင်ရောက်ပါ',
    tell: 'ဖုန်းနံပါတ်',
    password: 'စကားဝှက်',
    passwordPlaceholder: 'စကားဝှက်ထည့်ပါ',
    forget: 'စကားဝှက်မေ့ပျောက်',
    registerAccount: 'အကောင့်မှတ်ပုံတင်ပါ',
    backLog: 'ဝင်ရောက်မှုသို့ပြန်သွား',
    verifyCode: 'အတည်ပြုကုဒ်',
    getVerifyCode: 'အတည်ပြုကုဒ်ရယူပါ',
    verifyCodeErr: 'အတည်ပြုကုဒ်မှား',
    confimPassword: 'စကားဝှက်အတည်ပြုပါ',
    confimPasswordPlaceholder: 'စကားဝှက်အတည်ပြုပါ',
    editPassword: 'စကားဝှက်ပြောင်းပါ',
    register: 'မှတ်ပုံတင်ပါ',
    reSend: 'နောက်ပြန်ယူပါ',
    loginLoadText: 'ဝင်ရောက်နေပါသည်၊ ခဏစောင့်ပါ...',
    loadingPageTextL: 'ဝင်ရောက်မှုအောင်မြင်ပြီ၊ စာမျက်နှာဖွဲ့စည်းပုံတင်နေပါသည်...',
    loginSuccess: 'ဝင်ရောက်မှုအောင်မြင်သည်',
    tellErr: 'ဖုန်းနံပါတ်ဖော်မတ်မမှန်ကန်',
    passwordErr: 'စကားဝှက်ထည့်ပါ'
    },
  main: {
    head: {
      title: 'Bluen',
      subTitle: 'Save time, materials, and effort',
      task: 'တာဝန်ယူပါ',
      arrange: 'ပြင်ဆင်မှု',
      surplus: 'ပိုလျှံပစ္စည်း',
      setting: 'ဆက်တင်',
      find: 'ရှာဖွေတွေ့ရှိ',
      upgrade: 'ချက်ချင်းအဆင့်မြှင့်',
      editNickName: 'နာမည်ခေါ်ဝေါ်ပြင်',
      editPassword: 'စကားဝှက်ပြင်',
      logout: 'ထွက်သွားပါ',
      notice: 'ကြေငြာချက်',
      enterOfficial: 'တရားဝင်ဝက်ဘ်ဆိုဒ်သွား',
      equipment: 'စက်ကိရိယာ',
      help: 'ကူညီမှု',
      importFunc: 'သီးသန့်လုပ်ဆောင်ချက်ကြည့်ပါ',
      enterThinkerOfficial: 'Xingeer တရားဝင်ဝက်ဘ်ဆိုဒ်ဝင်ပါ',
      history: 'မှတ်တမ်းသိမ်းပါ',
      plankManager: 'မူရင်းပေါ်ဒ်စီမံ',
      tagManager: 'တံဆိပ်စီမံ',
      suplumentManager: 'ဖြည့်ဆည်းပြင်ဆင်မှုဘောင်',
      fileManager: 'ဖိုင်စီမံ',
      productionLine: 'ကိရိယာချိတ်ဆက်',
      workeShop: 'Cloud ထုတ်လုပ်မှု',
      useLesson: 'အသုံးပြုနည်းသင်ခန်းစာ',
      videoLesson: 'ဗီဒီယိုသင်ခန်းစာ',
      prolineManager: 'ထုတ်လုပ်မှုလိုင်းစီမံ',
      materialManager: 'ပေါ်ဒ်စီမံ',
      productManual: 'ကုန်ပစ္စည်းလမ်းညွှန်',
      medialRelated: 'တဆင့်ထုတ်ပြည်'
      },
    sideBar: {
      title: 'ထုတ်လုပ်မှုကောင်းမွန်အောင်',
      materialList: 'ဖြတ်တောက်စာရင်း',
      paibanTask: 'ပြင်ဆင်မှုစီမံချက်',
      paibanResult: 'ပြင်ဆင်မှုစီမံချက်',
      printTag: 'တံဆိပ်ပုံနှိပ်ပါ',
      history: 'မှတ်တမ်းသိမ်းပါ',
      limitDate: 'Limited Free',
      surplusManager: 'ပိုလျှံပစ္စည်းစီမံ',
      translateManager: 'ဘာသာပြန်စီမံ',
      moreSettings: 'နောက်ထပ်ဆက်တင်',
      deepSeekTitle: 'အကြံပေးပုဂ္ဂိုလ်',
      paibanCommune: 'ပြင်ဆင်မှုဆွေးနွေးအဖွဲ့'
      },
    allRead: 'အားလုံးဖတ်ပြီး',
    learnMore: 'အသေးစိတ်ကြည့်ပါ',
    noticeEmpty: 'ကြေငြာချက်မရှိသေး....',
    noticeErr: 'ကြေငြာချက်အသေးစိတ်ရယူမှုအမှား',
    feedBack: {
      tab1: 'တုံ့ပြန်ချက်တင်ပြပါ',
      tab2: 'တုံ့ပြန်ချက်မှတ်တမ်း',
      type: 'အကြံပြုချက်အမျိုးအစား',
      typePlaceholder: 'လုပ်ဆောင်ချက်ရွေးပါ',
      description: 'ဖော်ပြချက်',
      descriptionPlaceholder: 'ကျွန်ုပ်တို့ကိုပိုမိုကောင်းမွန်စွာကူညီနိုင်ရန် အနည်းဆုံးစကားလုံး ၁၅ လုံးပါသောအသုံးပြုနည်းဖော်ပြချက်ဖြည့်ပါ',
      uploadPic: 'ပုံထည့်ပါ၊ အများဆုံး ၆ ပုံ၊ တပုံအရွယ်အစား ၁၀M မကျော်',
      tell: 'ဆက်သွယ်ရေးဖုန်းနံပါတ်',
      submit: 'တင်ပြပါ',
      admin: 'Cloud Layout စီမံခန့်ခွဲသူ:',
      picTip: 'ပုံ: (ပုံအသေးစိတ်ကြည့်ရန်နှိပ်ပါ)',
      empty: 'တုံ့ပြန်ချက်ဒေတာမရှိသေး',
      picErr: 'တပုံအရွယ်အစား ၁၀M မကျော်ရ',
      contentErr: 'စာလုံးအရေအတွက် ၁၅ မှ ၃၀၀ ကြား',
      necessary: 'ဤရွေးချယ်မှုမဖြစ်မနေဖြည့်ရမည်'
      }
    },
  taskPage: {
    tab1: 'ထုတ်လုပ်မှုတာဝန်',
    tab2: 'အစုလိုက်ထုတ်လုပ်မှုတန်းစီ',
    filter: {
      title: 'စစ်ထုတ်ပါ',
      unArrange: 'မပြင်ဆင်ရသေး',
      arranged: 'ပြင်ဆင်ပြီး',
      allArranged: 'အားလုံးပြင်ဆင်ပြီး',
      preLayout: 'ကြိုတင်ပြင်ဆင်မှု'
      },
    search: {
      placeholder: 'ရှာဖွေမည့်အကြောင်းအရာထည့်ပါ',
      orderName: 'အော်ဒါအမည်',
      sender: 'ပေးပို့သူ'
      },
    importTask: 'တာဝန်တင်သွင်းပါ',
    refuseTask: 'တာဝန်ငြင်းဆိုပါ',
    refreshList: 'စာရင်းပြောင်းသစ်ပါ',
    refuseRecord: 'ငြင်းဆိုမှုမှတ်တမ်း',
    taskCard: {
      sender: 'တင်သွင်းထားသောပစ္စည်းစာရင်း',
      delivery: 'ပို့ဆောင်ရမည့်ရက်',
      delete: 'ဖျက်ပါ',
      addToBatch: 'အစုလိုက်ထည့်ပါ',
      save: 'သိမ်းဆည်းပါ',
      arrange: 'တိုက်ရိုက်ပြင်ဆင်ပါ',
      deleteTitle: 'တာဝန်ဖျက်ပါ',
      checkDetail: 'အသေးစိတ်ကြည့်ရန်နှိပ်ပါ',
      refuse: 'ငြင်းဆိုပါ',
      refuseTime: 'ငြင်းဆိုသည့်အချိန်',
      refuseReason: 'ငြင်းဆိုသည့်အကြောင်း',
      refuseTask: 'တာဝန်ငြင်းဆိုပါ',
      refuseTaskPlaceholder: 'ငြင်းဆိုသည့်အကြောင်းထည့်ပါ',
      addErr: 'ထည့်သွင်းမှုမအောင်မြင်ပါ၊ နောက်မှပြန်ကြိုးစားပါ!'
      },
    batchNo: ' အစုနံပါတ်',
    batchArrange: 'အစုလိုက်ပြင်ဆင်မှု',
    clearBatch: 'တန်းစီဆေးကြောပါ',
    taskCount: 'လက်ရှိတာဝန်အရေအတွက်:',
    checkAllTask: 'ပစ္စည်းစာရင်းအားလုံးကြည့်ပါ',
    clearSuccess: 'ဆေးကြောမှုအောင်မြင်သည်',
    record: {
      batchNo: 'အစုနံပါတ်',
      saveDate: 'သိမ်းဆည်းသည့်အချိန်',
      materialList: 'ပစ္စည်းစာရင်း',
      arrangedRecord: 'ပြင်ဆင်မှုစီမံချက်',
      searchPlaceholder: 'အစုနံပါတ်ထည့်ပါ',
      tipText: 'ဤသိမ်းဆည်းမှုကိုဖျက်မည်လား?'
      },
    errTip: 'လုပ်ဆောင်နိုင်သောတာဝန်ဒေတာမရှိ၊ တာဝန်စာရင်းသွားထည့်ပါ!',
    emptyErr: 'ဤတာဝန်အော်ဒါတွင်ပေါ်ဒ်ဒေတာမရှိ၊ ပြင်ဆင်မှုထုတ်လုပ်မှုမလုပ်နိုင်!',
    operationSuccess: 'လုပ်ဆောင်မှုအောင်မြင်သည်',
    operationFail: 'လုပ်ဆောင်မှုမအောင်မြင်ပါ၊ နောက်မှပြန်ကြိုးစားပါ!',
    saveSuccess: 'သိမ်းဆည်းမှုအောင်မြင်သည်',
    plankMaxLimit: 'ပေါ်ဒ်ငယ်အရေအတွက် အများဆုံးပြင်ဆင်မှုကန့်သတ်ချက်ကျော်လွန်သည်',
    batchWorning: 'ကျေးဇူးပြု၍ အစုအဖွဲ့ဖြင့်ထုတ်လုပ်ပါ',
    batchEmptyErr: 'အော်ဒါစာရင်းတွင်ပေါ်ဒ်ဒေတာမရှိ၊ အစုလိုက်ထုတ်လုပ်မှုမလုပ်နိုင်!',
    noRoomTip: 'အခန်းမရှိ၊ အစုလိုက်ထုတ်လုပ်မှုမလုပ်နိုင်!',
    refuseHistory: 'ငြင်းဆိုမှုမှတ်တမ်း'
    },
  materialPage: {
    specialProcess: 'အထူးလုပ်ငန်းစဉ်',
    distanceFromTop: 'အပေါ်မှ အကွာ',
    distanceFromRight: 'ညာမှ အကွာ',
    hingeData: 'ဟင်းချဉ်ဒေတာ',
    labelBackProcTip: 'ဤနောက်ဆုံးအပ်ဒိတ်တွင် ပေါ်ဒ်ကြီးအကျောတံဆိပ်ကပ်နည်းကိုကောင်းမွန်အောင်ပြုလုပ်ထားသည်',
    openDir: 'တံခါးဖွင့်ဘက်',
    edgeEmptyTip: 'ဘေးဖြတ်တန်ဖိုးဗလာမဖြစ်ရ',
    edgeNumberLimit: 'ဘေးဖြတ်တန်ဖိုးတွင် ကိန်းဂဏန်းသာ ထည့်နိုင်သည်',
    chooseSurplusQuantity: 'အသုံးပြုနိုင်သောပိုလျှံပစ္စည်း {total} မျိုး ရှိသည်၊ {quantity} မျိုးရွေးချယ်ပြီး',
    noCanSaveInfo: 'သိမ်းဆည်းနိုင်သောသတင်းမရှိ',
    chooseBujianStoreQuantity: 'ဖြည့်ဆည်းပစ္စည်း {total} ချပ်ရှိသည်၊ ဖြည့်ဆည်းပေါ်ဒ်ငယ် {quantity} ချပ်ပါနိုင်သည်၊ {chooseQuantity} ချပ်ရွေးပြီး',
    isConfirmPushToAwaitStore: 'ရွေးချယ်ထားသောပေါ်ဒ်ကို ပြင်ဆင်ရန်ဘောင်သို့ ထည့်ရန်သေချာပါသလား?',
    enterAutoCreateMatCode: 'Enter နှိပ်ပါက ပစ္စည်းကိုအလိုအလျောက်ဖန်တီးမည်',
    chooseAwaitStoreQuantity: 'ပြင်ဆင်ရန်ဘောင်တွင် ပေါ်ဒ်ငယ် {total} ချပ်ရှိသည်၊ ပြင်ဆင်မှုထည့်နိုင်သော ပေါ်ဒ် {quantity} ချပ်ရှိသည်၊ {chooseQuantity} ချပ်ရွေးပြီး',
    defaultFold: 'ပေါ်ဒ်ဒေတာ မူရင်းကြောင်းလိပ်',
    startArrange: 'ပြင်ဆင်မှုစတင်ပါ',
    importMaterial: 'ဖြတ်တောက်စာရင်းတင်သွင်းပါ',
    saveToHistory: 'မှတ်တမ်းသို့သိမ်းပါ',
    addPlank: 'ပေါ်ဒ်ထည့်ပါ',
    addBujian: 'ဖြည့်ဆည်းပစ္စည်းထည့်ပါ',
    deletePlank: 'ပေါ်ဒ်ဖျက်ပါ',
    batchEdit: 'အစုလိုက်ပြင်ဆင်ပါ',
    moreSetting: 'နောက်ထပ်ဆက်တင်',
    plankSize: 'ပေါ်ဒ်အရွယ်အစား',
    plankSize2: 'အရွယ်အစား (အရှည် * အကျယ် * အထူ)',
    searchPlaceholder: 'ပေါ်ဒ်အမည်/ပေါ်ဒ်နံပါတ်ရှာပါ',
    checkArranged: 'ပြင်ဆင်မှုကြည့်ပါ',
    checkErr: 'ပြင်ဆင်မှုမလုပ်ရသေး၊ မကြည့်နိုင်!',
    downloadSheet: 'နမူနာဇယားဒေါင်းလုဒ်',
    downloadSheetShowScientific: 'နမူနာဇယားဒေါင်းလုဒ် (သိပ္ပံကိန်းဂဏန်းနည်းပြ)',
    exportHoleSlotPDF: 'ပေါ်ဒ်ပေါက်ကြိုးပုံထုတ်ပါ',
    style1: 'ပုံစံ ၁',
    style2: 'ပုံစံ ၂',
    style2PDF: 'ပုံစံ ၂ (PDF)',
    style2DXF: 'ပုံစံ ၂ (DXF)',
    style3: 'ပုံစံ ၃',
    importNoCover: 'ပစ္စည်းစာရင်းတင်သွင်းချိန်မဖုံးကွယ်',
    openBujianPlankRecommend: 'ဖြည့်ဆည်းပေါ်ဒ်ငယ်အကြံပြုချက်ဖွင့်ပါ',
    openAwaitStorePlankRecommend: 'ပြင်ဆင်ရန်ဘောင်ပေါ်ဒ်ငယ်အကြံပြုချက်ဖွင့်ပါ',
    openSurplusPlankRecommend: 'ပိုလျှံပစ္စည်းပေါ်ဒ်ကြီးအကြံပြုချက်ဖွင့်ပါ',
    pushToAwaitStore: 'ပြင်ဆင်ရန်ဘောင်တွင်သိမ်းပါ',
    setTableHead: 'ဖြတ်တောက်စာရင်းဇယားခေါင်းစဉ်သတ်မှတ်ပါ',
    syncConfirm: 'ဗီရိုနှင့် Cloud Layout ပေါ်ဒ်ဒေတာမကိုက်ညီ! ဗီရိုပေါ်ဒ်ဒေတာနှင့်ကိုက်ညှိမည်လား?',
    handleSync: 'မှတ်ချက် - မူရင်းပေါ်ဒ်စီမံတွင် ကိုယ်တိုင်ကိုက်ညှိနိုင်သည်',
    noMoreTip: 'နောက်ထပ်မဆိုင်',
    checkMore: 'နောက်ထပ်ကြည့်ပါ',
    noHistory: 'သိမ်းဆည်းထားသောမှတ်တမ်းမရှိသေး...',
    sameOrder: 'ထုတ်လုပ်မှုဖိုင်ထုတ်ပြီးသောအော်ဒါရှိသည်၊ ထပ်ဆင့်ထုတ်လုပ်မှုပြဿနာကိုသတိပြုပါ!',
    markOrder: 'အော်ဒါစာမျက်နှာတွင် ထုတ်လုပ်ပြီးကိုမှတ်မည်လား?',
    editErrTip: 'အော်ဒါများတွင် သတင်းပြင်ဆင်ချိန်ကာလမပံ့ပိုး',
    autoSaveSuccess: 'မှတ်တမ်းသို့အလိုအလျောက်သိမ်းဆည်းပြီ!',
    goAdd: 'ထည့်ရာသွားပါ',
    noProductionLine: 'ဤမှတ်တမ်း၏ ထုတ်လုပ်မှုလိုင်းကိုဖျက်ထားသည်၊ ဖြတ်တောက်စာရင်းသွား ပြန်ပြင်ဆင်ပါ',
    fileErr: 'ဖိုင်အကြောင်းအရာပိုင်းခွဲမှုမအောင်မြင်ပါ၊ ဖိုင်အကြောင်းအရာကိုအတည်ပြုပါ!',
    noCheckData: 'ဒေတာမတွေ့ပါ!',
    noArrangeTip: 'ပြင်ဆင်မှုစီမံချက်ကိုတိုက်ရိုက်မကြည့်နိုင်ပါ၊ ပြင်ဆင်မှုစတင်ပါကိုနှိပ်ပါ!',
    tooOld: 'ငါး/ခြောက်မျက်နှာဖောက်ဆက်တင်ဟောင်းနွမ်းနေသည်',
    contactUs: 'ကျေးဇူးပြု၍ ဝန်ဆောင်မှုဝန်ထမ်းနှင့်ဆက်သွယ်ပြန်ချိတ်ဆက်ပါ',
    pathErr: 'ပေါ်ဒ်တွင်းတွင် မမှန်ကန်သောဒေတာရှိသည် (ပေါ်ဒ်နံပါတ်: {errorPathPlankID})၊ စစ်ဆေးပါ!',
    sizeErr: 'ကြီးလွန်းသောပေါ်ဒ်ရှိသည်! ပေါ်ဒ်ငယ်အရွယ်အစား: {width}-{height}',
    noKnife: 'ဖြတ်ဓားဖြင်တ်မသတ်မှတ်ရသေး၊ ကြွပ်ကော်စက်သွားဓားသတ်မှတ်ပါ!',
    noKnifeDiameter: 'ဤထုတ်လုပ်မှုလိုင်း ဖြတ်ဓား ({name}) ဖြင်တ်ဗလာဖြစ်နေသည်၊ သင့်လျော်သောဓားဖြင်တ်ထည့်ရာသွားပါ',
    openDifferentMaterialCuttingKnives: 'ကွဲပြားသောပစ္စည်း ဖြတ်ဓားဖွင့်ထားပြီ',
    sendFactorySuccess: 'ဝပ်ရှော့သို့ပေးပို့မှုအောင်မြင်သည်',
    sendFactoryErr: 'ဝပ်ရှော့ပေးပို့မှုမအောင်မြင်ပါ၊ ဝန်ဆောင်မှုဝန်ထမ်းနှင့်ဆက်သွယ်ကူညီတောင်းပါ',
    createTaskCard: 'သင့်ဆောင်တာဝန်ကတ်ဖန်တီးမည်လား?',
    surplusStatistics: 'အသုံးပြုနိုင်သောပိုလျှံပစ္စည်းစုစုပေါင်း',
    surplusStatistics2: 'ရွေးချယ်ပြီး',
    suplementStatistic: 'ချပ်ဖြည့်ဆည်းပစ္စည်း၊ ဖြည့်ဆည်းပေါ်ဒ်ငယ်ပါနိုင်သောအားလုံး',
    expand: 'ဖြန့်ပြပါ',
    packUp: 'ခေါင်းလောင်းပါ',
    importErr: 'မှန်ကန်သောဖိုင်ရွေးပါ!',
    sendLoadingText: 'NC ဖိုင်ကိုလုပ်ဆောင်ပြီးပေးပို့နေသည်......',
    arrangeLoading: 'စုစုပေါင်း',
    arrangeLoading2: 'ချပ်ပေါ်ဒ်ငယ် ပြင်ဆင်မှုကောင်းမွန်အောင်ပြုလုပ်နေသည်......',
    dealing: 'လုပ်ဆောင်နေသည်...',
    deleteConfirm: 'ဖျက်လိုက်ပါက ပိုလျှံပစ္စည်းသည် အမှိုက်ပုံးသို့ ရွှေ့ပေးပါမည်။ ဤပိုလျှံပစ္စည်းကိုဖျက်ရန်သေချာပါသလား။',
    copyTip: 'ရွေးချယ်ထားသောပိုလျှံပစ္စည်းကိုကူးယူမည်',
    copyTip2: 'ကူးယူမည့်အရေအတွက်ကိုအတည်ပြုပါ',
    surplusHead: {
      shape: 'ပုံသဏ္ဍာန်',
      type: 'အမျိုးအစား',
      remark: 'မှတ်ချက်',
      area: 'ဧရိယာ(m²)',
      area1: 'ဧရိယာ'
      },
    surplusTip: 'အသုံးပြုနိုင်သောပိုလျှံပစ္စည်းမရှိသေး၊ ကြိုတင်သွားနိုင်သည်',
    creatSurplus: 'ပိုလျှံပစ္စည်းအသစ်ဖန်တီးပါ',
    orderInfo: 'အော်ဒါသတင်း',
    suplement: {
      statistic: 'ဖြည့်ဆည်းပစ္စည်း {total} ချပ်၊ ဖြည့်ဆည်းပေါ်ဒ် {useable} ချပ်ပါနိုင်သည်၊ {selected} ချပ်ရွေးပြီး',
      exportSuplement: 'ဖြည့်ဆည်းစာရင်းထုတ်ပါ',
      suplementLoading: 'ဖြည့်ဆည်းဒေတာတင်နေသည်',
      exportSuplementIng: 'ဖြည့်ဆည်းစာရင်းထုတ်နေသည်',
      noMatchSup: 'အသုံးပြုနိုင်သောဖြည့်ဆည်းဒေတာမတွေ့ပါ',
      exportTip: 'ဖြည့်ဆည်းပစ္စည်းအနည်းဆုံးတစ်ခုရွေးပြီးထုတ်ပါ'
      },
    empty: 'ပေါ်ဒ်ဒေတာမရှိသေး',
    paibanSetting: {
      title: 'ပြင်ဆင်မှုဆက်တင်',
      createTask: 'ပြင်ဆင်မှုဆက်တင်အလိုအလျောက်ဖြတ်',
      selectProduction: 'ထုတ်လုပ်မှုလိုင်းရွေးချယ်ပါ',
      arrangeWay: 'ပြင်ဆင်မှုစီမံချက်ရွေးချယ်ပါ',
      suitText: 'သင့်တော်သည်：',
      surplusTrimTip: 'သတိ: ပိုလျှံပစ္စည်းကိုယ်တိုင်ဘေးဖြတ်လုပ်ဆောင်မှုသုံးနေ၊ ဓားပုတ်မြောင်းပြင်ဆင်မှုသာရွေးနိုင်',
      suitEquipmentNormal: 'ပုံမှန်ကြွပ်ကော်စက်',
      suitEquipmentSpecial: 'မှန်ဖြတ်စက်၊ ဓားရွက်ဖြတ်စက်',
      lessRoll: 'ပြောင်းဘက်နည်းနည်း',
      computedSpecial: 'အထူးပုံတွက်ချက်ပါ',
      specialTip: 'ပြင်ဆင်မှုအမြန်နှုန်းကိုသက်ရောက်',
      irregularNesting: 'အထူးပုံပေါင်းစပ်',
      primaryNesting: 'ပုံမှန်ပေါင်းစပ်',
      specialShapedPanel: 'အထူးပုံပုံမှန်ပေါ်ဒ်ပေါင်းစပ်',
      limitedTimeTrial: 'Limited Free',
      seniorShape: 'မြင့်မားသောပေါင်းစပ်',
      heteromorphicInlay: 'အထူးပုံအထူးပုံပေါင်းစပ်',
      autoCutSurplus: 'ပိုလျှံပစ္စည်းအလိုအလျောက်ဖြတ်',
      cutWay: 'ဖြတ်တောက်နည်း',
      maxRect: 'အများဆုံးတစ်ထောင့်မှန်ဖြတ်',
      fixedRect: 'သတ်မှတ်အရွယ်ဖြတ်',
      minRectSetting: 'အနည်းဆုံးဖြတ်အရွယ်',
      firstCutL: 'ဖြတ်တောက်မှုL ပုံပိုလျှံပစ္စည်းဦးစားပေးဖန်တီး',
      firstCutLTip: 'ဖွင့်ပြီးနောက် သင့်ဆောင်ထောင့်မှန်ပေါ်ဒ်ကို L ပုံပိုလျှံပစ္စည်းဖြစ်အောင်ဦးစားပေးဖြတ်မည်',
      shortLine: 'တိုဘောင်ထက်ကြီး',
      longLine: 'ရှည်ဘောင်ထက်ကြီး',
      setDifferentThickness: 'ကွဲပြားသောအထူပေါ်ဒ်အနည်းဆုံးဖြတ်အရွယ်သတ်မှတ်ပါ',
      defaultRuleTip: 'ပေါ်ဒ်အထူပြည်မီသောစည်းမျဉ်းမရှိသောအခါ မူရင်းစည်းမျဉ်းနှင့်ဖြတ်ပါ',
      panelThickness: 'ပေါ်ဒ်ကြီးအထူ',
      duplicateMinCutSize: 'လက်ရှိအထူတွင် တူညီသောအနည်းဆုံးဖြတ်အရွယ်ရှိပြီး',
      templateEmpty: '"ကွဲပြားသောအထူပေါ်ဒ်အနည်းဆုံးဖြတ်အရွယ်သတ်မှတ်" ပုံစံဒေတာဗလာမဖြစ်ရ!',
      duplicateThicknessData: '"ကွဲပြားသောအထူပေါ်ဒ်အနည်းဆုံးဖြတ်အရွယ်သတ်မှတ်" ပုံစံဒေတာတွင် ထပ်နေသောအထူဒေတာရှိသည်!',
      atLeastOne: 'အနည်းဆုံးတစ်ခုသိမ်းထားပါ!',
      maxAddFive: 'အများဆုံးငါးခုထည့်နိုင်သည်!',
      surplusTemplate: 'ပိုလျှံပစ္စည်းအသုံးများသောပုံစံ',
      add: 'ထည့်ပါ',
      templateErr: 'ပုံမှန်အရွယ်ဖြတ်ရွေးချယ်ချိန် ဒေတာပုံစံတစ်ခုရွေးထားရမည်',
      cutLong: 'ဖြတ်အရှည်',
      cutWidth: 'ဖြတ်အကျယ်',
      baseInfo: 'အခြေခံသတင်းအချက်အလက်',
      continue: 'အတည်ပြုပြီးဆက်လုပ်',
      standardSelect: 'စံပေါ်ဒ်ကြီးရွေးချယ်',
      customPlankOrder: 'ပေါ်ဒ်ကြီးပြင်ဆင်မှုအစဉ်ကိုယ်ပိုင်သတ်မှတ်',
      customPlankOrderDetail: 'မပြင်ဆင်ရသေးသောပေါ်ဒ်ငယ်စာရင်း',
      customPlankOrderTip: 'ထည့်သွင်းထားသောCloud Layout ဤလုပ်ဆောင်ချက်ကိုမကျင့်သုံးနိုင်',
      customPlankOrderBrandTip: 'ပြင်ဆင်ရန်စောင့်ဆိုင်းနေသောအော်ဒါတွင်အမှတ်တံဆိပ်အရောင်ကတ်ပြားများရှိ၍ဤလုပ်ဆောင်ချက်ကိုပုံသေအသုံးပြုသည်',
      surplusPlank: 'ကျန်ပေါ်ဒ်ငယ်စာရင်း',
      overSizePlank: 'အကြီးလွန်ပေါ်ဒ်ငယ်စာရင်း',
      plankOrder: 'ပြင်ဆင်မှုအစဉ်',
      plankType: 'ပေါ်ဒ်အမျိုးအစား',
      plankSize: 'ပေါ်ဒ်အရွယ်အစား',
      plankEdgeOff: 'ဘေးဖြတ်တန်ဖိုး',
      amount: 'ဖြတ်တောက်အရေအတွက်',
      amountMax: 'ဖြတ်တောက်အရေအတွက်အများဆုံး',
      numAndOverSizeTip: 'ပေါ်ဒ်ငယ်ကြီးလွန်ပြီး ပေါ်ဒ်ကြီးပမာဏမလုံလောက်၍ မပြင်ဆင်နိုင်',
      numErrorTip: 'ပေါ်ဒ်ကြီးပမာဏမလုံလောက်၍ မပြင်ဆင်နိုင်',
      overSizeTip: 'ပေါ်ဒ်ငယ်ကြီးလွန်၍ မပြင်ဆင်နိုင်',
      restPartList: 'မပြင်ဆင်ရသေးသောပေါ်ဒ်ငယ်စာရင်း',
      layoutOrder: 'ပြင်ဆင်မှုအစဉ်',
      arrangeAmount: 'ဖြတ်တောက်အရေအတွက်',
      specialShapeTip: 'အထူးပုံပိုလျှံပစ္စည်းတွင် ဓားပုတ်မြောင်းပြင်ဆင်မှုမသုံးနိုင်',
      surplusConflictTip: 'ဖြတ်တောက်ပိုလျှံပစ္စည်းနှင့်ပေါ်ဒ်ကြမ်းတမ်းပဋိပက္ခ ဖြစ်သည်၊ ပြန်ဖြတ်ပါ',
      stackingMethod: {
        title: 'ပေါ်ဒ်ပိုင်းပြင်ဆင်ခြင်းမှာယူသည့်နည်းလမ်း',
        long: 'အကြီးဆုံးကြောင်းမှာယူသည့်နည်းလမ်း',
        short: 'အနီးဆုံးကြောင်းမှာယူသည့်နည်းလမ်း'
        },
      seniorShapeTip: '【Advanced Nesting】အခမဲ့စမ်းသပ်မှုသက်တမ်းကုန်သွားပါပြီ၊ လက်ရှိတွင် advanced nesting layout ရလဒ်ကို ကြိုတင်ကြည့်ရှုနိုင်ပါသည် (သာမန် nesting သို့ ပြောင်းလဲ၍ ပုံမှန်ထုတ်လုပ်မှုလုပ်ဆောင်နိုင်ပါသည်)။ advanced nesting ထုတ်လုပ်မှုဖိုင်ထုတ်ယူဖို့ လိုပါက အရောင်းဝန်ထမ်းကို ဆက်သွယ်ဝယ်ယူပါ~'
      },
    filter: {
      title: 'ပေါ်ဒ်စစ်ထုတ်',
      search: 'ရှာပါ',
      all: 'အားလုံးရွေး',
      diskSize: 'ပေါ်ဒ်စစ်ထုတ်မှုပယ်ဖျက်',
      resetFilter: 'စစ်ထုတ်မှုပယ်ဖျက်'
      },
    edit: {
      title: 'အစုလိုက်ပြင်ဆင်',
      target: 'ပြင်ဆင်မည့်အရာ',
      onlineSelectRow: 'ရွေးချယ်ထားသောကြောင်းသာ',
      allRow: 'ကြောင်းအားလုံး',
      editKey: 'ပြင်ဆင်မည့်အကြောင်းအရာ',
      editValue: 'ပြင်ဆင်ရန်',
      warningTip: 'သတိ: ပြင်ဆင်ပြီးနောက် ပေါက်ကြိုးနှင့်အထူးပုံကိုအလိုအလျောက်ဖယ်ရှားမည်',
      allEdge: 'ဘောင်အားလုံးပိတ်ဆို့'
      },
    add: {
      title: 'ပေါ်ဒ်ထည့်ပါ',
      continue: 'အတည်ပြုပြီးဆက်လုပ်',
      matCodeErr: 'ပစ္စည်းဗလာမဖြစ်ရ',
      thickErr: 'အထူဗလာမဖြစ်ရ',
      colorErr: 'အရောင်ဗလာမဖြစ်ရ',
      longErr: 'ပြီးစီးသောကုန်ပစ္စည်းအရှည်ဗလာမဖြစ်ရ',
      widthErr: 'ပြီးစီးသောကုန်ပစ္စည်းအကျယ်ဗလာမဖြစ်ရ',
      countErr: 'အရေအတွက်အနည်းဆုံး ၁ ဖြစ်ရမည်'
      },
    delete: {
      tip: 'ဤဒေတာဖျက်ပြီးမပြန်ရနိုင်ပါ၊ ဖျက်ရန်အတည်ပြုမည်လား?',
      errTip: 'ဤလုပ်ဆောင်မှုမပြုမီ ပေါ်ဒ်အနည်းဆုံးတစ်ခုရွေးပါ!',
      errTip1: 'ပြင်ဆင်မှုမပြုမီ ပေါ်ဒ်အနည်းဆုံးတစ်ခုရွေးပါ',
      confirm: 'ဖျက်ဆီးမှုအတည်ပြု'
      },
    restore: {
      confirm: 'ပြန်လည်ထားရှိမှုအတည်ပြု'
      },
    restoreConfirm: 'ပြန်လည်ထားရှိပြီးနောက် ပိုလျှံပစ္စည်းသည် ပိုလျှံပစ္စည်းစာရင်း သို့မဟုတ် သိုလှောင်ရုံသို့ ပြန်ရွှေ့ပါမည်။ ဤပစ္စည်းကို ပြန်လည်ထားရှိရန် သေချာပါသလား။',
    restoreBatchConfirm: 'ရွေးချယ်ထားသော ပိုလျှံပစ္စည်းများကို ပြန်လည်ထားရှိရန် သေချာပါသလား။',
    save: {
      errTip: 'သိမ်းဆည်းနိုင်သောသတင်းမရှိ!',
      title: 'စီမံချက်သိမ်းပါ',
      subTitle: '(မှတ်ချက်: မှတ်တမ်းတစ်နှစ်သာသိမ်းသည်)',
      name: 'စီမံချက်အမည်',
      historyName: 'ဂတိသမ်စီမံချက်',
      successTip: 'သိမ်းဆည်းမှုအောင်မြင်သည်!',
      fieldTip: 'သိမ်းဆည်းမှုမအောင်မြင်ပါ!'
      },
    exportErr: 'ပေါ်ဒ်မရှိ၊ ထုတ်မနိုင်',
    exportPicErr: 'ပေါ်ဒ်ပေါက်ကြိုးပုံထုတ်ချိန်အမည်မသိအမှားကြုံပါသည်၊ ကျွန်ုပ်တို့ကိုဆက်သွယ်ပါ',
    plankNotFound: 'သက်ဆိုင်ရာပေါ်ဒ်မတွေ့ပါ! ပေါ်ဒ်ဆွဲပြီးမပြီးအတည်ပြုပါ!',
    noPlankName: 'ပေါ်ဒ်အမည်မတွေ့ပါ',
    plankDataErr: 'ပေါ်ဒ်ဒေတာမှားနေသည်၊ ထုတ်လုပ်မှုဆုံးရှုံးမှုကိုရှောင်ရှားရန်သေချာစစ်ဆေးပါ',
    exportThreeViewErr: 'ပေါက်ကြိုးသုံးဘက်မြင်ကွင်းထုတ်မှုမအောင်မြင်ပါ၊ အရောင်းပြီးနောက်ဝန်ဆောင်မှုကိုဆက်သွယ်ပါ',
    heighGlossWarning: 'သတိ: ပစ္စည်းသည်မြင့်မားသောဝင်းပတ်ပေါ်ဒ်ဖြစ်သောအခါ ပစ္စည်းပြင်ဆင်ပြီးနောက်ပေါ်ဒ်ကိုမြင့်မားသောဝင်းပတ်ပေါ်ဒ်သို့ပြန်မရနိုင်ပါ!',
    reset: 'မူရင်းပြန်ထားပါ',
    settingHead: {
      title: 'ဖြတ်တောက်စာရင်းဇယားခေါင်းစဉ်သတ်မှတ်ပါ',
      head: 'ဇယားခေါင်းစဉ်',
      customHeadName: 'စိတ်ကြိုက်ဇယားခေါင်းစဉ်အမည်',
      example: 'နမူနာ',
      tip: 'လုပ်ဆောင်မှုအကြံပြု: ဇယားခေါင်းဒေတာဆိပ်ကမ်းကိုဘယ်ညာဆွဲဆောင်နိုင်သည်',
      headerNameEmpty: 'ခေါင်းစဉ်အလွတ်မဖြစ်ရပါ',
      duplicateHeader: 'ပြန်လည်ခေါင်းစဉ်ရှိသည်'
      },
    copyLine: 'ကလစ်နှိပ်ပြီးအောက်တွင်လက်ရှိကြောင်းကူးယူနိုင်သည်',
    copySuccess: '{name} ဒေတာကူးယူမှုအောင်မြင်သည်',
    arranging: 'စုစုပေါင်း {count} ချပ်ငယ်ပေါ်ဒ် ပြင်ဆင်မှုကောင်းမွန်အောင်ပြုလုပ်နေသည်......',
    overSize: {
      title: 'ပေါ်ဒ်ကြီးလွန်',
      subTitle: 'အကြီးလွန်ပေါ်ဒ်ငယ်စာရင်း',
      overSizeTip: 'ပေါ်ဒ်ကြီးလွန်သတိပေးချက်',
      nonWorkInfo: 'လုပ်မနိုင်သောပေါ်ဒ်အသေးစိတ်',
      mergeFrameDoorWholeTip: 'မှတ်ချက်: ဤအစိတ်အပိုင်းသည်အရိုးတံခါးတစ်ခုလုံးအတွက်ပေါင်းစပ်လုပ်ငန်းဖြစ်သည်',
      conflictWorkInfo: 'ပဋိပက္ခဖြစ်နေသောပေါ်ဒ်အသေးစိတ်',
      warning: 'ပေါ်ဒ်ငယ်အရွယ်ရှည်လွန်ကြောင်းစစ်ဆေးတွေ့ရှိ၍ မပြင်ဆင်နိုင်! ပေါ်ဒ်ငယ်အရွယ်ညှိပေးပါ သို့မဟုတ် သင့်တော်သောအရွယ်မူရင်းချပ်ထည့်ပါ',
      checkInfo: 'ပေါ်ဒ်အသေးစိတ်ကြည့်ပါ',
      tipContent: 'စနစ်သည်ပြင်ဆင်မှုပေါ်ဒ်ငယ်တွင်ကြီးလွန်သောပေါ်ဒ်ရှိကြောင်းစစ်ဆေးတွေ့ရှိ၍ အထူးပေါ်ဒ်ထည့်ရန်အကြံပြုချက်ပေးပါသည်',
      add: 'တစ်ကလစ်ထည့်',
      addPlank: 'မူရင်းချပ်ထည့်ပါ',
      error: 'ပေါ်ဒ်ကြီးလွန်၍ ပြင်ဆင်မှုမအောင်မြင်',
      successTip: 'ပေါ်ဒ်ထည့်မှုအောင်မြင်သည်! ပြန်ပြင်ဆင်နေသည်',
      warningTip: 'ပေါ်ဒ်အရှည်အကျယ်ဖြည့်ပါ!'
      },
    arrangeErr: 'ပေါ်ဒ်အတွင်းဒေတာပုံမမှန်ကြောင်းရှိ၍ ပြင်ဆင်မှုလုပ်ငန်းလုပ်မနိုင်',
    nonDelete: 'မဖျက်နိုင်',
    addOverSizeTip: 'ကြီးလွန်မှုရှိသည်၊ ထပ်မံထည့်ပါ',
    addPlankSuccess: 'အထူးပေါ်ဒ်ကြီးထည့်မှုအောင်မြင်သည်',
    addPlankFail: 'အထူးပေါ်ဒ်ကြီးထည့်မှုမအောင်မြင်ပါ',
    paibanFeedback: 'ပြင်ဆင်မှုတုံ့ပြန်ချက်',
    cuttingAndPaoban: 'ဖြတ်တောက်ပြင်ဆင်မှု',
    lowUtilizationRate: 'အသုံးချမှုနှုန်းနိမ့်',
    unreasonableLayout: 'ပြင်ဆင်မှုမသင့်တော်',
    feedbackSuccessTip: 'တုံ့ပြန်ချက်အောင်မြင်သည်!',
    feedbackFailTip: 'တုံ့ပြန်ချက်မအောင်မြင်ပါ!',
    mixedLayoutScheme: 'ဤကြိမ်ရောနှောပြင်ဆင်မှုစီမံချက်'
    },
  arrangedPage: {
    subtleDownloadCheckTip: 'ပေါ်ဒ်ဒေတာပြောင်းလဲသွားသော်လည်း စီမံချက်မသိမ်းရသေး၊ စီမံချက်သိမ်းရန်အတည်ပြုပြီးဆက်လုပ်ပါ',
    paibanRequestFailed: 'အပြင်အဆင် တောင်းဆိုမှု မအောင်မြင်ပါ၊ ထပ်မံကြိုးစားပါ',
    accordingPlankCountOrder: 'ပေါ်ဒ်ကြီးအရေအတွက်ကိုမြင့်မှနိမ့်သို့စီရင်',
    editOrder: 'အစဉ်နံပါတ်တည်းဖြတ်',
    dragOrder: 'ဆွဲဆောင်စီရင်',
    inputOrder: 'အစဉ်ထည့်သွင်း',
    editOrderTip: 'အစဉ်ညှိ',
    range: 'နယ်ပယ်',
    unsupportRotateTip: 'ပေါ်ဒ်ကြီးအချို့လှည့်ထားပြီး ပြန်ပြင်ဆင်မှုကိုယာယီမထောက်ခံ၊ လှည့်ပြီးပေါ်ဒ်ကြီးအစဉ်နံပါတ်:',
    slotErrTip: 'လက်ရှိပေါ်ဒ်တွင်ဘောင်ကပ်ထမ်းဆောင်ရွက်သောချောင်းများရှိ၍ ပြန်ပြင်ဆင်မှုကိုမထောက်ခံ!',
    lockedPaibanTip: 'ပေါ်ဒ်ကြီးကိုလော့ပိတ်ထားသဖြင့်ပြန်ပြင်ဆင်မနိုင်',
    batchBujianErrTip: 'လက်ရှိပေါ်ဒ်သည်ပစ္စည်းစာရင်းမူရင်းဒေတာတွင်မရှိ၊ ဖြည့်ဆည်းပစ္စည်း/ပြင်ဆင်ရန်ကြိုဆောင်ဒေတာဘင်မှပြန်ပြင်ဆင်မှုကိုရွေးနိုင်',
    useFolderIsNot: 'ဖိုင်ဒေါင်းလုတ်သိမ်းဆည်းနေရာ "{type}" မရှိကြောင်းစစ်ဆေးတွေ့ရှိ! ဖိုင်တွဲဖျက်သိမ်းခြင်းရှိမရှိစစ်ဆေးပါ',
    useFolderIsNot1: 'ဖိုင်ဒေါင်းလုတ်တည်နေရာမသတ်မှတ်ရသေးကြောင်းစစ်ဆေးတွေ့ရှိ၊ ဦးစွာဖိုင်တွဲရွေးပါ',
    downloadNC: 'NC ဒေါင်းလုတ်',
    downloadNC1: 'NC ဖိုင်ဒေါင်းလုတ်',
    reArrange: 'ပြန်ပြင်ဆင်',
    reArrangeSpecifiedMaterialGroup: 'သတ်မှတ်ထားသော ပေါ်ဒ်အုပ်စုများကို ပြန်လည်အပြင်အဆင်လုပ်ပါ',
    specifiedMaterialRelayoutMoreResultTip: 'သတ်မှတ်ထားသော ပေါ်ဒ်အုပ်စုများကို ပြန်လည်အပြင်အဆင်လုပ်ပြီးနောက် နောက်ထပ်အပြင်အဆင်ရလဒ်များကို မပေးတော့ပါ',
    searchMaterialGroup: 'ပေါ်ဒ်အုပ်စုများကို ရှာပါ',
    saveToHistory: 'မှတ်တမ်းသို့သိမ်းပါ',
    moreSetting: 'နောက်ထပ်',
    cutIndexRe: 'မှတ်ချက်ကိုဖယ်ရှားရန် ctrl+z ကိုအသုံးပြုပါ',
    followExportTag: 'NC ဒေါင်းလုတ်ကိုဆိပ်ကမ်းဖိုင်ထုတ်ပါ',
    followExportPaibanImg: 'NC ဒေါင်းလုတ်ကိုပြင်ဆင်မှုပုံဖိုင်ထုတ်ပါ',
    followExportWorkerShop: 'NC ဒေါင်းလုတ်ကိုဝယ်ယူမှုစာရင်းထုတ်ပါ',
    tagTemplateSelect: 'ဆိပ်ကမ်းပုံစံရွေးချယ်',
    showCuttingSequence: 'ဖြတ်တောက်အစဉ်ပြသ',
    showPlankSize: 'ပေါ်ဒ်ငယ်အရွယ်ပြသ',
    sendToFactory: {
      title: 'လုပ်ငန်းခွင်သို့ပေးပို့',
      fileType: 'ဆိပ်ကမ်းဖိုင်အမျိုးအစား'
      },
    checkData: 'ဒေတာပြည့်စုံမှုစစ်ဆေးနေသည်...',
    dataLoading: 'တင်ဆောင်နေသည်......',
    addToBujianStore: 'ဖြည့်ဆည်းပစ္စည်းဂိုဒေါင်သို့ထည့်နေသည်...',
    updateTaskStatus: 'တာဝန်အခြေအနေအပ်ဒိတ်လုပ်နေသည်...',
    sending: 'လုပ်ငန်းခွင်သို့ပေးပို့နေသည်',
    waitLoadding: 'စောင့်ဆိုင်း',
    loadding: 'ဆောင်ရွက်နေသည်',
    finish: 'ပြီးဆုံး',
    loadSetting: 'ဆက်တင်တင်ဆောင်',
    loadPreference: 'ဦးစားပေးဆက်တင်တင်ဆောင်',
    dealTemplate: 'ပုံစံပြင်ဆင်',
    initTagData: 'ဆိပ်ကမ်းဒေတာစတင်',
    prepareDrawData: 'ဆိပ်ကမ်းဆွဲဒေတာပြင်ဆင်',
    drawDataText: 'ဆိပ်ကမ်းဆွဲဒေတာ',
    genPdfTagFile: 'PDF ဆိပ်ကမ်းဖိုင်ဖန်တီး',
    genPicTagFile: 'ဆိပ်ကမ်းပုံဖိုင်ဖန်တီး',
    uploadFile: 'ဖိုင်တင်ဆောင်',
    dealNCFile: 'NC ဖိုင်ပြင်ဆင်',
    zipFile: 'ဒေသဆိုင်ရာချုံ့ဖိုင်ဖန်တီး',
    plankCount: 'ပေါ်ဒ်ကြီးအရေအတွက်',
    rollCount: 'ပြောင်းဘက်အကြိမ်ရေ',
    totalRate: 'ကာလပြည့်ကောင်းမွန်မှုနှုန်း',
    rate: 'ကောင်းမွန်မှုနှုန်း',
    useArea: 'ကောင်းမွန်အောင်ပြုလုပ်ပြီးဧရိယာ',
    materialList: 'ပစ္စည်းစာရင်း',
    saveSurplus: 'ပိုလျှံပစ္စည်းဂိုဒေါင်သွင်း',
    workeShop: 'ဝယ်ယူမှုစာရင်း',
    batchTagging: 'အစုလိုက်ဆိပ်ကမ်းဖြည့်ပါ',
    batchTaggingTip: 'အောက်တွင်ဆိပ်ကမ်းထပ်ကြိုက်မည့်ပေါ်ဒ်ကိုရွေးပါ',
    holeSlotErr: 'ပေါ်ဒ်တွင်ပေါက်ကြိုးနက်မှုပုံမမှန်ရှိကြောင်းစစ်ဆေးတွေ့ရှိ!',
    knivesErr: 'ပေါ်ဒ်ငယ်တွင်လုပ်ဆောင်ရေးဓားမတွေ့ကြောင်းစစ်ဆေးတွေ့ရှိ!',
    checkDetail: 'အသေးစိတ်ကြည့်ပါ',
    deepErr: {
      title: 'ပေါ်ဒ်ပေါက်ကြိုးနက်မှုပုံမမှန်',
      errStatistic: 'ပေါ်ဒ်ငယ်တွင် {count} နေရာ ပုံမမှန်ရှိ',
      errText: 'ပုံမမှန်သောအပိုင်း',
      markErrPart: 'ပုံမမှန်သောအပိုင်းကိုဘောင်ဆွဲပါ'
      },
    warningTip: 'နှစ်ဖက်လုပ်ဆောင်ပေါ်ဒ်: ဦးစွာ မြင့်မားသောဝင်းပတ်မျက်နှာကိုလုပ်ဆောင်ပြီး မှိုင်းမျက်နှာကိုလုပ်ဆောင်; တစ်ဖက်တည်းလုပ်ဆောင်ပေါ်ဒ်: မှိုင်းမျက်နှာကိုတိုက်ရိုက်လုပ်ဆောင်',
    showDetail: {
      tip1: 'ကလစ်တစ်ချက်နှိပ်ပြီးပေါ်ဒ်တစ်ချပ်ရွေးပါ',
      tip2: 'ပေါ်ဒ်ဆိပ်ကမ်းကြည့်ပါ'
      },
    arrangeTip: '(အထူးပုံပေါင်းစပ်ပြင်ဆင်မှုကိုထောက်ခံပြီ)',
    plankOpration: 'ပေါ်ဒ်လုပ်ဆောင်မှု',
    rotate: '၉၀ ဒီဂရီလှည့်',
    notCare: 'ပေါ်ဒ်ကြောင်းမဲမရှိ',
    editRemark: 'မှတ်ချက်တည်းဖြတ်',
    clearRemark: 'မှတ်ချက်ရှင်းပြ',
    recalcIndex: 'ဓားချဉ်ပြင်ဆင်နှင့်ဖြတ်တောက်အစဉ်ပြန်တွက်ချက်',
    recalcIndexSuccess: 'ဓားချဉ်ပြင်ဆင်နှင့်ဖြတ်တောက်အစဉ်ပြန်တွက်ချက်မှုအောင်မြင်',
    storageArea: {
      title: 'ပေါ်ဒ်ယာယီသိမ်းဆည်းနယ်',
      empty: 'ပေါ်ဒ်ယာယီသိမ်းဆည်းမရှိ',
      storageTip: 'ပေါ်ဒ်ကိုဤနေရာသို့ဆွဲဆောင်ယာယီသိမ်းဆည်းနိုင်'
      },
    subtleArrange: 'ပြင်ဆင်မှုနှင့်ကောင်းမွန်',
    addPlank: 'ပေါ်ဒ်ကြီးထည့်',
    deletePlank: 'ပေါ်ဒ်ကြီးဖျက်',
    deletePlankErr: 'လက်ရှိပေါ်ဒ်ကြီးတွင်ပေါ်ဒ်ငယ်ရှိ၍ ပေါ်ဒ်ကြီးမဖျက်နိုင်!',
    useSurplus: {
      title: 'ပိုလျှံပစ္စည်းသုံး'
      },
    dragWarning: 'ပေါ်ဒ်ကိုပေါ်ဒ်ကြီးပေါ်ဆွဲဆောင်ပါ!',
    areaWarning: 'ပေါ်ဒ်ချနိုင်မည်မဟုတ်ပါ၊ နေရာထားရှိမှုကိုအာရုံစိုက်ပါ',
    subtlePage: {
      cut: 'ပိုလျှံပစ္စည်းဖြတ်',
      lineTip: 'ပေါ်ဒ်ကြီးပေါ်တွင်သာဖြတ်နိုင်၍ ပေါ်ဒ်ငယ်ကိုမထိနိုင်!',
      cancelCut: 'ဖြတ်တောက်ဆုံးနားပြ',
      cutPoint: 'ပိုလျှံပစ္စည်းဖြတ်ဆွဲဆောင်မှတ်',
      storageArea: 'ပေါ်ဒ်ပြင်ဆင်ရန်ကြိုဆောင်ဧရိယာ',
      cutErr: 'ပေါ်ဒ်ကြီးပေါ်တွင်သာဖြတ်နိုင်၍ ပေါ်ဒ်ငယ်ကိုမထိနိုင်!',
      saveErr: 'ဦးစွာဖြတ်ရမည့်ပိုလျှံပစ္စည်းတစ်ခုရွေးပါ',
      cutErr2: 'ပေါ်ဒ်ကြီးပေါ်တွင်သာဖြတ်နိုင်၍ ပေါ်ဒ်ကြီးကျော်မနိုင်!',
      selectTip: 'ဖြတ်ရမည့်ပိုလျှံပစ္စည်းပေါ်ဒ်တစ်ခုရွေးပါ',
      noCutPath: 'အထူးပုံအပိုင်းတွင်တစ်ထောင့်မှန်မဖြတ်နိုင်',
      cutOperate: 'ပိုလျှံပစ္စည်းဖြတ်တောက်လုပ်ဆောင်မှု',
      line: 'လက်ဖြင့်ဘောင်ဆွဲ',
      cutErrtip: 'ဖြတ်တောက်မှတ်တွင်ကျော်မြောက်ပြဿနာရှိ၊ ပြန်ဖြတ်ပါ',
      cutErrtip2: 'ဖြတ်တောက်မှတ်သည် ၉ မှတ်ကန့်သတ်ကျော်လွန်မည်၊ ပြန်ဖြတ်ပါ'
      },
    shortCut: 'ကီးဘုတ်အမြန်',
    updownRoll: 'အပေါ်အောက်ဆလိုက်',
    leftRightRoll: 'ဘယ်ညာဆလိုက်',
    zoomScale: 'ချဲ့ကျုံ့',
    dragCanvas: 'စာမျက်နှာဆွဲဆောင်',
    mouseRoll: 'မောက်စ်ဘီး',
    mouseRight: 'မောက်စ်ညာ',
    mouseMultiSelect: 'ပေါ်ဒ်ပါတ်များကို တစ်ခါတည်းထပ်နှစ်ချက်ကလစ်',
    mouseLeft: 'မောက်စ်အမြန်',
    doublePlank: 'ပေါ်ဒ်ကြီးကိုနှစ်ချက်ကလစ်',
    keyboard: 'ကီးဘုတ်',
    picSymble: 'ပုံသင်္ကေတ',
    funished: 'ပြီးစီးသောပစ္စည်း',
    holeSlotConflict1: 'ပေါက်ကြိုးပဋိပက္ခ',
    plankErr: 'ပေါ်ဒ်ပဋိပက္ခ',
    frontSlot: 'ရှေ့မျက်နှာဆွဲချောင်း',
    backSlot: 'နောက်မျက်နှာဆွဲချောင်း',
    frontHole: 'ရှေ့မျက်နှာပေါက်',
    backHole: 'နောက်မျက်နှာပေါက်',
    resetScale: 'ချဲ့ကျုံ့မူရင်းပြန်',
    maxLong: 'အရှည်ဆုံး',
    tempErr: 'ထည့်မှုမအောင်မြင်၊ ပုံစံနေရာမမှန်ကန် သို့မဟုတ် ပုံစံကြီးလွန်!',
    sendErr: 'လုပ်ငန်းခွင်ပေးပို့မှုမအောင်မြင်၊ ဆိပ်ကမ်းပုံစံနှင့်ပေါ်ဒ်ဒေတာမှန်ကန်မှုစစ်ဆေးပြီးပြန်ပေးပို့ပါ',
    someTips: 'Cloud Layout အထူးပုံပိုလျှံ/အထူးပုံပေါင်းစပ်လုပ်ဆောင်ချက်ကိုကန့်သတ်ကာလသုံးနေသည်၊ ထုတ်လုပ်မှုပြဿနာများကိုရှောင်ကြဉ်ပါ!',
    nestingTips: '[Advanced Irregular Nesting Layout] အတွက် ကန့်သတ်ကာလ အခမဲ့စမ်းသပ်မှု သက်တမ်းကုန်သွားပါပြီ။ ဆက်လက်အသုံးပြုရန် အရောင်းဌာနကို ဆက်သွယ်ဝယ်ယူပါ!',
    frameDoorTip: 'ာတ်ပုံဖော်မတ်တွင် ပေါင်းစပ်ထားသော အရိုးတံကို တွေ့ရှိပါသည်။ အရိုးတံကို ဒုတိယအကြိမ် ပြုပြင်ခြင်းမပြုမီ ကုလားထိပ်ခတ်ခြင်းကို ဦးစွာပြုလုပ်ပြီးမှသာ ထွင်းထုစက်ဖြင့် ဖြတ်တောက်ရန် လိုအပ်ကြောင်း သတိပြုပါ။',
    cutOrderErr: 'ဖြတ်တောက်အစဉ်မမှန်ကန်ပါ၊ ဓားချဉ်ပြင်ဆင်နှင့်ဖြတ်တောက်အစဉ်ပြန်တွက်ချက်ရန်ကလစ်နှိပ်ပါ!',
    holeSlotConflict: 'ပေါ်ဒ်တွင်ပေါက်ကြိုးပဋိပက္ခ/ပေါ်ဒ်ငယ်ပျံထွက်ကြောင်းစစ်ဆေးတွေ့ရှိ',
    exportSetting: 'ထုတ်ပြင်ဆင်ဆက်တင်',
    currentTagTemp: 'လက်ရှိဆိပ်ကမ်းပုံစံ',
    specialPaibanErr: 'ပေါ်ဒ်တွင်အထူးလုပ်ငန်းစဉ်သို့မဟုတ်ဘောင်ကပ်ချောင်းရှိ၍ ပြန်ပြင်ဆင်မှုကိုယာယီမထောက်ခံ!',
    moreResult: 'ပိုမိုသောရလဒ်များ',
    moreResultTip: 'ပေါ်ဒ်ကြီးတွင်ဘောင်ကပ်ချောင်းရှိပါက ပေါ်ဒ်ကြီးသည်ပြန်ပြင်ဆင်မှုတွင်မပါဝင်',
    batchBujian: 'အစုလိုက်ဖြည့်ဆည်း',
    batchOperation: 'အစုလိုက်လုပ်ဆောင်မှု',
    batchEditPlankSize: 'ပေါ်ဒ်ကြီးအရွယ်အစုလိုက်ပြင်ဆင်',
    editPlankSize: 'အရွယ်ပြင်ဆင်',
    editWay: 'ပြင်ဆင်နည်း',
    editByType: 'အမျိုးအစားအလိုက်ပြင်ဆင်',
    editByPlankNumber: 'ပေါ်ဒ်ကြီးနံပါတ်အလိုက်ပြင်ဆင်',
    editContent: 'ပြင်ဆင်အကြောင်းအရာ',
    editContentTip: 'ပြင်ဆင်ရမည့်ပေါ်ဒ်ကြီးအမျိုးအစားရွေးပါ',
    editContentTip1: 'ပြင်ဆင်ရမည့်ပေါ်ဒ်ကြီးနံပါတ်ရွေးပါ',
    editStart: 'စတင်',
    editEnd: 'ဆုံးနေရာ',
    bigPlank: 'ပေါ်ဒ်ကြီး',
    editSize: 'အရွယ်ပြင်ဆင်ရန်',
    bigPlankWidth: 'ပေါ်ဒ်ကြီးအကျယ်',
    bigPlankHeight: 'ပေါ်ဒ်ကြီးအရှည်',
    bigPlankLengthMarking: 'ပေါ်ဒ်ကြီးအရှည်သတ်မှတ်ချက်',
    markedAs: 'အဖြစ်သတ်မှတ်',
    maxAddTen: 'အများဆုံး ၁၀ ခုထည့်နိုင်',
    minValue: 'အနည်းဆုံးတန်ဖိုး',
    differentKnifeErr: 'ကွဲပြားသောဖြတ်ဓားရှိသောပေါ်ဒ်ကြီးများကိုရွေးထားသဖြင့်အရွယ်ပြင်ဆင်မနိုင်',
    noEditablePlank: 'ပြင်ဆင်နိုင်သော သတ်မှတ်ချက်နှင့်ကိုက်ညီသည့် ပေါ်ဒ်ကြီး မရှိပါ',
    skipBrandPlankTip: 'ရွေးချယ်ထားသောအတိုင်းအတာအတွင်း အရွယ်အစားပြင်ဆင်ခြင်းကို မပံ့ပိုးသော အမှတ်တံဆိပ်ပေါ်ဒ်ကြီး {count} ခုရှိပြီး ကျော်သွားပါပြီ',
    nonBrandToBrandTip: 'ဤပေါ်ဒ်ငယ်ကို အမှတ်တံဆိပ်အရောင်ကတ်ပေါ်ဒ်ကြီးသို့ ဆွဲယူ၍မရပါ!',
    brandToNonBrandTip: 'ဤပေါ်ဒ်ငယ်ကို အမှတ်တံဆိပ်မဟုတ်သော အရောင်ကတ်ပေါ်ဒ်ကြီးသို့ ဆွဲယူ၍မရပါ!',
    brandToOtherBrandTip: 'ဤပေါ်ဒ်ငယ်ကို အခြားအမှတ်တံဆိပ်အရောင်ကတ်ပေါ်ဒ်ကြီးသို့ ဆွဲယူ၍မရပါ!',
    editNo: 'နံပါတ်',
    editAllPlank: 'ပေါ်ဒ်ကြီးအားလုံး',
    editBigPartSize: 'ပေါ်ဒ်ကြီးအရွယ်ပြင်ဆင်မှု',
    disPlaySetting: 'ပြသဆက်တင်',
    stored: 'ဂိုဒေါင်သွင်းပြီး',
    onlySurplus: 'ပိုလျှံပစ္စည်းသာကြည့်',
    UnuseSurplus: 'ပိုလျှံပစ္စည်းအသုံးချနှုန်းတွက်ချက်မှုတွင်မပါဝင်',
    usePlankAdsorption: 'ပေါ်ဒ်ဆွဲဆောင်မှုလုပ်ဆောင်ချက်',
    dataDefaultCollapsed: 'ဒေတာမူရင်းကျုံ့ထား',
    unit: 'ချပ်',
    cutSurplus: 'ပိုလျှံပစ္စည်းဖြတ်',
    frontWarningTip: 'နှစ်ဖက်လုပ်ဆောင်ပေါ်ဒ်: ဦးစွာ မှိုင်းမျက်နှာကိုလုပ်ဆောင်ပြီး မြင့်မားသောဝင်းပတ်မျက်နှာကိုလုပ်ဆောင်; တစ်ဖက်တည်း: မြင့်မားသောဝင်းပတ်မျက်နှာကိုတိုက်ရိုက်လုပ်ဆောင်',
    selectTip: 'အောက်တွင်ဖြည့်ဆည်းရမည့်ပေါ်ဒ်ငယ်ရွေးပါ!',
    plankKeyWordPlaceholder: 'ပေါ်ဒ်အမည် သို့မဟုတ် ပေါ်ဒ်နံပါတ်ထည့်ပါ',
    surplusStoreSuccess: 'ဂိုဒေါင်သွင်းမှုအောင်မြင်',
    editCutOrder: 'ဖြတ်တောက်အစဉ်ပြင်ဆင်',
    setCutPoint: 'ဓားချဉ်ပြင်ဆင်သတ်မှတ်',
    specialPaibanChangeErr: 'ပေါ်ဒ်တွင်အထူးလုပ်ငန်းစဉ်သို့မဟုတ်ဘောင်ကပ်ချောင်းရှိ၍ ပြင်ဆင်မှုစီမံချက်ပြောင်းခြင်းကိုယာယီမထောက်ခံ!',
    storedSuccess: 'ဖြည့်ဆည်းမှုအောင်မြင်! ရွေးချယ်ထားသောပေါ်ဒ်ကိုဖြည့်ဆည်းစီမံချက်တွင်ထည့်ပြီး!',
    noSurplus: 'အသုံးပြုနိုင်သောပိုလျှံပစ္စည်းမတွေ့ပါ',
    selectErrTip: 'ပိုလျှံပစ္စည်းပေါ်ဒ်ကိုဖြည့်ဆည်းမနိုင်၊ ပုံမှန်ပေါ်ဒ်ငယ်ကိုဦးစွာရွေးပါ',
    noRoomIDTip: 'ဤပေါ်ဒ်တွင်အခန်း ID မရှိ၍ ဖြည့်ဆည်းဂိုဒေါင်သွင်းမနိုင်၊ အခြားပေါ်ဒ်ငယ်ကိုဦးစွာရွေးပါ',
    noPlank: 'ပေါ်ဒ်မတွေ့ပါ',
    noPaibanData: 'ပြင်ဆင်မှုဒေတာမရှိ၊ ဆောင်ရွက်မနိုင်',
    historyNameErr: 'စီမံချက်အမည်ထည့်ပါ',
    tempErrTip: 'ငါးဖက်/ခြောက်ဖက်တူးစက်ပုံစံမထည့်ရသေး၍ ထုတ်လုပ်ဖိုင်မထုတ်နိုင်ပါ',
    changeDataTip: 'သတိ: ဒေတာပြောင်းလဲမှုရှိကြောင်းစစ်ဆေးတွေ့ရှိ၊ ဤပြောင်းလဲမှုသိမ်းဆည်းဖို့မှတ်တမ်းဖိုင်အသစ်ဖန်တီးမည်လား?',
    upgrade: 'အဆင့်မြှင့်',
    upgradeTip: '၊ အောက်ပါခလုတ်ကိုနှိပ်ပြီးဗားရှင်းအဆင့်မြှင့်နိုင်',
    plankOverEdge: 'NC ဒေါင်းလုတ်မအောင်မြင်! ပေါ်ဒ်ထပ်နေသည် သို့မဟုတ် ပေါ်ဒ်ကြီးပြင်ပတွင်ရှိနေသည်ကိုစစ်ဆေးပါ',
    useSurplusTip: 'ပိုလျှံပစ္စည်းနှုတ်မည်လား',
    noDataExport: 'ထုတ်နိုင်သောပြင်ဆင်မှုဒေတာမရှိ',
    noPlankExport: 'ထုတ်နိုင်သောပေါ်ဒ်ငယ်ဒေတာမရှိ',
    lockTip1: 'ကလစ်နှိပ်ပြီးလော့ဖွင့်မည်၊ ဖွင့်ပြီးနောက်',
    lockTip2: 'ပေါ်ဒ်ငယ်တည်နေရာနှင့်ထူးဆန်းချက်ကိုတည်းဖြတ်နိုင်',
    unlockTip1: 'ကလစ်နှိပ်ပြီးလော့ပိတ်မည်၊ ပိတ်ပြီးနောက်မဆောင်ရွက်နိုင်',
    unlockTip2: 'ပေါ်ဒ်ငယ်တည်နေရာနှင့်ထူးဆန်းချက်တည်းဖြတ်မှု',
    plankLockErr: 'ဤပေါ်ဒ်ကြီးကိုလော့ပိတ်ထားသဖြင့်ချနိုင်မည်မဟုတ်',
    lockPartEditTip: 'ပေါ်ဒ်ကိုလော့ပိတ်ထားသဖြင့်တည်းဖြတ်မနိုင်',
    glassEquipmentTip: 'ထုတ်လုပ်မှုလိုင်းသည်မှန်ဖြတ်စက်ဖြစ်သောအခါ ပေါ်ဒ်ကိုရွှေ့မနိုင်',
    expandedTip: 'ပေါ်ဒ်တွင်ဆွဲချောင်းအထူးလုပ်ငန်းစဉ်ရှိ၍ တည်းဖြတ်မှုကိုမထောက်ခံ!',
    sameWidthPlankTip: 'ဓားရွက်ပြင်ဆင်မှုဖွင့်ထားသဖြင့်ပေါ်ဒ်ကိုရွှေ့မနိုင်',
    expandedArrangeTip: 'ပေါ်ဒ်တွင်ဆွဲချောင်းအထူးလုပ်ငန်းစဉ်ရှိ၍ ပြန်ပြင်ဆင်ရန်လိုအပ်!',
    dragErrTip: 'ချနိုင်မည်မဟုတ်ပါ၊ ပေါ်ဒ်ပစ္စည်း၊ အရောင်နှင့်အထူကိုစစ်ဆေးပါ!',
    subtleSaveTip: 'ပေါ်ဒ်ကိုလုပ်ဆောင်ပြီးမသိမ်းရသေး၊ ထွက်မည်လား?',
    rollTip: 'ပေါ်ဒ်ကြီးတွင်ဖောက်ပေါက်/ဖောက်ချောင်းရှိ၍ ပြောင်းဘက်ကိုမအကြံပြု!',
    glossRollErr: 'မြင့်မားသောဝင်းပတ်ပေါ်ဒ်ပြောင်းဘက်တားမြစ်',
    lockDeleteErr: 'ပေါ်ဒ်ကိုလော့ပိတ်ထားသဖြင့်ဖျက်မနိုင်',
    deleteConfirmTip: 'ဖျက်ဆီးမှုလုပ်ဆောင်ချက်ပြန်ရမည်မဟုတ်',
    deleteContinueTip: 'ဆက်လုပ်မည်လား?',
    deleteConfirm: 'ဖျက်ဆီးမည်ကိုအတည်ပြုပါ',
    selectPlankTip: 'ဤလုပ်ဆောင်မှုမပြုမီ ပေါ်ဒ်ကိုဦးစွာရွေးပါ',
    storeFailTip: 'ပိုလျှံပစ္စည်းဂိုဒေါင်သွင်းမှုမအောင်မြင်! ပေါ်ဒ်ထပ်နေသည် သို့မဟုတ် ပေါ်ဒ်ကြီးပြင်ပတွင်ရှိနေသည်ကိုစစ်ဆေးပါ',
    repeatStoreErr: 'လက်ရှိဖြတ်ထားသောပိုလျှံပစ္စည်းပေါ်ဒ်ကိုဂိုဒေါင်သွင်းပြီးသားဖြစ်သည်',
    surplusStoreFail: 'ဂိုဒေါင်သွင်းမှုမအောင်မြင်၊ ပေါ်ဒ်သည်တစ်ထောင့်မှန် သို့မဟုတ် L ပုံဖြစ်မဖြစ်စစ်ဆေးပါ!',
    plankConfilictErr: 'ဤနေရာတွင်ချနိုင်မည်မဟုတ်ပါ၊ အခြားပေါ်ဒ်များနှင့်ပဋိပက္ခဖြစ်မည်',
    surplusErrTip: 'ဤနေရာတွင်ချနိုင်မည်မဟုတ်ပါ၊ မမှန်ကန်သောပိုလျှံပစ္စည်းဖန်တီးမည်',
    changeArrageSuccess: 'ပြင်ဆင်မှုစီမံချက်ပြောင်းလဲမှုအောင်မြင်',
    trialProduction: {
      trialProductionSample: 'စမ်းသပ်ထုတ်လုပ်မှုနမူနာဗိုင်တိုက်',
      trialProduced: 'ကျွန်ုပ်စမ်းသပ်ထုတ်လုပ်ပြီး',
      trialWarning: '{fontStyleStart}အကယ်၍{fontStyleEnd} သင်သည် နမူနာစင်္ကြံအတွက် ထုတ်လုပ်မှု အတည်ပြုချက်ပြုလုပ်ခြင်းကို မပြုလုပ်ခြင်းကြောင့် သင်ကိုယ်တိုင်၊ တခြားသူများနှင့် တိမ်သား တိုက်ချက်ဆော့ဖ်ဝဲတို့အပေါ် ကျန်ရစ်သော အကျိုးဆိုမှုနှင့် မကောင်းသောဆိုးကျိုးအားလုံးအတွက် တာဝန်သည် သင်ကိုယ်တိုင်မှ သာလျှင် အပြည့်အဝ ရှိပါသည်။',
      trialSlotTip: 'စမ်းသပ်ထုတ်လုပ်ချိန်ရှေ့နောက်မျက်နှာပေါက်ကြိုးအရွယ်၊ နက်မှု၊ မျက်နှာနှင့်တည်နေရာမမှန်ကန်မှုစစ်ဆေးပါ',
      trialSlotTip1: 'ဗိုင်ပုံကြောင်းပျောက်ကြောင်းမဖြစ်ရ',
      trialSlotTip2: 'ပြဿနာ',
      pleaseUploadTrial: 'တပ်ဆင်ပြီးသောစမ်းသပ်ထုတ်လုပ်မှုနမူနာဗိုင်ဓာတ်ပုံတင်ပါ',
      uploadTrial: 'နမူနာဗိုင်တင်ဆောင်'
      },
    awaitPlankStore: {
      store: 'ပေါ်ဒ်ပြင်ဆင်ရန်ကြိုဆိုင်ဒေတာဘင်',
      notTip: 'ဂိုဒေါင်မသွင်းရသေးကြောင်းမပြတော့',
      justLookCurrent: 'လက်ရှိမှာယူမှုပေါ်ဒ်ငယ်သာကြည့်',
      notInPushStorage: 'ဂိုဒေါင်မသွင်းရသေး',
      beInStorage: 'ဂိုဒေါင်သွင်းပြီး',
      searchPlaceholder: 'မှာယူမှုထည့်ပြီးပြင်ဆင်ရန်ကြိုဆိုင်ဒေတာဘင်ပေါ်ဒ်ငယ်ရှာ',
      plankUploading: 'ပေါ်ဒ်သိမ်းဆည်းနေသည်',
      oneClickStorage: 'တစ်ကလစ်ဖြင့်ပြင်ဆင်ရန်ကြိုဆောင်ဒေတာဘင်တွင်သိမ်း',
      notUsePlank: 'ယာယီအသုံးပြုနိုင်သောပေါ်ဒ်ငယ်မရှိ',
      notPlank: 'ပေါ်ဒ်ယာယီသိမ်းဆည်းမရှိ',
      dragPlankInHere: 'ပေါ်ဒ်ကိုဤနေရာသို့ဆွဲဆောင်ပြီးယာယီသိမ်းဆည်းနိုင်',
      surplusCannotBeStorage: 'ပိုလျှံပစ္စည်းဂိုဒေါင်သွင်းမနိုင်',
      plankHasBeenDeduction: 'ပေါ်ဒ်ငယ်ကိုနှုတ်ယူပြီးသို့မဟုတ်မူရင်းဒေတာမရှိ၍ ဂိုဒေါင်သွင်းမနိုင်',
      plankLoadErr: 'ပေါ်ဒ်သတင်းတင်ဆောင်မအောင်မြင်',
      taskTitle: 'ပြင်ဆင်ရန်ကြိုဆိုင်ဒေတာဘင်ပေါ်ဒ်တင်ဆောင်',
      dataGenErr: 'ဒေတာဖန်တီးမှုအမှား',
      pushSuccess: 'ဂိုဒေါင်သွင်းမှုအောင်မြင်',
      pushErr: 'အမည်မသိအမှားဖြစ်ပွား၍ ဂိုဒေါင်သွင်းမှုမအောင်မြင်',
      awaitBoxExistPlank: 'ပြင်ဆင်ရန်ကြိုဆိုင်ဒေတာဘင်တွင်ဂိုဒေါင်မသွင်းရသေးသောပေါ်ဒ်ငယ်ရှိ၍ ဂိုဒေါင်သွင်းပြီးမှဆောင်ရွက်ရန်အကြံပြု',
      mergeFrameDoorWholeTip: 'ဤအစိတ်အပိုင်းသည်အရိုးတံခါးတစ်ခုလုံးအစိတ်အပိုင်းဖြစ်ပြီးနောက်တွင်စနစ်သည်စီမံခန့်ခွဲမှုအတွက်တစ်ခုတည်းပန',
      checkPlankStatus: 'ပေါ်ဒ်အခြေအနေစစ်ဆေးနေသည်...'
      },
    batchSetCut: 'ဓားချဉ်ပြင်ဆင်အစုလိုက်သတ်မှတ်',
    applyTo: 'သင့်တော်သည်:',
    ncDownloadLifeText: {
      checkData: 'ဒေတာစစ်ဆေးနေသည်',
      checkDone: 'ဒေတာစစ်ဆေးမှုပြည့်စုံ',
      checkDataText: 'ဒေတာစစ်ဆေး',
      loadSetting: 'ဆက်တင်တင်ဆောင်နေသည်',
      settingLoadDone: 'ဆက်တင်တင်ဆောင်မှုပြည့်စုံ',
      loadSettingText: 'ဆက်တင်တင်ဆောင်',
      downloadNc: 'NC ဒေါင်းလုတ်နေသည်',
      ncDownloadDone: 'NC ဒေါင်းလုတ်ပြည့်စုံ',
      downloadText: 'NC ဒေါင်းလုတ်',
      loadPreferenceSetting: 'ဦးစားပေးဆက်တင်တင်ဆောင်နေသည်',
      PreferenceSettingLoadDone: 'ဦးစားပေးဆက်တင်တင်ဆောင်မှုပြည့်စုံ',
      loadPreferenceText: 'ဦးစားပေးဆက်တင်တင်ဆောင်',
      dealTemp: 'ပုံစံပြင်ဆင်နေသည်',
      TempDealDone: 'ပုံစံပြင်ဆင်မှုပြည့်စုံ',
      dealTempText: 'ပုံစံပြင်ဆင်',
      beBeingGenTagFile: '{fileType} ဖိုင်ဖန်တီးနေသည်',
      genTagFileDone: '{fileType} ဖိုင်ဖန်တီးမှုပြည့်စုံ',
      genTagFileText: '{fileType} ဖိုင်ဖန်တီး',
      zip: 'ဒေသဆိုင်ရာချုံ့ဖိုင်ဖန်တီးနေသည်',
      zipDone: 'ဒေသဆိုင်ရာချုံ့ဖိုင်ဖန်တီးမှုပြည့်စုံ',
      genZipText: 'ချုံ့ဖိုင်ဖန်တီး',
      fileTypeText: 'ဓာတ်ပုံ'
      },
    surplusCommonTemp: 'ပိုလျှံပစ္စည်းအသုံးများသောပုံစံ',
    plankErrTip: 'လက်ရှိပစ္စည်းစီမံချက်တွင်ပြင်ဆင်နိုင်သောပေါ်ဒ်ကြီးမရှိသောပေါ်ဒ်ငယ်ရှိသည်!',
    brandPlankErrTip: 'လက်ရှိပစ္စည်းစီမံချက်တွင် ပြင်ဆင်ရန် အမှတ်တံဆိပ်ပေါ်ဒ်ကြီးမရှိသော အမှတ်တံဆိပ်ပေါ်ဒ်ငယ်များရှိသည်!',
    overSizeTip: 'ပေါ်ဒ်ကြီးအရေအတွက်မလုံလောက် သို့မဟုတ် ကြီးလွန်',
    uselessPart: 'လက်ရှိပေါ်ဒ်ကြီးတွင်အသုံးပြုနိုင်သောပေါ်ဒ်ငယ်မရှိ၊ ကျေးဇူးပြု၍ပြန်စီစဉ်ပါ',
    splitArranged: 'ပေါ်ဒ်ငယ်အရေအတွက်များလွန်း၍ ပြန်စီစဉ်ရန်သို့မဟုတ်အပိုင်းများပိုင်းပြင်ဆင်ရန်အကြံပြု',
    arrangedErrTip: 'ပြင်ဆင်မှုမအောင်မြင်၊ ပေါ်ဒ်ကြီးအရေအတွက်မလုံလောက် သို့မဟုတ် ပေါ်ဒ်ငယ်ကြီးလွန်ကြောင်းစစ်ဆေးတွေ့ရှိ',
    knivesModalTitle: 'ပေါက်/ချောင်းတွင်ဓားရှာမတွေ့',
    cannotDownloadByKnivesErr: 'NC ဒေါင်းလုတ်မနိုင်၊ အောက်ပါပေါက်/ချောင်းတွင်ဓားရှာမတွေ့',
    viewPart: 'ပြဿနာပေါ်ဒ်ငယ်ကြည့်',
    deductionModalTitle: 'နှုတ်ရမည့်အရာရွေးပါ',
    bujianDeduction: 'ဖြည့်ဆည်းပေါ်ဒ်ငယ်နှုတ်',
    paibanDeduction: 'ယာယီသိမ်းဆည်းနေရာပေါ်ဒ်ငယ်နှုတ်',
    surplusDeduction: 'ပိုလျှံပစ္စည်းပေါ်ဒ်ကြီးနှုတ်',
    unlockPaiban: 'ပြင်ဆင်မှုတွင်ပါဝင်သောပိုလျှံပစ္စည်းလော့ဖြည်',
    maintain: 'ပြင်ဆင်မှုတွင်ပါဝင်သောပိုလျှံပစ္စည်းလော့ထိန်းသိမ်း',
    lockModalText: 'ပိုလျှံပစ္စည်းပေါ်ဒ်ကြီးကိုအခြားမှာယူမှုများသုံးနေ၍ ပြင်ဆင်မှုပြန်လုပ်မည်လား',
    lockNewSModalText: 'လက်ရှိပိုလျှံပစ္စည်းပေါ်ဒ်ကြီးကိုအခြားမှာယူမှုများသုံးနေ၍ NC ဆက်ဒေါင်းလုတ်မည်လား',
    rePaibanWarn: 'ပိုလျှံပစ္စည်းပေါ်ဒ်ကြီးကိုအခြားမှာယူမှုသုံးနေ၍ ပေါ်ဒ်ကြီးမလုံလောက်၊ ကုန်ကြမ်းစာရင်းတွင်ပြင်ဆင်မှုပြန်လုပ်ပါ',
    sawRePaiban: 'သတိ: ဓားရွက်ဖြင့်ဖြတ်ကာကျဉ်းချောင်းပေါ်ဒ်ပြင်ဆင်မှုထပ်ထည့်ပြီ၊ NC ဖိုင်ထုတ်ဖို့ပြင်ဆင်မှုပြန်လုပ်ရမည်',
    togglePlankTip: 'ပေါ်ဒ်တွင်ဆွဲချောင်းအထူးလုပ်ငန်းစဉ်ရှိ၍ ရှေ့နောက်ပြောင်းကိုမထောက်ခံ!',
    stepCuttingMsg: 'ထပ်ဆင့်ဖြတ်နက်သည်ပေါ်ဒ်အထူထက်နည်းရမည်',
    stepCuttingMsg2: 'ထပ်ဆင့်ဖြတ်နက်တွင်သုည(0)ထက်ကြီးသောနံပါတ်သာထည့်နိုင်',
    flipPlankTip: 'ပေါက်/ချောင်းခွဲစင်ဖြတ်စက်တစ်ဖက်ပေါ်ဒ်ဖွင့်ထားသဖြင့်ပြောင်းဘက်ခွင့်မပြု!',
    genNoCutTagNotSupportExportPic: 'မဖြတ်ပေါ်ဒ်တံဆိပ်ဖန်တီးဖွင့်ထားသဖြင့်ဓာတ်ပုံထုတ်ကိုယာယီမထောက်ခံ',
    allSmallPlanksAreNoCutNotInLayout: 'လက်ရှိပေါ်ဒ်ငယ်အားလုံးသည်မဖြတ်ပေါ်ဒ်ဖြစ်၍ ပြင်ဆင်မှုတွင်မပါဝင်',
    canStillExportHoleSlotOrPrintTag: 'ပေါက်/ချောင်းဖိုင်ထုတ်ခြင်း သို့မဟုတ် တံဆိပ်ရိုက်နှိပ်ခြင်းဆက်လုပ်နိုင်',
    desMaterialNoCutNotSupportSwitchLine: 'လက်ရှိထုတ်လုပ်မှုလိုင်းတွင်သတ်မှတ်ပေါ်ဒ်ငယ်ပစ္စည်းမဖြတ်ဖွင့်ထားသဖြင့်ထုတ်လုပ်မှုလိုင်းတိုက်ရိုက်ပြောင်းမထောက်ခံ',
    desMaterialNoCutSettingChanged: 'သတ်မှတ်ပေါ်ဒ်ငယ်ပစ္စည်းမဖြတ်ဆက်တင်ပြောင်းလဲကြောင်းစစ်ဆေးတွေ့ရှိ၊ ထုတ်လုပ်မှုတိကျမှုသေချာစေဖို့ပြင်ဆင်မှုပြန်လုပ်ပါ',
    continueDownload: 'ဆက်ဒေါင်းလုတ်',
    desMaterialNoCutErrorTip: 'သတ်မှတ်ပေါ်ဒ်ငယ်ပစ္စည်းမဖြတ်တွင်ထွင်းဆာင်းစက်ဆောင်ရွက်ရသောပေါက်/ချောင်းရှိ၊ ဤဒေါင်းလုတ်တွင်ပေါက်/ချောင်းအားလုံးငါးခြမ်း/ခြောက်ခြမ်းထွင်းဆာင်းဆောင်ရွက်ဖို့ပြောင်းသည်',
    clearReuseRelation: 'ပြန်လည်အသုံးပြုမှုဆက်ဆံရေးကို ရှင်းလင်းရန် နှိပ်ပါ',
    layoutReuseTip: 'ကြီးမားသော ပေါ်ဒ်အပြင်အဆင်ကို အမြန်ပုံတူကူးပါ၊ ပေါ်ဒ်ပြောင်းလဲမှုသည် ပြန်လည်အသုံးပြုမှုဆက်ဆံရေးကို အလိုအလျောက်ဖယ်ရှားသည်',
    hasBeenReused: 'ပြန်လည်အသုံးပြုပြီး',
    layoutReuse: 'အပြင်အဆင် ပြန်လည်အသုံးပြုခြင်း',
    specialProcessNotSupported: 'ပေါ်ဒ်တွင် အထူးလုပ်ငန်းစဉ်ရှိပြီး ဤလုပ်ဆောင်ချက်ကို မပံ့ပိုးပါ',
    conflictNotSupported: 'ပေါ်ဒ်တွင် conflic ရှိပြီး ဤလုပ်ဆောင်ချက်ကို မပံ့ပိုးပါ',
    noAvailablePlankForReuse: 'ပြန်လည်အသုံးပြုရန် ရရှိနိုင်သော ပေါ်ဒ်မရှိပါ',
    noMatchingPlankFound: 'ကိုက်ညီသော ပေါ်ဒ်ကို မတွေ့ပါ',
    reuseBoard: '{number} ပေါ်ဒ်ပြန်လည်အသုံးပြုခြင်း',
    influenceTip: {
      title: 'ကောင်းမွန်မှုနှုန်းအပေါ်သက်ရောက်သောလုပ်ဆောင်ချက်များ',
      empty: 'မရှိပါ',
      groupParams: 'အစီအစဉ်ချမှုအညွှန်းများ',
      surplusNoRoll: 'ကျန်ရှိပစ္စည်းများ မလှန်ပါ',
      surplusCustomTrim: 'သီးခြားအနားညှိတန်ဖိုး',
      otherPlateCustomTrim: 'အထူးဘုတ်အတွက်သီးခြားအနားညှိတန်ဖိုး',
      knifeDiameter: 'ပန်းချိုးအလျား',
      surplusNoFlip: 'ကျန်ရှိပစ္စည်းများ မလှန်ပါ',
      surplusNotLayout: 'ကျန်ရှိပစ္စည်းများ မလှန်ပါ',
      plankEdgeOff: 'အနားညှိတန်ဖိုး',
      surplusCustomTrim2: 'ကျန်းမာရှင်းခြင်းကို အမှန်တကျဆိုးသည်',
      other: 'အကျိုးသက်ရောက်နိုင်သည့် အခြားလုပ်ဆောင်ချက်များ',
      enabled: 'ဖွင့်ထားသည်',
      plankThicknessStacking: 'ပြားအရောင်ခြင်းကို အမှန်တကျဆိုးသည်',
      edgePreMilling: 'ပြားအရောင်ခြင်းကို အမှန်တကျဆိုးသည်',
      multiMaterialCuttingBlade: 'ပြားအရောင်ခြင်းကို အမှန်တကျဆိုးသည်',
      sawSpecialShapePart: 'လွှဖြတ်နှင့် ထွင်းစက်များအတွက် ပုံသဏ္ဍာန်မမှန် အပေါက်ပါပြားများ',
      longPlankCutting: 'ပြားအရောင်ခြင်းကို အမှန်တကျဆိုးသည်'
      }
    },
  paibanImg: {
    title: 'ပြင်ဆင်မှုပုံစံစီမံ',
    exportCustomPaibanImg: 'စိတ်ကြိုက်ပြင်ဆင်မှုပုံဓာတ်ထုတ်',
    customPaibanImg: 'စိတ်ကြိုက်ပြင်ဆင်မှုပုံ',
    isCustomName: 'စိတ်ကြိုက်ပြင်ဆင်မှုပုံအမည်',
    template: 'ပြင်ဆင်မှုပုံပုံစံ',
    addTem: 'ပုံစံထည့်',
    canvasIndexSearch: 'ပေါ်ဒ်ကြီးနံပါတ်ရှာ',
    symbol: 'ပြင်ဆင်မှုပုံအမှတ်အသား',
    frontSlot: 'ရှေ့ချောင်း',
    backSlot: 'နောက်ချောင်း',
    frontHole: 'ရှေ့ပေါက်',
    backHole: 'နောက်ပေါက်',
    printNum: 'စာရွက်တစ်ရွက်ရိုက်တွင်အများဆုံးပြသမှု',
    printUnit: 'ပြင်ဆင်မှုပုံတစ်ပုံ',
    edit: 'ပြင်ဆင်မှုပုံပုံစံတည်းဖြတ်',
    temName: 'ပုံစံအမည်',
    rotate: 'ပြင်ဆင်မှုပုံလှည့်',
    showOverflow: 'စာသားပေါ်ဒ်မကြာ့သောအခါသတ်မှတ်မျဉ်းသည်ပေါ်ဒ်ငယ်ဒေတာပြသ',
    showHoleSlot: 'ပေါက်/ချောင်းသတင်းပြ',
    bigPartCss: 'ပေါ်ဒ်ကြီးပြင်ဆင်မှုပုံပုံစံချိန်ညှိ',
    partCss: 'ပေါ်ဒ်ငယ်ပြင်ဆင်မှုပုံပုံစံချိန်ညှိ',
    addTemTip: 'ပြင်ဆင်မှုပုံပုံစံ ၁၀ ခုသာထည့်နိုင်!',
    exportTip: 'ပြင်ဆင်မှုပုံပုံစံတစ်ခုနှင့်အထက်ရွေးပြီးထုတ်ပါ!',
    editSaveTip: 'ဖြည့်ရမည့်အချက်အားလုံးဖြည့်ပြီးမှသိမ်းပါ!',
    exportDXF: 'DXF ထုတ်ပါ',
    exportDxfGeneral: '2D အထွေထွေ DXF',
    exportDxf3d: '3D သီးသန့် DXF',
    exportDxfGeneralTip: 'လက်ဖြင့်加工ခြင်း၊ ပုံကြည့်၍ ဖြတ်တောက်ခြင်း သို့မဟုတ် အပြင်အဆင်ရလဒ်ကို စစ်ဆေးခြင်းအတွက် သင့်တော်သည်',
    exportDxf3dTip: 'ထုတ်လုပ်ရန် တတိယပါတီစနစ်များသို့ ထည့်သွင်းရန် သင့်တော်သည်။ Huiya လေဆာဖြတ်တောက်ရေး ပေါင်းစပ်စက်ကို ပံ့ပိုးသည်'
    },
  historyPage: {
    matchErrBySpecialTip1: 'အောက်ပါအထူးပေါ်ဒ်ကြီးများသင့်တော်သောအရာမတွေ့တော့ပါ၊ ပြင်ဆင်မှုစာမျက်နှာပြန်လုပ်ရာတွင်ပြဿနာဖြစ်မည်',
    specialPlankInfoErrTip2: 'အထူးပေါ်ဒ်ကြီးသတင်းရယူတွင်အမှားဖြစ်ပွား၊ ပြင်ဆင်မှုစာမျက်နှာပြန်ပြင်လုပ်ဆောင်ချက်ကိုထိခိုက်မည်',
    download: 'ဒေသဒေါင်းလုတ်',
    allType: 'အားလုံးသိမ်း',
    handleSave: 'လက်ဖြင့်သိမ်း',
    specialPlank: 'အထူး',
    surplusPlank: 'အကျိုးသက်သာ',
    autoSave: 'အလိုအလျောက်သိမ်း',
    allArrange: 'အားလုံးပြင်ဆင်',
    searchPlaceholder: 'မှာယူမှုအမည် / နေရာချထားမှုအသုတ် / မှာယူမှုနံပါတ်ဖြင့် ရှာဖွေပါ',
    saveHistoryName: 'သိမ်းဆည်းထားသော မှတ်တမ်းအမည်',
    trailProduction: {
      title: 'စမ်းသပ်ထုတ်လုပ်မှုနမူနာဗိုင်တိုက်',
      lastTime: 'ယခင်စမ်းသပ်ထုတ်လုပ်မှုရက်',
      recordList: 'စမ်းသပ်ထုတ်လုပ်မှုမှတ်တမ်း',
      start: 'စမ်းသပ်ထုတ်လုပ်မှုစတင်',
      date: 'အချိန်',
      outputFrom: 'ထုတ်ရာနေရာ',
      empty: 'ဒေတာမရှိသေး',
      record: 'တင်ဆောင်ထားသောစမ်းသပ်ထုတ်လုပ်မှုနမူနာဗိုင်ဓာတ်ပုံမှတ်တမ်း',
      tip1: 'သတိ: လက်ရှိစမ်းသပ်ထုတ်လုပ်မှုမှာယူမှုသည်မူရင်းထုတ်လုပ်မှုဒေတာကိုသုံးနေသည်',
      tip2: 'သတိ: လက်ရှိစမ်းသပ်ထုတ်လုပ်မှုမှာယူမှုသည်နောက်ဆုံးလုပ်ငန်းစဉ်ဆက်တင်ကိုမသုံးပါ၊ စမ်းသပ်ထုတ်လုပ်မှုအခန်းကိုသွားပြီးပြန်သိမ်းနိုင်!',
      download: 'ဖြည်ပြင်ဆင်ဖိုင်ဒေါင်းလုတ်'
      },
    deleteTip: 'အောက်ပါမှတ်တမ်းများဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    startDate: 'စတင်ရက်',
    endDate: 'ပြီးဆုံးရက်',
    lastWeek: 'ယခင်တစ်ပတ်',
    lastMonth: 'ယခင်တစ်လ',
    lastSeason: 'ယခင်သုံးလ',
    toArrangePage: 'ပြင်ဆင်မှုစာမျက်နှာသို့သွားနေသည်',
    notArrangedTip: 'ဤမှတ်တမ်းသည်ပြင်ဆင်မှုမလုပ်ဖူးသေး၊ ကုန်ကြမ်းစာရင်းကိုဦးစွာသွားပါ!',
    toMaterialPage: 'ကုန်ကြမ်းစာရင်းစာမျက်နှာသို့သွားနေသည်',
    lessSelectTip: 'ဤလုပ်ဆောင်မှုမပြုမီ မှတ်တမ်းတစ်ခုနှင့်အထက်ရွေးပါ',
    downloadNc: 'ဖြည်ပြင်ဆင်ဖိုင်ဒေါင်းလုတ်'
    },
  workShopPage: {
    warningTip: 'ဤလုပ်ဆောင်ချက်သည်အချိန်ကန့်သတ်စမ်းသပ်ဖြစ်သည်၊ မှာယူမှုထုတ်လုပ်မှုကိုသင့်တော်အောင်စီစဉ်ပါ!',
    fileManager: 'ထုတ်လုပ်မှုဖိုင်စီမံ',
    selected: 'ရွေးချယ်ပြီး',
    suplement: 'ဖြည့်ဆည်း',
    size: 'အတိုင်းအတာ',
    saveToStore: 'ဖြည့်ဆည်းဂိုဒေါင်ထည့်',
    enterArrange: 'ပြင်ဆင်မှုတွင်ဝင်နေသည်...',
    deleteTip: 'ဒေတာဖျက်ပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    arrangeTip: 'ဖြည့်ဆည်းဒေတာပြင်ဆင်နေသည်၊ ခဏစောင့်ပါ...',
    store: 'ဖြည့်ဆည်းဂိုဒေါင်',
    downloadFile: 'ထုတ်လုပ်မှုဖိုင်ဒေါင်းလုတ်',
    notBujianFile: 'ဖြည့်ဆည်းဖိုင်မတွေ့ပါ',
    productLineDelete: 'ဤထုတ်လုပ်မှုလိုင်းကိုဖျက်ပြီး၊ NC ဖိုင်ဒေါင်းလုတ်မနိုင်!'
    },
  basePlankManager: {
    saveTip: 'မှတ်ချက်: Enter နှိပ်ပြီးသိမ်း',
    offsetSize: 'ขอบ ဘောင်ဖြတ်အတိုင်းအတာ',
    overSizeTip: 'အတိုင်းအတာကြီးလွန်သောအခါ ပေါ်ဒ်ကြီးအရွယ်ကြီးကိုအလိုအလျောက်ရွေးပြင်ဆင်',
    addTip: 'ပြင်ဆင်ချိန်ပေါ်ဒ်ကြာ့သောအခါ အထူးပေါ်ဒ်ကြီးအလိုအလျောက်ထည့်ရောက်မည်',
    defaultOversizePlankValue: 'ကြာ့ပေါ်ဒ်ကြီးသည်ကြာ့ပေါ်ဒ်ငယ်သာပြင်ဆင်တဲ့အခါအထူးပေါ်ဒ်ကြီးအလိုအလျောက်ထည့်ရောက်မည်',
    onlyLayoutTooBig: 'ကြာ့ပေါ်ဒ်ကြီးသည်ကြာ့ပေါ်ဒ်ငယ်သာပြင်ဆင်',
    settingRemark: 'မှတ်ချက်: မူလဤနေရာလုပ်ဆောင်ချက်ကိုညာဘက်ဆက်တင်တွင်ပြောင်းထားသည်',
    searchPlaceholder: 'ပေါ်ဒ်ပစ္စည်း/အရောင်ရှာ',
    syncData: 'ဗိုင်ဒေတာစင်ခ်',
    syncDataM: 'ဗိုင်တံခါးဒေတာစင်ခ်',
    deletePlank: 'အထူးပေါ်ဒ်ကြီးဖျက်',
    addPlank: 'အထူးပေါ်ဒ်အသစ်ဆောက်',
    matCodePlaceholder: 'ပေါ်ဒ်ရွေးပါ',
    thickPlaceHolder: 'အထူရွေးပါ',
    widthErr: 'ပေါ်ဒ်အကျယ်မဟာမဆ',
    heightErr: 'ပေါ်ဒ်အရှည်မဟာမဆ',
    matCodeErr: 'ပေါ်ဒ်ပစ္စည်းမဟာမဆ',
    colorErr: 'ပေါ်ဒ်အရောင်မဟာမဆ',
    editPlank: 'ပေါ်ဒ်တည်းဖြတ်',
    deleteTip: 'ဒေတာဖျက်ပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    plankKnifeSelect: 'မူရင်းပေါ်ဒ်ဓားရွေးချယ်',
    plankKnifeSelectTip: 'ပေါ်ဒ်အပိုင်းဥပဒေများတိုက်ဆိုင်သောအခါ ပေါ်ဒ်အထူဦးစားပိုကြီး',
    knifeSelectTip: 'မှတ်ချက်: ထည့်ရောက်ပြင်ဆင်မှုသည်ဤလုပ်ဆောင်ချက်ကိုမထောက်ခံ',
    knife: 'ဖြတ်ဓား',
    matcodeInput: 'ပေါ်ဒ်ပစ္စည်းရိုက်ထည့်ပါ',
    thickInput: 'ပေါ်ဒ်အထူရိုက်ထည့်ပါ',
    default: 'စနစ်မူရင်း',
    unessential: 'ဤကော်လံ: မဖြည့်ရမည်မဟုတ်',
    emptyTip: 'သတိ: ဤကော်လံမဖြည့်ပါကမူရင်းနှင့်တိုက်ဆိုင်ရာဤဒေတာကိုမခွဲမပြ!',
    defaultUse: 'မူရင်းရွေး',
    editMatcode: 'ပစ္စည်းတည်းဖြတ်',
    syncTip: '{fromMc}ဒေတာယူ၍ ယာယီဆာဗာပြင်ဆင်မှုမူရင်းပေါ်ဒ်စီမံဒေတာကိုအစားထိုးမည်၊ ချိတ်ဆက်မည်လား?',
    sameErr: 'တူညီသောဒေတာရှိပြီး',
    cancelDelete: 'ဖျက်ဆီးမှုဖျက်သိမ်း',
    syncErr: 'ချိတ်ဆက်မမှုမအောင်မြင်',
    syncSuccess: 'ချိတ်ဆက်မှုအောင်မြင်',
    syncDataTip: '{fromMc}ဒေတာချိတ်ဆက်',
    editErrTip: 'မဖြည့်ရသေးသောသတင်းရှိ၊ စစ်ဆေးပါ!',
    numberCheck: '{type}တွင်ကိန်းဂဏန်းသာထည့်နိုင်!',
    deleteStandardPlate: 'မမာတ်ပေါ်ဒ်ဖျက်',
    createStandardPlate: 'မမာတ်ပေါ်ဒ်အသစ်ဆောက်',
    editStandardPlate: 'မမာတ်ပေါ်ဒ်တည်းဖြတ်',
    trimmingDimension: 'ဘောင်ဖြတ်အတိုင်းအတာ',
    front: 'အပေါ်',
    back: 'အောက်',
    left: 'ဘယ်',
    right: 'ညာ',
    frontTrim: 'အပေါ်ဘောင်ဖြတ်',
    backTrim: 'အောက်ဘောင်ဖြတ်',
    leftTrim: 'ဘယ်ဘောင်ဖြတ်',
    rightTrim: 'ညာဘောင်ဖြတ်',
    customTrim: 'စိတ်ကြိုက်ဘောင်ဖြတ်တန်ဖိုး',
    trimValue: 'ဘောင်ဖြတ်တန်ဖိုး',
    notEmpty: '{type}မဟာမဆ!',
    edgeDir: 'ဘောင်ဖြတ်({type})',
    brandPlank: 'အမှတ်တံဆိပ်ပေါ်ဒ်',
    brandPlankTip: 'မှတ်ချက်: အမှတ်တံဆိပ်ပေါ်ဒ်ဖျက်ခြင်းနှင့်ပြင်ဆင်ခြင်းကို Cabinet client ပေါ်ဒ်အရင်းအမြစ်စာကြည့်တိုက်တွင်ဆောင်ရွက်သည်',
    brand: 'အမှတ်တံဆိပ်',
    supplier: 'ထောက်ပံ့သူ',
    brandPlaceholder: 'အမှတ်တံဆိပ်ရွေးပါ',
    supplierPlaceholder: 'ထောက်ပံ့သူရွေးပါ',
    brandInput: 'အမှတ်တံဆိပ်ထည့်ပါ',
    supplierInput: 'ထောက်ပံ့သူထည့်ပါ',
    addBrandPlank: 'အမှတ်တံဆိပ်ပေါ်ဒ်ထည့်ပါ',
    deleteBrandPlank: 'အမှတ်တံဆိပ်ပေါ်ဒ်ဖျက်ပါ',
    editBrandPlank: 'အမှတ်တံဆိပ်ပေါ်ဒ်ပြင်ပါ',
    searchBrandPlaceholder: 'အမှတ်တံဆိပ်/ထောက်ပံ့သူ/ပစ္စည်း/အရောင် ရှာဖွေပါ'
    },
  bujianAndStore: {
    bujianStore: 'ဖြည့်ဆည်းဂိုဒေါင်',
    awaitStore: 'ပေါ်ဒ်ပြင်ဆင်စောင့်ဆိုင်း',
    depositAwaitStore: 'ပြင်ဆင်စောင့်ဆိုင်းဂိုဒေါင်ထည့်',
    pushToAwaitStore: 'ပြင်ဆင်စောင့်ဆိုင်းဂိုဒေါင်ထဲထည့်',
    useTwoTableArrange: 'ဖောင်နှစ်ခုဖြင့်ပြင်ဆင်',
    confirmUseTwoTableTip: 'ရွေးချယ်ထားသောပေါ်ဒ်ငယ်တွင်ဖြည့်ဆည်းဂိုဒေါင်နှင့်ပြင်ဆင်စောင့်ဆိုင်းဂိုဒေါင်ပေါ်ဒ်ပါဝင်သည်',
    confirmAddPlankToAwaitStore: 'ရွေးချယ်ထားသောပေါ်ဒ်ကိုပြင်ဆင်စောင့်ဆိုင်းဂိုဒေါင်ထည့်ရမည်ကိုအတည်ပြုလား?',
    pushStoreSuccess: 'ဂိုဒေါင်ဝင်မှုအောင်မြင်',
    dataGenErr: 'ဒေတာထုတ်လုပ်မှုအမှား',
    unknownErr: 'အမည်မသိအမှားဖြစ်ပွားသဖြင့်ဂိုဒေါင်ဝင်မသွားပါ'
    },
  surplusPage: {
    surplusMaterial: 'ပိုလျှံပစ္စည်းစာရင်း',
    surplusStore: 'ပိုလျှံပစ္စည်းဂိုဒေါင်',
    recycleBin: 'ပိုလျှံပစ္စည်းဂိုဒေါင်အသစ်ဆောက်',
    recycleBinTip: 'ပိုလျှံပစ္စည်းဒေတာကို အမှိုက်ပုံးတွင် ၉၀ ရက်ကျော်ထားလျှင် အလိုအလျောက် ဖျက်သိမ်းမည်',
    "deleteReason-0": 'ကိုယ်တိုင်ဖျက်ခြင်း',
    "deleteReason-1": 'စာမျက်နှာချပ်နည်းခြင်း',
    "deleteReason-2": 'Guigui မိုဘိုင်းအပ်ပလီကေးရှင်းမှ ထုတ်ယူမှု',
    surplusShape: 'ပိုလျှံပစ္စည်းပုံသဏ္ဍာန်',
    batchTransfer: 'အပိုင်းလိုက်လွှဲ',
    createNewSurplusStore: 'ပိုလျှံပစ္စည်းဂိုဒေါင်အသစ်ဆောက်',
    pushStoreSetting: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ဝင်ဆက်တင်',
    surplusStoreName: 'ပိုလျှံပစ္စည်းဂိုဒေါင်အမည်',
    surplusStoreName2: 'ပိုလျှံပစ္စည်းဂိုဒေါင်အမည်',
    addSurplusStore: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ထည့်',
    inventoryCeiling: 'ကုန်ပစ္စည်းအမြင့်ဆုံးကန့်သတ်',
    autoTransferTip: 'ဖျက်ပြီးနောက်ပိုလျှံပစ္စည်းဂိုဒေါင်မှပိုလျှံပစ္စည်းသည်အလိုအလျောက်ပိုလျှံပစ္စည်းစာရင်းသို့ပြောင်းသည်',
    asIndexPushStore: 'ဂိုဒေါင်သိမ်းဆည်းမှုအစဉ်အတိုင်းဝင်',
    pushToSurplusMaterial: 'ပိုလျှံပစ္စည်းစာရင်းသိမ်း',
    surplusStoreTable: {
      number: 'နံပါတ်',
      name: 'ပိုလျှံပစ္စည်းဂိုဒေါင်အမည်',
      quantity: 'သိမ်းဆည်းထားသောပိုလျှံပစ္စည်းအရေအတွက်(ခု)',
      capacity: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ကုန်ပစ္စည်းကန့်သတ်(ခု)',
      rules: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ဝင်စည်းမျဉ်း',
      remark: 'မှတ်ချက်',
      operation: 'လုပ်ဆောင်မှု'
      },
    editSurplusStore: 'ပိုလျှံပစ္စည်းဂိုဒေါင်တည်းဖြတ်',
    addSurplus: 'ပိုလျှံပစ္စည်းထည့်',
    importSurplus: 'ပိုလျှံပစ္စည်းတင်သွင်း',
    downloadSurplusTemplate: 'ပိုလျှံပစ္စည်းတင်သွင်းပုံစံဒေါင်းလုတ်',
    batchExportSurplus: 'လက်ရှိပိုလျှံပစ္စည်းစာရင်းထုတ်',
    surplusBatchImportExport: 'ပိုလျှံပစ္စည်းအပိုင်းလိုက်တင်သွင်းထုတ်',
    surplusMaterialStorageCode: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ဝင်ကုဒ်',
    generateQRCodeSuccess: 'QR ကုဒ်ဖန်တီးအောင်မြင်',
    generateQRCodeFailed: 'QR ကုဒ်ဖန်တီးမမှုမအောင်မြင်',
    refreshQRCode: 'QR ကုဒ်သစ်ကို',
    refreshQRCodeFailed: 'QR ကုဒ်သစ်ကိုမမှုမအောင်မြင်',
    cancelRefresh: 'သစ်ကိုဖျက်သိမ်း',
    refreshQRCodeTip: 'QR ကုဒ်သစ်ကိုမည်လား၊ သစ်ပြီးနောက်လက်ရှိ QR ကုဒ်မသုံးနိုင်တော့ပါ။',
    refreshQRCodeConfirm: 'အတည်ပြု',
    refreshQRCodeCancel: 'ဖျက်သိမ်း',
    wechatScanTip: 'WeChat ဖွင့်ပြီး QR ကုဒ်စကင်ဖတ်ကာပိုလျှံပစ္စည်းဂိုဒေါင်ကိုကိုယ်တိုင်ထည့်နိုင်',
    deletSurplus: 'ပိုလျှံပစ္စည်းဖျက်',
    editSurplus: 'ပိုလျှံပစ္စည်းပြင်',
    surplusNoRoll: 'ပိုလျှံပစ္စည်းပြန်မဖြတ်စီမံမှုဖွင့်',
    type: {
      all: 'ပုံသဏ္ဍာန်အားလုံး'
      },
    allMatcode: 'ပစ္စည်းအားလုံး',
    allThick: 'အထူအားလုံး',
    surplusName: 'ပိုလျှံပစ္စည်းအမည်',
    rectSurplus: 'ဆေးကွက်ပုံပိုလျှံပစ္စည်း',
    LTypeSurplus: 'L ပုံသဏ္ဍာန်ပိုလျှံပစ္စည်း',
    noMatchSup: 'သက်ဆိုင်ရာဒေတာမတွေ့',
    jumpTo: 'ကျော်သွား',
    page: 'စာမျက်နှာ',
    newMatcode: 'ပစ္စည်းအသစ်ဆောက်',
    newColor: 'အရောင်အသစ်ဆောက်',
    autoCreateColor: 'Enter နှိပ်ပြီးအလိုအလျောက်အရောင်ကဒ်ဖန်တီး',
    nameLimit: 'ပိုလျှံပစ္စည်းအမည်တွင်စကားလုံး ၁၀ လုံးသာထည့်နိုင်',
    nameLimitNameErr: 'ပိုလျှံပစ္စည်းအမည်မဟာမဆ',
    tempLongTip: 'ပေါ်ဒ်အရှည်တွင်ကိန်းဂဏန်းသာထည့်နိုင်',
    minLongLimit: 'တိုတောင်းဘက်အရှည်တွင်ကိန်းဂဏန်းသာထည့်နိုင်',
    minLongEmptyTip: 'တိုတောင်းဘက်အရှည်မဟာမဆ',
    minLongLimitMax: 'တိုတောင်းဘက်အရှည်သည်ပေါ်ဒ်အရှည်ကိုမကျော်နိုင်',
    widthLimit: 'ပေါ်ဒ်အကျယ်တွင်ကိန်းဂဏန်းသာထည့်နိုင်',
    minWidthLimit: 'တိုတောင်းဘက်အကျယ်တွင်ကိန်းဂဏန်းသာထည့်နိုင်',
    minWidthEmptyLimit: 'တိုတောင်းဘက်အကျယ်မဟာမဆ',
    minWidthLimitMax: 'တိုတောင်းဘက်အကျယ်သည်ပေါ်ဒ်အကျယ်ကိုမကျော်နိုင်',
    thickLimit: 'ပေါ်ဒ်အထူတွင်ကိန်းဂဏန်းသာထည့်နိုင်',
    thickEmptyLimit: 'ပေါ်ဒ်အထူမဟာမဆ',
    countInputLimit: 'အရေအတွက်သည်ဒဿမမရသောအပေါင်းကိန်းသာဖြစ်နိုင်',
    countEmptyLimit: 'အရေအတွက်မဟာမဆ',
    remarkMaxlimit: 'မှတ်ချက်တွင်စကားလုံး ၅၀ လုံးသာထည့်နိုင်',
    orderAddressMaxlimit: 'မူရင်းမှာယူမှုလိပ်စာတွင်စကားလုံး ၁၀၀ သာထည့်နိုင်',
    orderIdMaxlimit: 'မူရင်းမှာယူမှုနံပါတ်တွင်စကားလုံး ၁၀၀ သာထည့်နိုင်',
    createTime: 'ထည့်ဝင်ချိန်',
    deleteTime: 'ဖယ်ရှားသည့် အချိန်',
    deleteReason: 'ဖယ်ရှားသည့် မှတ်ချက်',
    branchName: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ရှိသောနေရာ',
    orderAddress: 'မူရင်းမှာယူမှုလိပ်စာ',
    orderId: 'မူရင်းမှာယူမှုနံပါတ်',
    lockStatus: 'လော့ချထားသောအခြေအနေ',
    lockOrder: 'မှာယူမှုလော့ချ',
    enableSurplusLock: 'ပိုလျှံပစ္စည်းလော့ချလုပ်ဆောင်ချက်ဖွင့်',
    isCloseSurplusLock: 'လုပ်ဆောင်ချက်ပိတ်ပြီးနောက်ပိုလျှံပစ္စည်းအားလုံးလော့ချဖြေ၊ ဆက်မည်လား',
    confirm: 'ပိတ်သည်ကိုအတည်ပြု',
    surplusTransfer: 'ပိုလျှံပစ္စည်းပြောင်းရွှေ့',
    targetSurplusStore: 'ပစ်မှတ်ပိုလျှံပစ္စည်းဂိုဒေါင်',
    enableSurLockTip: 'ဖွင့်ပြီးနောက်ပြင်ဆင်မှုတိုင်းတွင်အသုံးပြုသောပိုလျှံပစ္စည်းကိုလော့ချကာအခြားမှာယူမှုမသုံးနိုင်အောင်ကာကွယ်',
    addMainRule: 'မူလစည်းမျဉ်းထည့်',
    surplusRules: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ဝင်စည်းမျဉ်း',
    mainRulesTip: 'မူလစည်းမျဉ်းများကြားသည်သို့မဟုတ်ဆက်ဆံရေးဖြစ်ပြီးမူလစည်းမျဉ်းတစ်ခုကိုဖြည့်ဆည်းပေးနိုင်လျှင်ဂိုဒေါင်ဝင်မည်',
    mainRulesTip1: 'စည်းမျဉ်းထည့်ပြီးနောက်ဂိုဒေါင်ကိုပထမဦးဆုံးသိမ်းဆည်းမည်',
    rule: 'စည်းမျဉ်း',
    addSubRule: 'ကြားဖြတ်စည်းမျဉ်းထည့်',
    subRuleTip: 'ကြားဖြတ်စည်းမျဉ်းများကြားသည်နှင့်ဆက်ဆံရေးဖြစ်ပြီးမူလစည်းမျဉ်းအောက်ကြားဖြတ်စည်းမျဉ်းအားလုံးကိုဖြည့်ဆည်းမှသာဂိုဒေါင်ဝင်မည်',
    bigPlankMatCode: 'ပေါ်ဒ်ကြီးပစ္စည်း',
    bigPlankThick: 'ပေါ်ဒ်ကြီးအထူ',
    bigPlankColor: 'ပေါ်ဒ်ကြီးအရောင်',
    greaterEqual: 'ကြီးသည်သို့မဟုတ်ညီမျှ',
    lessEqual: 'သေးသည်သို့မဟုတ်ညီမျှ',
    capNumberCheck: 'ကုန်ပစ္စည်းအမြင့်ဆုံးကန့်သတ်တွင်ကိန်းဂဏန်းသာထည့်နိုင်!',
    capEmptyCheck: 'ကုန်ပစ္စည်းအမြင့်ဆုံးကန့်သတ်မဟာမဆ!',
    surNameEmptyCheck: 'ပိုလျှံပစ္စည်းဂိုဒေါင်အမည်မဟာမဆ!',
    mainRuleLimit: 'မူလစည်းမျဉ်းကန့်သတ်ချက်ရောက်ပြီ',
    delMainRuleTip: 'ဤမူလစည်းမျဉ်းကိုဖျက်ဆီးမည်လား',
    matCodeEmptyCheck: 'ပေါ်ဒ်ကြီးပစ္စည်းမဟာမဆ!',
    thickEmptyCheck: 'ပေါ်ဒ်ကြီးအထူမဟာမဆ!',
    textureEmptyCheck: 'ပေါ်ဒ်ကြီးအရောင်မဟာမဆ!',
    enableWarehouseSecondCon: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ဝင်ဒုတိယအတည်ပြုချက်ဖွင့်',
    surplusWarehouseConfirm: 'ပိုလျှံပစ္စည်းဂိုဒေါင်ဝင်အတည်ပြုချက်',
    surplusWarehouseConfirm1: 'ဂိုဒေါင်ဝင်အတည်ပြုချက်',
    closeSurplusConfirm: 'ဂိုဒေါင်ဝင်အတည်ပြုချက်ပိတ်(ပိုလျှံပစ္စည်းစီမံမှုစာမျက်နှာတွင်ပြန်ဖွင့်နိုင်)',
    position: 'သိမ်းဆည်းနေရာ',
    nameRepeatTip: 'ပိုလျှံပစ္စည်းအမည်ရှိပြီး၊ ပြင်ဆင်ပြီးဂိုဒေါင်ပြန်ဝင်ပါ',
    surLimitTip: 'လက်ရှိပိုလျှံပစ္စည်းဂိုဒေါင်ကန့်သတ်ချက်ရောက်ပြီ သို့မဟုတ် ဂိုဒေါင်ဝင်စည်းမျဉ်းမပြည့်မီ',
    surFailTip: 'ဂိုဒေါင်ဝင်မမှုမအောင်မြင်၊ ပိုလျှံပစ္စည်းအမည်တူညီမှုရှိသည် သို့မဟုတ် ဂိုဒေါင်ကန့်သတ်ချက်ရောက်ပြီ သို့မဟုတ် စည်းမျဉ်းမပြည့်မီ',
    surplusExistTip: 'ပိုလျှံပစ္စည်းအချို့ဂိုဒေါင်ထဲရှိပြီးဖြစ်ပြီးဤလုပ်ဆောင်မှုမအောင်မြင်',
    surplusExistTip2: 'လက်ရှိပိုလျှံပစ္စည်းဂိုဒေါင်ထဲရှိပြီးဂိုဒေါင်ဝင်မနိုင်',
    currentPage: 'လက်ရှိစာမျက်နှာ',
    totalPage: 'အားလုံးရွေး'
    },
  printPage: {
    goto: 'ချက်ချင်းသွား',
    surplusSizeTittle: 'ပိုလျှံပစ္စည်းအတိုင်းအတာသေးငယ်သတိပေး',
    surplusSizeErrTip: 'ပိုလျှံပစ္စည်းအတိုင်းအတာသေးငယ်လွန်းသည်၊ သင့်တော်သောထုတ်လုပ်မှုလိုင်းတွင်အနည်းဆုံးအတိုင်းအတာသတ်မှတ်ပါ!',
    opacityTip: 'ဇိနိဘဲဆွဲကာလူနာဦးစောင်မထောက်ခဲ',
    opacityTip2: 'လက်ရှိအကောင့်ကိုးကျောင်းကာလူနာမ၀ယ်ရသေး',
    loadFontTip: 'လိုအပ်သောဖောင့်ဖိုင်တင်နေသည်ခဏစောင့်ပါ',
    leftAlign: 'ဘယ်ဘက်ညှိ',
    rightAlign: 'ညာဘက်ညှိ',
    topAlign: 'အပေါ်ညှိ',
    bottomAlign: 'အောက်ညှိ',
    horizontalAlign: 'အလျားလိုက်အလယ်ညှိ',
    verticalAlign: 'ထောင်လိုက်အလယ်ညှိ',
    horizontalSplit: 'အလျားလိုက်တူညီကွဲ',
    verticalSplit: 'ထောင်လိုက်တူညီကွဲ',
    norTag: 'ပုံမှန်မူရင်းပေါ်ဒ်တံဆိပ်',
    surTag: 'ပိုလျှံပစ္စည်းပေါ်ဒ်ကြီးတံဆိပ်',
    genTag: 'တံဆိပ်ဖန်တီး',
    all: 'အားလုံးရွေး',
    deleteWarning: 'ဖြေရှင်းချက်',
    print: 'ရိုက်နှိပ်',
    defaultTemplate: 'မူရင်းပုံစံ（60 x 40）',
    editTemplate: 'ပုံစံတည်းဖြတ်',
    deleteTip: 'ပုံစံဖျက်ပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    tagSetting: 'တံဆိပ်ဆက်တင်',
    rememberSetting: 'ပြင်ဆင်ပြီးနောက်ဆက်တင်မှတ်ထားမည်',
    genCutingTag: 'ဖြတ်တောက်ပိုလျှံပစ္စည်းပေါ်ဒ်တံဆိပ်ဖန်တီး',
    genSurplusTag: 'ပိုလျှံပစ္စည်းပေါ်ဒ်တံဆိပ်ဖန်တီး',
    genPlankTag: 'ပေါ်ဒ်ကြီးတံဆိပ်ဖန်တီး',
    genPartTag: 'ပေါ်ဒ်ငယ်တံဆိပ်ဖန်တီး',
    genNoCutTag: 'မဖြတ်ပေါ်ဒ်တံဆိပ်ဖန်တီး',
    tagPosition: 'တံဆိပ်ကပ်နေရာ',
    tagPositionTip: '(တံဆိပ်ကပ်စက်သာX/Yကိုဩဒိနိတ်ဖြည့်ရမည်)',
    Xposition: 'X ကိုဩဒိနိတ်',
    Yposition: 'Y ကိုဩဒိနိတ်',
    genPlankSuffix: 'ပေါ်ဒ်ကြီးတံဆိပ်ဖန်တီးချိန်ဖိုင်အမည်နောက်ဆက်',
    arrangeMirror: 'တံဆိပ်ပုံမှန်ပြောင်းပြန်',
    drillPlankBase: 'ငါးချက်ခြောက်မျက်နှာတွင်းထွင်းပြားအခြေခံ',
    drillPlankBaseTip: 'ပြားချထားမှုအခြေခံဒေတာမရ၊ နောက်မှပြန်ကြိုးစားပါ!',
    suitAuto: 'တံဆိပ်စီမှုအလိုအလျောက်အပေါ်အောက်နှင့်ကိုက်ညီ:',
    colorLabel: 'အရောင်တံဆိပ်များဖန်တီး',
    colorRevert: 'ပေါ်ဒ်ငယ်ပြောင်းပြန်အရောင်တံဆိပ်ဖန်တီး',
    displayEnAndZh: 'အခန်း/ကက်ဘိန/ပြားအမည်ကိုအင်္ဂလိပ်တရုတြသခြင်း',
    displayEnAndZhTip: 'မူရင်းအခန်း/ကက်ဘိန/ပြားအမည်သာပံ့ပိုး၊ စိတ်ကြိုက်ပြင်ပြီးနောက်မအလုပ်လုပ်',
    up: 'အပေါ်သို့',
    down: 'အောက်သို့',
    default: 'မူရင်း',
    printSetting: 'ရိုက်နှိပ်ဆက်တင်',
    oneToMore: 'တစ်ချပ်များစွာစာမျက်နှာ',
    perPage: 'အချပ်ချင်း',
    coloumn: 'ကော်လံ',
    tagMargin: 'တံဆိပ်ကြားအကွာအဝေး',
    coloumnMargin: 'ကော်လံကြားအကွာအဝေး',
    specialMark: 'အထူးမှတ်သားချက်',
    opacity: 'အပြင်အပြင်',
    opacityTip3: 'BMP ပုံသည်အပြင်အပြင် support ရန် true color ရွေးရမည်',
    suite: 'အလိုအလျောက်ညှိ',
    svgListTip: 'ပေါ်ဒ်ငယ်တံဆိပ်ဖန်တီးမဖွင့်ရ၊ ဘယ်ဘက်တွင်ရွေးပါ',
    size: 'အရွယ်အစား',
    lightSide: 'အလင်းမျက်နှာစာ',
    locFrontSide: 'ကက်ဘိနက်ရှေ့မျက်နှာ',
    openSide: 'တံခါးဖွင့်ရာဘက်',
    extraTip: 'ပထမဆုံးတိုက်ရိုက်ရိုက်နှိပ်သုံးသည့်အခါပရင့်တာဆက်တင်တွင်အရွယ်တူအလျားအကျယ်ပြောင်းထားသောစာရွက်ထည့်ပြီးထိုစာရွက်ဖြင့်ရိုက်ပါ',
    noMore: 'နောက်ထပ်မရှိ',
    prepareData: 'ဒေတာပြင်ဆင်နေသည်...',
    genTagFile: 'တံဆိပ်ဖန်တီးနေသည်၊ စာမျက်နှာပြောင်းခြင်း၊ ဘရောက်ဆာခေါက်ခြင်း၊ တံဆိပ်အပေါ်အောက်လှိမ့်ခြင်းမပြုပါနှင့်!',
    waitGen: 'တံဆိပ်များပြည့်စုံစွာလာမှဒေါင်းလုတ်ပါ',
    tempLoading: 'တံဆိပ်ပုံစံလာနေသည်၊ ခဏစောင့်ပါ',
    front: 'ရှေ့',
    open: 'ဖွင့်',
    toEdit: 'တည်းဖြတ်သို့သွား',
    simplifyOneCodeTip: 'ဤတံဆိပ်ပုံစံ၏ဘားကုဒ်ဆက်တင်သည်ရိုးရှင်းဘားကုဒ်ကိုမပံ့ပိုး၊ ဘားကုဒ်ဆက်တင်ပြင်ပါ(အကြံပြု CODE128)',
    plankTemp: 'ပေါ်ဒ်ငယ်တံဆိပ်ပုံစံ',
    surplusTemp: 'ပိုလျှံပစ္စည်းတံဆိပ်ပုံစံ',
    enableSubTag: 'အရန်တံဆိပ် ဖွင့်ရန်',
    enableSubTagTip: 'နောက်ထပ် ဆက်တင်များ > အကွက်ငယ် အရန်တံဆိပ် ဆက်တင် > အရန်တံဆိပ် ထုတ်လုပ်ရန် အကျိုးသက်ရောက်သော ဒေတာရင်းမြစ် သတ်မှတ်ရန် တွင် သတ်မှတ်နိုင်သည်။ ဖွင့်ပြီးနောက် သတ်မှတ်ထားသော ဒေတာရင်းမြစ်တွင် အရန်တံဆိပ်ပေါ် တန်ဖိုးရှိမှသာ အရန်တံဆိပ် ထုတ်လုပ်မည်၊ မဟုတ်ပါက ထုတ်လုပ်မည်မဟုတ်ပါ။',
    goSet: 'ဆက်တင်သို့ သွားရန်',
    mainTag: 'အကွက်ငယ် ပင်မတံဆိပ်',
    subTag: 'အကွက်ငယ် အရန်တံဆိပ်',
    downloadSubTagTip: 'ထုတ်ယူသော တံဆိပ်တွင် အရန်တံဆိပ် ပါရှိသည်။ အလိုအလျောက် တံဆိပ်ကပ် စက်လိုင်းသည် လက်ရှိတွင် အရန်တံဆိပ် ထုတ်လုပ်၍ မရသေးပါ။ ဆက်လက် ထုတ်မည်လား။',
    embeddedSubTagTip: 'အရန်တံဆိပ် ဖွင့်ရန် မရရှိပါ။ အရန်တံဆိပ် ဖွင့်ရန် မရရှိပါ။ အရန်တံဆိပ် ဖွင့်ရန် မရရှိပါ။',
    subTagPerSaveTip: 'အရန်တံဆိပ် အကူအညီပြုလုပ်ထားသည်။ အရန်တံဆိပ်ကိုပိတ်ပြီးတော့ပြီးမှာယူပါ။',
    subTagPerexportTip: 'ထုတ်ယူသော ပရိုဒူးရေးသားစက်ကို အရန်တံဆိပ် အကူအညီပြုလုပ်ထားသည်။ အရန်တံဆိပ်ကိုပိတ်ပြီးတော့ပြီးမှာယူပါ။',
    tempNamePlaceHolder: 'ပုံစံအမည်ထည့်ပါ',
    editTip: 'ဘယ်ဘက်ခလုတ်များကိုညာဘက်တံဆိပ်စက္ကူပေါ်သို့ဆွဲချပြီးတံဆိပ်ပုံစံတည်းဖြတ်ပါ',
    oneCode: 'ဘားကုဒ်',
    image: 'ပုံ',
    arrow: 'မြှား',
    editPage: {
      digitLimitation: 'ဂဏန်းကန့်သတ်ချက်',
      title: 'တံဆိပ်ပုံစံတည်းဖြတ်',
      reset: 'မူရင်းပြန်ထား',
      exit: 'တည်းဖြတ်မှထွက်',
      tagInfo: 'တံဆိပ်အချက်အလက်',
      tagName: 'တံဆိပ်အမည်',
      tagSize: 'တံဆိပ်အရွယ်',
      tagData: 'တံဆိပ်ဒေတာ',
      dragTip: 'ဒေတာတံဆိပ်ထုတ်ရန်မောက်စ်ဘယ်ဘက်နှိပ်ဆွဲပါ',
      dataTip: 'ညာဘက်ပြဋ္ဌာန်းချက်တန်းမှဒေတာရွေးပါ',
      text: 'စာသား',
      dataSource: 'ဒေတာအချက်အလက်',
      graph: 'ဂရပ်ဖစ်',
      typograpyPic: 'အစီအစဉ်တကျပုံ',
      barCode: 'ဘားကုဒ်',
      QRCode: 'QR ကုဒ်',
      plankMark: 'ပြားမှတ်သားချက်',
      holeSlotPic: 'အပေါက်ချောင်းပုံ',
      edgeBandPic: 'အစွန်းပြားပုံ',
      visibleEdgePic: 'အလင်းမျက်နှာစာ',
      holeSlotPicZoom: 'အပေါက်ချောင်းပုံချဲ့',
      rotateDeg: 'လည်ချောင်းထောင့်',
      colorDeep: 'အရောင်အနက်',
      surplusMark: 'ပိုလျှံပစ္စည်းမှတ်သား',
      surplusSizePic: 'ပိုလျှံပစ္စည်းအရွယ်ပုံ',
      dataSize: 'ဒေတာအရွယ်',
      extraList: 'အပိုစာရင်း',
      QRCodeFormat: 'QR ကုဒ်ဖော်မတ်',
      formatQR: 'QR ဖော်မတ်',
      formatDM: 'DM ဖော်မတ်',
      locIndex: 'ကက်ဘိနက်အစဉ်နံပါတ်',
      plankFrontSign: 'ပြားရှေ့မျက်နှာမှတ်',
      genNCSuffix: 'NC နောက်ဆက်ဖန်တီး',
      table: 'ဇယား',
      inputPlaceholder: 'စာသားထည့်ရန်နှစ်ချက်နှိပ်ပါ',
      attribute: 'ဂုဏ်သတ္တိ',
      fontFamily: 'ဖောင့်အမျိုးအစား',
      fontSize: 'ဖောင့်အရွယ်',
      fontWeight: 'ဖောင့်ထူ',
      flipOverProcessing: 'မျက်နှာပြင်လှန်လုပ်ဆောင်ခြင်း',
      showSideMachiningSequenceDiagramBorder: 'မျက်နှာပြင်လှန်လုပ်ဆောင်ခြင်းနှင့်အတူတူမျက်နှာပြင်လှန်လုပ်ဆောင်ခြင်းနှင့်အတူတူ',
      showSideMachiningSequenceNumber: 'မျက်နှာပြင်လှန်လုပ်ဆောင်ခြင်းနှင့်အတူတူမျက်နှာပြင်လှန်လုပ်ဆောင်ခြင်းနှင့်အတူတူ',
      autoRow: 'အလိုအလျောက်အကြောင်းပြန်း',
      rowMargin: 'အတန်းကြားအကွာ',
      autoFontSize: 'ပြည့်လျှံသည့်အခါဖောင့်အရွယ်အလိုအလျောက်ညှိ',
      statisticsDimension: 'စာရင်းအင်းအတိုင်းအတာ',
      noLimit: 'ကန့်သတ်ချက်မရှိ',
      sameOrderNo: 'တူညီမှာယူမှု',
      sameRoom: 'တူညီအခန်း',
      sameWardrobe: 'တူညီကက်ဘိနက်',
      alignWay: 'ညှိချက်နည်း',
      JustifyLeft: 'ဘယ်ညှိ',
      JustifyRight: 'ညာညှိ',
      JustifyCenter: 'အလယ်ညှိ',
      otherOpration: 'အခြားလုပ်ဆောင်ချက်',
      attributeReset: 'ပါရာမီတာပြန်ထား',
      barCodeSize: 'ဘားကုဒ်အရွယ်',
      installPic: 'တပ်ဆင်ပုံ',
      plankCode2: 'ပြားဘားကုဒ်(noMark)',
      frontCode: 'ရှေ့မျက်နှာဘားကုဒ်',
      backCode: 'အနောက်မျက်နှာဘားကုဒ်',
      orderRemark: 'မှာယူမှုမှတ်ချက်',
      NCFileName: 'ဖြတ်တောက်ဖိုင်အမည်',
      NCFileNameTip: 'ဖြတ်တောက်ဖိုင်အမည်တွင်တရုတ်မပါရ၊ အရှည်၁၀လုံးထက်မပိုရ',
      showOpenSide: 'တံခါးဖွင့်ရာဘက်ပြသ',
      limitFixed: 'ဒဿမနေရာကန့်သတ်',
      showFrontHS: 'ရှေ့မျက်နှာအပေါက်ချောင်းပြသ',
      showBackHS: 'အနောက်မျက်နှာအပေါက်ချောင်းပြသ',
      showPartEdge: 'ပြားအစွန်းပြားပြသ',
      showPlankSize: 'ပြားအရွယ်ပြသ',
      tempNamePlaceholder: 'တံဆိပ်အမည်ထည့်ပါ',
      deleteAreaTip: 'ဖျက်မည့်နေရာရွေးပါ',
      suitShunt: 'ပြားအပေါက်ချောင်းပြသ',
      suitShuntTip: 'ပြုပြင်ခြင်းနောက် နောက်ဆက်စက်မရှိသော ပြားအပေါက်ချောင်းပြားများကို ဘားကုဒ်များမထုတ်လိုက်ပါ',
      noHoleSlot: 'အပေါက်ချောင်းမရှိလည်းဘားကုဒ်ပြသ',
      rotate: 'ဘားကုဒ်လည်ပါ',
      barcodeAtrribute: 'ဘားကုဒ်ဂုဏ်သတ္တိ',
      imgSize: 'ပုံအရွယ်',
      graphStyle: 'ဂရပ်ဖစ်စတိုင်း',
      noEdgeDisplay: 'အစွန်းပြား၀ဖြစ်လျှင်မပြသ',
      allEdgeNoDisplay: 'အစွန်းပြားမပြသ',
      isShowDiffEdgeColor: 'အစွန်းပြားအရောင်များပြသ',
      hideSameEdgeColorAsPlank: 'ပေါ်ဒ်အရောင်များအတူတူဖြစ်လျှင်အစွန်းပြားအရောင်များမပြသ',
      hideSameEdgeColorAsPlankTip: 'ထည့်သွင်းမိုးတိမ်တပ်ဆင်ခြင်းသည်ယာယီမပံ့ပိုးပါ',
      imgRotate: 'ပုံလည်ပါ',
      circleD: 'အဝိုင်းဘောင်အချင်း',
      roomNo: 'အခန်းနံပါတ်',
      roomOrder: 'ကက်ဘိနက်အစဉ်(အခန်းအလိုက်စီ)',
      alphabetically: 'က္ခရာစဉ်အတိုင်း',
      numberOrder: 'ကိန်းဂဏန်းစဉ်အတိုင်း',
      specialMarkup: 'အထူးမှတ်သားသင်္ကေတ',
      smallPlateMarking: 'ပေါ်ဒ်ငယ်မှတ်သား',
      arrow: 'မြှား',
      triangle: 'တြိဂံထောင့်မှတ်',
      sixSideDrillPlankBase: 'ငါးချက်ခြောက်မျက်နှာတွင်းထွင်းပြားအခြေခံ',
      boldSettingTip: 'PDF ထူဖောင့်မပံ့ပိုး',
      frontEdge: 'ကက်ဘိနက်ရှေ့မျက်နှာပြသ',
      visibleEdge: 'အလင်းမျက်နှာစာပြသ',
      lineCount: 'တစ်ကြောင်းစာလုံးအရေအတွက်'
      },
    autoSaveToHistory: 'သမိုင်းသို့အလိုအလျောက်သိမ်းပြီး!',
    firstPrintTip: 'ပထမဆုံးတိုက်ရိုက်ရိုက်နှိပ်သုံးသည့်အခါပရင့်တာဆက်တင်တွင်အလျားအကျယ်ပြောင်းထားသောစာရွက်အသစ်ထည့်ပြီးထိုစာရွက်ဖြင့်ရိုက်ပါ',
    tagDownloading: 'တံဆိပ်ဒေါင်းလုတ်ဆွဲနေသည်...',
    cutLaveEnd: 'ပိုလျှံတံဆိပ်များကိုတစ်ချပ်စီပေါ်ဒ်ကြီးနောက်တွင်ဖန်တီး',
    deleteTemplate: 'ပုံစံဖျက်ဆီး',
    copyTemplateRenderUrl: 'ပုံစံဖျက်ဆီး',
    noPermission: 'ပုံစံဖျက်ဆီးပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    moreOperation: 'ပိုမိုလုပ်ဆောင်ချက်များ',
    importTemplate: 'ပုံစံဖျက်ဆီး',
    importTemplateLink: 'ပုံစံဖျက်ဆီးပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    importTemplateLinkPlaceholder: 'ပုံစံဖျက်ဆီးပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    noDeleteTemplate: 'ပုံစံဖျက်ဆီးပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    tip1: 'ပုံစံဖျက်ဆီးပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    tip2: 'ပုံစံဖျက်ဆီးပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    tip3: 'ပုံစံဖျက်ဆီးပြီးပြန်မရနိုင်ပါ၊ ဖျက်ဆီးမည်ကိုအတည်ပြုလား?',
    tip4: 'တင်သွင်းထားသော ပုံစံလင့်ခ်ကို မသိရှိနိုင်ပါ။ ထပ်မံဒေါင်းလုဒ်လုပ်ပြီး ပြန်တင်သွင်းပါ။'
    },
  fileManagerPage: {
    folderClassifyByTextureColorThickSize: 'အရောင်၊ ပစ္စည်း၊ အထူ၊ ပေါ်ဒ်ကြီးအရွယ်အလိုက်မတူသောဖိုလ်ဒါများခွဲခြား(တံဆိပ်ဖိုင်ပါ)',
    notOpeFolderPermission: 'ဤဒိုင်ရက်ကတိုးကိုလုပ်ဆောင်ခွင့်မရ',
    notFindFolder: 'လက်ရှိကလိုင်းယင့်တွင်ဤဒိုင်ရက်ကတိုးမတွေ့နိုင်',
    productLineUniversal: 'ထုတ်လုပ်မှုလိုင်းအားလုံးအတွက်ယေဘုယျ',
    effectCondition: 'ဤဆက်တင်ပြောင်းပြီးနောက်ပြန်စီရန်လိုအပ်',
    addPath: 'လမ်းကြောင်းထည့်',
    downloadPositionChangeByType: 'ဖန်တီးဖိုင်ဒေါင်းလုတ်နေရာကို{type}သို့ပြောင်းပြီး',
    isDeleteFolder: 'အသုံးပြုပြီးဖိုင်သိမ်းနေရာကိုဖျက်မည်ကိုအတည်ပြုလား?',
    netWorkIsNotSafe: 'သင့်ကွန်ယက်ပတ်ဝန်းကျင်မလုံခြုံဟုထင်ရ၊ ဤလုပ်ဆောင်ချက်ဖွင့်၍မရ၊ ကျွန်ုပ်တို့ထံပြန်ကြားနိုင်',
    NotSupportBrowse: 'သင့်ဘရောက်ဆားသည်ဤလုပ်ဆောင်ချက်ကိုမပံ့ပိုးသေး၊ နောက်ဆုံး Edge ဘရောက်ဆားဒေါင်းပါ',
    notSupportDisk: 'စနစ်အဆင့်ဒိုင်ရက်ကတိုးရွေးမရ(ဥပမာ ဒက်စ်တော့၊ C ဒရိုက်)',
    useFolderDownload: 'ထုတ်လုပ်ဖိုင်များကိုဖြည့်ပြီးပုံစံဖြင့်ဒေါင်းလုတ်',
    downloadPosition: 'ဖိုင်ဒေါင်းလုတ်နေရာ',
    changeUseFolder: 'ပြောင်းပါ',
    folderNameSetting: 'ဖိုလ်ဒါဆက်တင်',
    mainFolder: 'ပထမအဆင့်ဖိုလ်ဒါ',
    exportNameSetting: 'ထုတ်ကုန်ဖိုင်များကိုမှာယူမှုနံပါတ်ဖြင့်အမည်ပေး',
    fileMax: 'ဖိုင်အမည်အများဆုံး',
    char: 'စာလုံး',
    overTip: 'ကျော်လွန်သောအပမပြသ(တံဆိပ်ပုံzipနှင့်jsonဖိုင်များသည်ပထမအဆင့်ဖိုလ်ဒါအမည်လိုက်မည်)',
    example: 'နမူနာ',
    engravingFolder: 'ထွင်းထားစက်ဖိုလ်ဒါ',
    electronicSawFolder: 'အီလက်ထရွန်းနစ်လွှဖိုလ်ဒါ',
    labellingFolder: 'တံဆိပ်ကပ်စက်ဖိုလ်ဒါ',
    sideHoleDrillFolder: 'ဘေးတွင်းထွင်းစက်ဖိုလ်ဒါ',
    fiveDrillFolder: 'ငါးမျက်နှာတွင်းထွင်းဖိုလ်ဒါ',
    sixDrillFolder: 'ခြောက်မျက်နှာတွင်းထွင်းဖိုလ်ဒါ',
    PTPFolder: 'PTP ဖိုလ်ဒါ',
    labellingTagFolder: 'တံဆိပ်ပုံဖိုလ်ဒါ',
    surplusFolder: 'ပိုလျှံဖိုင်ပေါ်ဒ်ကြီးဆက်တင်',
    surplusBigPlankSetting: 'ပိုလျှံပေါ်ဒ်ကြီးဖြတ်ဖိုင်/တံဆိပ်ပုံ/တံဆိပ်ဖိုင်သပ်ခြားထား',
    surplusBigPlankSettingTip: 'ဖွင့်ပြီးနောက်ပိုလျှံ NC ဖိုင်၊ တံဆိပ်ပုံနှင့်တံဆိပ်ဖိုင်များကိုသပ်ဖိုလ်ဒါတွင်ထား',
    folderMergeSetting: 'ဖိုလ်ဒါပေါင်းစည်းဆက်တင်',
    folderMerge: 'ဖိုလ်ဒါပေါင်းစည်း',
    mergeName: 'ပေါင်းစည်းအမည်',
    subMergeFolder: 'ပစ္စည်း၊ အရောင်၊ အထူအလိုက်ဆက်ဖိုလ်ဒါသို့ပေါင်းစည်း',
    subFolderName: 'ဆက်ဖိုလ်ဒါအမည်',
    splitChar: 'ခွဲခြားသင်္ကေတ',
    splitTip: '( / : ? < > | . " * စသည်ထည့်မရ)',
    folderAutoAdd: 'ဖိုလ်ဒါအရေအတွက်အလိုအလျောက်တိုးစရာဂဏန်း',
    resetTip: '(နေ့စဉ်သုညအချိန်တွင်စရာဂဏန်းသို့ပြန်ထား)',
    emptyErrTip: 'အချက်အလက်မဟာမဆ',
    repeatErrTip: 'ဖိုင်အမည်ထပ်နေသည်',
    mergeDataTip: 'ပြားပစ္စည်းအရောင်အထူအလျားအကျယ် သို့မဟုတ် ဖိုင်အရေအတွက်တိုး သို့မဟုတ် ပြားပစ္စည်းအရောင်အထူ ရှိရမည်',
    engravingFileSetting: 'ထွင်းထားစက်ဖိုင်ဆက်တင်',
    engravingSplitZF: 'ထွင်းစက်ရှေ့/အနောက်ဖိုင်များကိုမတူသောဖိုလ်ဒါများတွင်ထား',
    engravingSplitZFTip: '၁၂၃အလိုအလျောက်တံဆိပ်ကပ်စက်အတွက်သင့်လျော်',
    engravingSplitWorkstation: 'ထွင်းစက်ရှေ့/အနောက်ဖိုင်များကိုမတူသောဖိုလ်ဒါများတွင်ထား',
    engravingSplitWorkstationTip: 'ထွင်းစက်ရှေ့/အနောက်ဖိုင်များကိုမတူသောဖိုလ်ဒါများတွင်ထား',
    holeFileSetting: 'အပေါက်ဖိုင်ဆက်တင်',
    holeFileSingle: 'အပေါက်ဖိုင်များကိုမတူမှာယူမှုအလိုက်ဖိုလ်ဒါခွဲသပ်ထား'
    },
  moreSettings: {
    generalSetting: 'ယေဘုယျဆက်တင်',
    outSyncTip: 'ကလောက်ဒ်ပြင်ဆင်ဒေတာနှင့်ကက်ဘိနက်မကိုက်ညီသည့်အခါအကြံပြုပေါ်ပြကာပွင့်',
    secondarySwitchShow: 'ထွင်းစက်ဆက်တင်ရှိခလုတ်ထိန်းချုပ်သောဒုတိယအကြောင်းအရာပိတ်ပြီးနောက်ပြသ',
    isFrameDoorTip: 'ကက်ဘိနက်ပစ္စည်းများကို ဘယ်လိုလုပ်ဆောင်ချင်သည်ဆိုပါက အကြံပြုပေါ်ပြသည်',
    exPaibanTip: 'အသွင်ပိုလျှံ/အသွင်နစ်စတင်ပြင်ဆင်သုံးသည့်အခါအကြံပြုပေါ်ပြ',
    isDesMaterialNoCutTip: 'သတ်မှတ်ပေါ်ဒ်ငယ်ပစ္စည်းမဖြတ်သောပြား၊ ထွင်းစက်သို့အပေါက်ချောင်း/အသွင်တာဝန်ပေးသည့်အခါအကြံပြုပေါ်ပြ',
    surpTagThresholdTextHalf1: 'ပိုလျှံ(ဖြတ်မဟုတ်သောပိုလျှံ)ဧရိယာသည်ထို့ထက်ငယ်သည့်အခါ',
    surpTagThresholdTextHalf2: 'ပိုလျှံတံဆိပ်မဖန်တီး',
    innerShapeToolMatch: 'ထွင်းစက်အတွင်းအသွင်အတွက်သင့်လျော်သောကိရိယာအလိုအလျောက်ရွေး',
    innerShapeToolMatchTip: '(ထွင်းစက်ဖြတ်ကိရိယာအချင်းထက်သေးသောအတွင်းအသွင်ကိုပြုသည့်အခါအရွယ်အမှားမပြုနိုင်ပါက ဤလုပ်ဆောင်ချက်ဖွင့်နိုင်)',
    innerShapeToolMatchTip2: 'သတိပြု-ဖွင့်ပြီးနောက်အနည်းဆုံးမီးလ်လင်ချောင်းကိရိယာသုံးမည်၊ အနည်းဆုံးမီးလ်လင်ချောင်းကိရိယာအလျားနှင့်အကြိမ်တစ်ချက်အများဆုံးပြုအနက်သတ်မှတ်ပါ၊ ကလောက်ဒ်ပြင်ဆင်တွင်သာသက်ရောက်',
    surNotLayout: 'ပိုလျှံပေါ်ဒ်ကြီးတွင်သတ်မှတ်ပြားမစီအောင်သတ်မှတ်',
    surNotLayoutTip: 'ဖွင့်ပြီးနောက်၁.ပိုလျှံပေါ်ဒ်ကြီးတွင်အောက်ပါအမည်ပါပေါ်ဒ်ငယ်မစီနိုင် ၂.ပြင်ဆင်ချိန်တွင်ဤပြင်ဆင်တွင်ဤလုပ်ဆောင်ချက်သက်ရောက်မှုရွေးနိုင်',
    addPlank: 'ပြားအမည်ထည့်',
    addPlankTip: 'အနည်းဆုံးပေါ်ဒ်ငယ်အမည်တစ်ခုထည့်ပါ',
    thisInput: 'ဤနေရာတွင်ထည့်ပါ',
    surNotLayoutMat: 'ပိုလျှံသည်သတ်မှတ်ပေါ်ဒ်ငယ်မစီ',
    subTagSetting: 'အကွက်ငယ် အရန်တံဆိပ် ဆက်တင်',
    subTagDataSource: 'အရန်တံဆိပ် ထုတ်လုပ်ရန် အကျိုးသက်ရောက်သော ဒေတာရင်းမြစ် သတ်မှတ်ရန်',
    subTagDataSourceTip: 'ဖွင့်ပြီးနောက် အရန်တံဆိပ် ထုတ်လုပ်မှုကို ထိန်းချုပ်သော ဒေတာရင်းမြစ်များကို ထည့်နိုင်သည်။ အရန်တံဆိပ်တွင် ထိုဒေတာရင်းမြစ်ရှိပြီး တန်ဖိုးရှိပါက အရန်တံဆိပ် ထုတ်လုပ်မည်။',
    addSubTagDataSource: 'ဒေတာရင်းမြစ် ထည့်ရန်',
    addSubTagDataSourceTip: 'ထပ်နေသော ဒေတာရင်းမြစ် ထည့်၍မရပါ',
    addSubTagDataSourceTip1: 'အနည်းဆုံး ဒေတာရင်းမြစ် တစ်ခု ထည့်ပါ',
    addSubTagDataSourceTip2: 'ဒေတာရင်းမြစ် အလွတ်မဖြစ်ရပါ၊ ရွေးချယ်ပါ',
    reuseMatchingPlankName: 'ပြားအမည်အရ ပြန်လည်အသုံးပြု ကိုက်ညီခြင်း',
    reuseMatchingPlankNameTip1: 'ဤဝန်ဆောင်မှုပိတ်ထားသောအခါ၊ အခင်းအကျင်း ပြန်လည်အသုံးပြုခြင်းသည် ပစ္စည်း၊ အရောင်၊ အထူ၊ အတိုင်းအတာ၊ အရောင်သန်းနှင့် အမြင့်ပြောင်းဂုဏ်သတ္တိများတူညီသော ပြားများကို ကိုက်ညီမည်',
    reuseMatchingPlankNameTip2: 'ဤဝန်ဆောင်မှုကို ဖွင့်သောအခါ၊ အထက်ပါ ကိုက်ညီမှု စည်းမျဉ်းများအပြင်၊ ပြားအမည် ကိုက်ညီမှုကိုလည်း ထည့်သွင်းမည်'
    },
  lineManager: {
    add: 'ထုတ်လုပ်မှုလိုင်းထည့်',
    engraving: 'ဖြတ်တောက်စက်ပစ္စည်း',
    holeSlotEquip: 'အပေါက်ချောင်းပြုပြင်စက်',
    workSetting: 'ပြုပြင်ဆက်တင်',
    noUse: 'မဖွင့်ရသေး',
    warningTip: '*သတိပြု-အောက်ပါလုပ်ဆောင်ချက်ဆက်တင်ပြီးနောက်ကက်ဘိနက်ကလိုင်းယင့်ဒီဗိုင်းစ်စာမျက်နှာတွင်မသိမ်းပါနှင့်၊ ပါရာမီတာပြန်ထားခြင်းကိုရှောင်ပါ!',
    engravingSetting: 'ဖြတ်တောက်စက်ဆက်တင်',
    workWay: 'ပြုပြင်နည်း',
    cutedSpecial: 'ပြုပြင်သောအထူးအပေါက်ချောင်းများ:',
    noWork: 'ဤရွေးချယ်မှုငါး/ခြောက်မျက်နှာတွင်းထွင်းမူရင်းပုံစံတွင်မသက်ရောက်',
    onlyCut: 'ဖြတ်တောက်ချက်သာ',
    onlyFrontHoleSlot: 'ပြားရှေ့မျက်နှာအပေါက်ချောင်းသာပြု',
    onlyHoleSlot: 'ပြားရှေ့အနောက်အပေါက်ချောင်းသာပြု',
    sideHoleSetting: 'ဘေးတွင်းထွင်းစက်ဆက်တင်',
    cutHoleSlot: 'ပြုပြင်ထားသောအပေါက်ချောင်းများ',
    minSize: 'တိုတောင်းဘက်အရွယ်',
    maxSize: 'ရှည်ဘက်အရွယ်',
    minSize2: 'mm ပေါ်ဒ်ပေါ်ရှိအားလုံး',
    minSize3: 'နှင့်အသွင်အစိတ်အပိုင်း',
    onlyFrontHoleSlotTip: 'ပြင်ဆင်စာမျက်နှာတွင်ရှေ့မျက်နှာအပေါက်ချောင်းရှိပေါ်ဒ်ငယ်သာ',
    onlyFrontHoleSlotTip2: 'ဘေးအပေါက်ဘေးချောင်းမပါ',
    holeAndSlot: 'အပေါက်နှင့်ချောင်း',
    empty: 'ဗလာ',
    singleHole: 'အပေါက်တစ်ခု',
    singleSlot: 'ချောင်းတစ်ခု',
    diameterRange: 'အပေါက်အချင်းအကွာအဝေး',
    hDeepRange: 'အပေါက်အနက်အကွာအဝေး',
    widthRange: 'ချောင်းအကျယ်အကွာအဝေး',
    sDeepRange: 'ချောင်းအနက်အကွာအဝေး',
    to: 'သို့',
    specialHS: 'အထူးအပေါက်ချောင်းနှင့်အသွင်',
    allowRoll: 'ဖြတ်စက်ပြားလှန်ပြီးအထူးအပေါက်ချောင်းပြုခွင့်ပြု',
    engravingPath: 'ဖြတ်စက်ပေါ်ပြားအသွင်အစိတ်အပိုင်းပြု',
    curve_range: 'အသွင်အစိတ်အပိုင်းရှည်ဘက်ထို့ထက်ကြီး',
    curve_range2: 'ပြား၏အသွင်အစိတ်အပိုင်းအားလုံး',
    curveArea: 'အသွင်ဧရိယာ',
    drillSetting: 'ငါး/ခြောက်မျက်နှာတွင်းထွင်းဆက်တင်',
    engravingCuted: 'ဖြတ်စက်ပေါ်ပြုပြီးအပေါက်ချောင်းများငါး/ခြောက်မျက်နှာတွင်းထွင်းတွင်ရှိ',
    engravingCutedSpecial: 'အသွင်ဧရိယာအစိတ်အပိုင်းအားလုံးဖြတ်စက်ပေါ်ပြုပြီးရှိ',
    genCuttingPath: 'ဖြတ်တောက်ချက်ဒေတာဖန်တီးပါ',
    otherCuted: 'အခြားစက်ပြုပြင်ထားအပေါက်ချောင်းများငါး/ခြောက်မျက်နှာတွင်းထွင်းတွင်ရှိ',
    noGen: 'မဖန်တီး',
    genCut: 'ဖန်တီးပြီးပြု',
    genNoCut: 'ဖန်တီးပြီးမပြု',
    cutTip: 'သတိပြု-ဤရွေးချယ်မှုသည်စိတ်ကြိုက်ငါး/ခြောက်မျက်နှာတွင်းထွင်းဖိုင်များတွင်သာသက်ရောက်',
    maxShortSize: 'အများဆုံးတိုတောင်းဘက်အရွယ်',
    maxLongSize: 'အများဆုံးရှည်ဘက်အရွယ်',
    normalSlot: 'ပုံမှန်ချောင်း',
    specialSlot: 'အထူးချောင်း',
    combinSetting: 'ပေါင်းစည်းစက်ဆက်တင်',
    allowShortSize: 'တိုတောင်းဘက်အရွယ်ခွင့်ပြု',
    equipment1: 'စက်တစ်',
    equipment2: 'စက်နှစ်',
    noSameTip: 'သတိပြု-စက်နှစ်ခုတူညီရွေးမရ',
    workRange: 'စက်တစ်ပြုနိုင်သောအပေါက်ချောင်းအကွာအဝေး',
    rangeWarning: 'သတိပြု-သာစက်တစ်ပြုအကွာအဝေးသတ်မှတ်နိုင်၊ စက်တစ်မဟုတ်အကွာအဝေးအားလုံးစက်နှစ်တွင်ပြုမည်၊ သတိထားပါ!',
    deleteWarning: 'ဤထုတ်လုပ်မှုလိုင်းဖျက်ပြီးပြန်မရနိုင်(ဤလိုင်းအောက်ဆက်တင်အားလုံးဖျက်မည်)၊ ဖျက်မည်ကိုအတည်ပြုလား?',
    top: 'ထိပ်',
    inputCheck: '{msg}အနည်းဆုံးသည်အများဆုံးထက်မကြီးနိုင်',
    lockTip: 'ထုတ်လုပ်မှုလိုင်းလော့ချထားပြီး၊ လုပ်ဆောင်ချက်မပြုရ!',
    reNameTip: 'မူရင်းထုတ်လုပ်မှုလိုင်းအမည်ပြင်မရ',
    permissonTip: 'အထောက်အထားသက်တမ်းကုန်ပြီ၊ ကက်ဘိနက်မှဤစာမျက်နှာပြန်ဖွင့်ပါ!',
    permissonErr: 'ဤခွင့်ပြုချက်မရှိသေး၊ အကောင့်ဗားရှင်းမြှင့်ပါ!',
    permissionOneMacErr: 'လက်ရှိအသုံးပြုနိုင်သောတစ်ကိုယ်ရည်စက်ထုတ်လုပ်မှုလိုင်းအရေအတွက်မှာ{idx}ကြောင်း၊ တိုးလိုပါကအရောင်းဝန်ထမ်းနှင့်ဆက်သွယ်ပါ!',
    permissionSawErr: 'ဆောက်ဖြတ်ထွင်းစက်အသုံးပြုခွင့်မရှိ၊ အရောင်းနှင့်ဆက်သွယ်ပြီးပြည့်အလူမီနီယံဆောက်ဖြတ်ဖြည့်ပါယူပြီးသုံးပါ',
    getAuthError: 'စက်ခွင့်ပြုချက်ရယူမှုမအောင်!',
    sawAddNumber: 'လက်ရှိအသုံးပြုနိုင်သောအီလက်ထရွန်းနစ်ဆောထုတ်လုပ်မှုလိုင်းအရေအတွက်ကုန်ပြီ၊ တိုးလိုပါကအရောင်းနှင့်ဆက်သွယ်ပါ!',
    newLine: 'ထုတ်လုပ်မှုလိုင်းအသစ်{idx}',
    deleteCheck: 'အားလုံးဖျက်မရ',
    deving: 'ဖွံ့ဖြိုးဆဲ',
    combinTip: 'အောက်ပါပေါင်းစည်းစက်ဆက်တင်ကိုနှိပ်ပြီးသတ်မှတ်ပါ',
    noUseEquip: 'ပြုပြင်စက်မဖွင့်ရသေး',
    equipmentSelectTip: 'ပေါင်းစည်းစက်တွင်ဖြတ်စက်ရွေးသည့်အခါဖြတ်စက်သည်အီလက်ထရွန်းနစ်ဆောမရွေးနိုင်',
    lineLoading: 'ဒေတာလာနေသည်',
    strenchType: 'ဆွဲဖြောင့်ချောင်းအမျိုးအစား',
    aioProcessTip: 'သင့်သည်တစ်ကိုယ်ရည်စက်ဖွင့်ပြီး၊ ပြုပြင်နည်းမူရင်းသည်ပြားရှေ့အနောက်အပေါက်ချောင်းပြု',
    aioProcessTip2: 'တစ်ကိုယ်ရည်စက်ဖွင့်ပြီးနောက်ထွင်းစက်အပိုင်းတွင်ပြုသောအထူးအပေါက်ချောင်းများ',
    aioProcessTip3: 'သတိပြု-ဤလုပ်ဆောင်ချက်သည် XY ဝင်ရိုးပြောင်းဖွင့်ထားသောထွင်းစက်နှင့်မကိုက်ညီ၊ သတိထားသုံးပါ',
    specialHoleTip: 'သတိပြု-အထက်ပြုပြင်သောအထူးအပေါက်ချောင်းသုံးသည့်အခါအပေါက်ဖောက်နည်းနှင့်ချောင်းဖောက်နည်းကိုတစ်ကြိမ်ဖောက်သတ်မှတ်ပါ',
    specialHoleTip2: 'သတိပြု-အထက်ပြုပြင်သောအထူးအပေါက်ချောင်းသုံးသည့်အခါထွင်းစက်အပေါက်ဖောက်နည်းနှင့်ချောင်းဖောက်နည်းကိုတစ်ကြိမ်ဖောက်သတ်မှတ်ပါ',
    fiveSixNotTake: 'ဤရွေးချယ်မှုငါး/ခြောက်မျက်နှာတွင်းထွင်းမူရင်းပုံစံတွင်မသက်ရောက်',
    onlyFrontSide: 'ရှေ့မျက်နှာသာပြု',
    onlyBackSide: 'အနောက်မျက်နှာသာပြု',
    less: 'ထို့ထက်ငယ်',
    equal: 'ညီမျှ',
    greater: 'ထို့ထက်ကြီး',
    or: 'သို့မဟုတ်',
    and: 'နှင့်',
    bothFrontBack: 'ရှေ့အနောက်နှစ်ဘက်ပြု',
    shareDataErrTip: 'ဤဒေတာကို{operatorPhone}အသုံးပြု၊ ip:{actionIp}',
    restoreParams: 'ပါရာမီတာပြန်ထား',
    loadMore: 'နောက်ထပ်လာမှု',
    currentCombinationEquipment: 'လက်ရှိရွေးထားပေါင်းစည်းစက်ရှိသည့်အခါဖြတ်စက်သည်ဖန်ဖြတ်စက်သို့ပြောင်းခွင့်မရှိ',
    selectEquipmentType: 'စက်အမျိုးအစားရွေးပါ',
    ruleRemark: 'စည်းမျဉ်းမှတ်ချက်',
    remarkPlaceholder: 'ဤစည်းမျဉ်းမည်သည့်ပညာပြုသည်ကိုမှတ်ထားနိုင်သည်၊ မေ့ခြင်းကိုရှောင်ပါ၊ ဖြည့်ပြီးထုတ်လုပ်မှုလိုင်းသိမ်းပြီးသက်ရောက်',
    onlyNoSideHoleSlotSmallPlank: 'ဘေးအပေါက်/ဘေးချောင်းမရှိသောပြားငယ်များသာ'
    },
  cuttingDock: {
    title: 'ဖြတ်တောက်ချိတ်ဆက်',
    autoStockCode: 'အလိုအလျောက်အပေါ်အောက်ပစ္စည်းကုဒ်',
    stationStart: 'အလုပ်ဌာနစတင်',
    stationStartCode1: 'အလုပ်ဌာန၁စတင်ကုဒ်',
    stationStartCode1Placeholder: 'အလုပ်ဌာန၁စတင်ကုဒ်ထည့်ပါ',
    stationStartCode2: 'အလုပ်ဌာန၂စတင်ကုဒ်',
    stationStartCode2Placeholder: 'အလုပ်ဌာန၂စတင်ကုဒ်ထည့်ပါ',
    stationEnd: 'အလုပ်ဌာနပြီး',
    stationEndCode1: 'အလုပ်ဌာန၁ပြီးကုဒ်',
    stationEndCode1Placeholder: 'အလုပ်ဌာန၁ပြီးကုဒ်ထည့်ပါ',
    stationEndCode2: 'အလုပ်ဌာန၂ပြီးကုဒ်',
    stationEndCode2Placeholder: 'အလုပ်ဌာန၂ပြီးကုဒ်ထည့်ပါ',
    frontBackStart: 'ရှေ့အနောက်စတင်',
    frontBackEnd: 'ရှေ့အနောက်ပြီး',
    frontStartCode: 'ရှေ့မျက်နှာစတင်ကုဒ်',
    frontStartCodePlaceholder: 'ရှေ့မျက်နှာစတင်ကုဒ်ထည့်ပါ',
    frontEndCode: 'ရှေ့မျက်နှာပြီးကုဒ်',
    frontEndCodePlaceholder: 'ရှေ့မျက်နှာပြီးကုဒ်ထည့်ပါ',
    backStartCode: 'အနောက်မျက်နှာစတင်ကုဒ်',
    backStartCodePlaceholder: 'အနောက်မျက်နှာစတင်ကုဒ်ထည့်ပါ',
    backEndCode: 'အနောက်မျက်နှာပြီးကုဒ်',
    backEndCodePlaceholder: 'အနောက်မျက်နှာပြီးကုဒ်ထည့်ပါ',
    plankStart: 'ပြားလှန်စတင်',
    plankEnd: 'ပြားလှန်ပြီး',
    plankRollCode1: 'အလုပ်ဌာန၁လှန်ကုဒ်',
    plankRollCode1Placeholder: 'အလုပ်ဌာန၁လှန်ကုဒ်ထည့်ပါ',
    plankRollCode2: 'အလုပ်ဌာန၂လှန်ကုဒ်',
    plankRollCode2Placeholder: 'အလုပ်ဌာန၂လှန်ကုဒ်ထည့်ပါ',
    autoBaitingCode: 'အလိုအလျောက်အောက်ပစ္စည်းကုဒ်',
    autoBaitingCode1: 'အလုပ်ဌာန၁အောက်ပစ္စည်းကုဒ်',
    autoBaitingCode1Placeholder: 'အလုပ်ဌာန၁အောက်ပစ္စည်းကုဒ်ထည့်ပါ',
    autoBaitingCode2: 'အလုပ်ဌာန၂အောက်ပစ္စည်းကုဒ်',
    autoBaitingCode2Placeholder: 'အလုပ်ဌာန၂အောက်ပစ္စည်းကုဒ်ထည့်ပါ',
    thickMarkPermission: 'သင်သည် လက်ရှိတွင် အကြီးပြားအထူအမှတ်အသား ခွင့်ပြုချက်မရှိပါ၊ အသုံးမပြုမီ အရောင်းနှင့် ဆက်သွယ်၍ ဝယ်ယူပါ',
    thickMark: 'မကြီးမြတ်သည်မှားနားချက်',
    preStartEquipment: 'ကြိုတင်စတင်စက်',
    firstKnifePreCode: 'ပထမဓားကြိုတင်စတင်ကုဒ်ကြိုထား',
    secondKnifePreCode: 'ဒုတိယနှင့်နောက်ဓားကြိုတင်စတင်ကုဒ်ကြိုထား',
    rowInsert: 'အတန်းထည့်',
    pumpPause: 'ဗက်ကြူးပမ်ခဏရပ်',
    pumpPauseTip: 'သတိပြု-အလုပ်ဌာနတစ်ခုစက်တွင်ဌာန၁နှင့်၂နှစ်ခုလုံးတူညီသောအလိုအလျောက်အပေါ်ပစ္စည်းကုဒ်နှင့်နှစ်ဘက်ပြုရှေ့မှတ်ချက်ကုဒ်ထည့်ရမည်',
    pumpPause2Tip: 'သတိပြု-အလုပ်ဌာနတစ်ခုစက်တွင်ဌာန၁နှင့်၂နှစ်ခုလုံးတူညီသောဗက်ကြူးပမ်ခဏရပ်ကုဒ်ထည့်ရမည်',
    pumpPauseCode1: 'အလုပ်ဌာန၁ဗက်ကြူးပမ်ခဏရပ်ကုဒ်',
    pumpPauseCode1Placeholder: 'အလုပ်ဌာန၁ဗက်ကြူးပမ်ခဏရပ်ကုဒ်ထည့်ပါ',
    pumpPauseCode2: 'အလုပ်ဌာန၂ဗက်ကြူးပမ်ခဏရပ်ကုဒ်',
    pumpPauseCode2Placeholder: 'အလုပ်ဌာန၂ဗက်ကြူးပမ်ခဏရပ်ကုဒ်ထည့်ပါ',
    annotationCode1: 'အလုပ်ဌာန၁နှစ်ဘက်ပြုရှေ့မှတ်ချက်ကုဒ်',
    annotationCode1Tip: 'အလိုအလျောက်အပေါ်ပစ္စည်းရှေ့မျက်နှာညီညွတ်မှုမတူသောစက်များအတွက်သင့်လျော်',
    annotationCode1Placeholder: 'အလုပ်ဌာန၁နှစ်ဘက်ပြုရှေ့မှတ်ချက်ကုဒ်ထည့်ပါ',
    annotationCode2: 'အလုပ်ဌာန၂နှစ်ဘက်ပြုရှေ့မှတ်ချက်ကုဒ်',
    annotationCode2Placeholder: 'အလုပ်ဌာန၂နှစ်ဘက်ပြုရှေ့မှတ်ချက်ကုဒ်ထည့်ပါ',
    upSpeedTip: 'အပြိုင်အစွန်းအရှိန်မြန်နှုန်းထည့်ပါ',
    cutThickTip: 'အပြိုင်အစွန်းဖြတ်အထူထည့်ပါ',
    sizeErrTip: 'ပြင်ဆင်စာမျက်နှာပုံထုတ်မှုအရွယ်အစားကိုတံဆိပ်စက်တွင်သတ်မှတ်ပါ!',
    offEdgeKnifeDiameter: 'အစွန်းပြင်ဓားအချင်းထည့်ပါ',
    slowDownSpeedTip: 'ထောင့်ဖြတ်လျော့နှေးမှုထည့်သွင်းပါရာမီတာမှား',
    permissionErr: 'လက်ရှိအခမဲ့ဗားရှင်း၊ သိမ်းမရ',
    labellingTempErr: 'တံဆိပ်စက်ပုံစံရွေးပါ',
    autoRollInputTip: 'တံဆိပ်အလိုအလျောက်လည်ဖွင့်ရန်တန်ဖိုးထည့်ရမည်',
    offlineTempFormat: 'လက်ရှိတံဆိပ်စက်ဖိုင်ဖော်မတ်ပယ်ဖျက်ပြီး၊ အတည်ပြုပါ',
    autoStockCode1: 'အလုပ်ဌာန၁အလိုအလျောက်အပေါ်ပစ္စည်းကုဒ်',
    autoStockCode1PlaceHolder: 'အလုပ်ဌာန၁အလိုအလျောက်အပေါ်ပစ္စည်းကုဒ်ထည့်ပါ',
    autoStockCode2PlaceHolder: 'အလုပ်ဌာန၂အလိုအလျောက်အပေါ်ပစ္စည်းကုဒ်ထည့်ပါ',
    autoStockCode2: 'အလုပ်ဌာန၂အလိုအလျောက်အပေါ်ပစ္စည်းကုဒ်',
    pauseCode: 'ခဏရပ်ကုဒ်',
    pauseCodePlaceHolder: 'ခဏရပ်ကုဒ်ထည့်ပါ',
    cuttingToolMaxDepthTip: 'ဓားသိုက်{errKey}ဓားတွင်တစ်ကြိမ်အများဆုံးပြုပြင်အနက်သည်ဓားအရှည်ထက်မကြီးရ',
    cuttingParams: {
      title: 'ဖြတ်တောက်ပါရာမီတာ',
      stationWidth: 'ပြင်သစ်ကြီးအလျား',
      stationWidthTip: 'ပိုလျှံပစ္စည်းကြီးဘုတ်ကိုအသုံးပြုသည့်အခါ အကျယ်ဦးတည်ချက်တွင် သတ်မှတ်ထားသောအရွယ်အစားအကွာအဝေးအတွင်းသာ အသေးဘုတ်များကို စီစဉ်နိုင်သည်',
      holeSlotMainSide: 'အပေါက်ချောင်းစုစည်းမျက်နှာ',
      holeMainSide: 'အပေါက်စုစည်းမျက်နှာ',
      slotMainSide: 'ချောင်းစုစည်းမျက်နှာ',
      workPriority: '(လုပ်ဆောင်ချက်ဦးစားပေး-အထူးအပေါက်ချောင်းပြုမျက်နှာစိတ်ကြိုက်>ဖောက်အပေါက်ချောင်းရှိမျက်နှာထိုပေါ်ဒ်ငယ်ပေါ်မဖောက်ထားအပေါက်ချောင်းလိုက်>အပေါက်ချောင်းခွဲရာတွင်သတ်မှတ်အထူးအပေါက်ချောင်းကြီးပြားရှေ့တွင်ဦးစား>ချောင်းစုမျက်နှာ>အပေါက်စုမျက်နှာ)',
      holeSlotSet: 'ဖောက်အပေါက်ချောင်းပြုဆက်တင်',
      hingeRollWork: 'ဆွဲဖြောင့်နှင့်ချိန်းခွက်အပေါက်ကိုကြီးပြားအနောက်တွင်ပြု',
      followWork: 'ဖောက်အပေါက်ချောင်းရှိမျက်နှာထိုပေါ်ဒ်ငယ်ပေါ်မဖောက်ထားအပေါက်ချောင်းလိုက်',
      autoMatchSide: 'အချိုးကျရှေ့အနောက်အပေါက်ချောင်းခွဲဝေ',
      backHSRate: 'အနောက်မျက်နှာအပေါက်ချောင်းရာခိုင်နှုန်း',
      matchTip: 'အမြှီးပြား, အသွင်တွက်ချက်လျှောက်ထုံးဖွင့်သည့်အခါ သို့မဟုတ် ပုံစံကိုက်ညီခြင်းတွင် ဤဆက်တင်မသက်ရောက်',
      specIalHoleAndSlotSurface: 'အထူးအပေါက်ချောင်းပြုမျက်နှာစိတ်ကြိုက်',
      specialRuleTip: 'အထူးအပေါက်ချောင်းရွေးပါ',
      specialSlotsHoles: 'အပေါက်ချောင်းအမျိုးအစား',
      holeType: 'အပေါက်အမျိုးအစား',
      specialRules: 'စည်းမျဉ်း',
      normalHole: 'ပုံမှန်အပေါက်',
      normalSlot: 'ပုံမှန်ချောင်း',
      holeDiam: 'အပေါက်အချင်း',
      slotLongSide: 'ချောင်းရှည်ဘက်',
      slotShortSide: 'ချောင်းတိုဘက်',
      FixedmachSurface: 'ပုံသေပြုပြင်မျက်နှာ',
      deleteRuleTip: 'ဤစည်းမျဉ်းဖျက်မလား',
      blankFront: 'ကြီးပြားရှေ့မျက်နှာ',
      blankBack: 'ကြီးပြားအနောက်မျက်နှာ',
      addRules: 'စည်းမျဉ်းထည့်',
      addRulesTip: 'တူညီပေါ်ဒ်ငယ်တစ်ခုတည်းတွင်စည်းမျဉ်းများစွာထိသည့်အခါအစီအစဉ်အရှိဆုံးစည်းမျဉ်းသက်ရောက်၊ အတန်းဆွဲပြောင်းနိုင်သည်',
      highGlossSetting: 'အမြှီးပြားဆက်တင်',
      heighGlossFront: 'ပြင်ဆင်စာမျက်နှာတွင်ပေါ်ဒ်ငယ်အမြှီးမျက်နှာကြီးပြားပေါ်စီ',
      highGlossPlankNoRotate: 'အမြှီးပြားဆက်တင်မှားနေသည်',
      highGlossAutoRoll: 'အနောက်မျက်နှာအပေါက်ချောင်းရှိကြီးပြားသာအလိုအလျောက်လှန်',
      highGlossAutoRollTip: "<span class='color-o-4'>(ဖွင့်ပြီးနောက်အနောက်မျက်နှာအပေါက်ချောင်းရှိကြီးပြားသာပြင်ဆင်စာတွင်အလိုအလျောက်လှန်ပြီးတစ်မျက်နှာပြားဖြစ်မည်)</span>",
      customHighGlossReverse: 'အမြှီးမျက်နှာလှန်ပြားထား',
      sideSlotPut: 'အစွန်းပြားချောင်းထား',
      optimize: 'လုပ်ဆောင်ချက်အကောင်းဆုံးဖြစ်နေသည်',
      sysDefault: 'စနစ်မူရင်း',
      plankInSide: 'ကြီးပြားအတွင်းဘက်',
      plankOutSide: 'ကြီးပြားအပြင်ဘက်',
      specialNotWork: 'ဤလုပ်ဆောင်ချက်အသွင်းပြားတွင်မသက်ရောက်',
      commonSide: 'အပြိုင်အစွန်းဖြတ်',
      commonSetting: 'အပြိုင်အစွန်းဆက်တင်',
      plankThickRange: 'ပြားအထူသည်ထို့ထက်ငယ်သို့မဟုတ်ညီမျှ',
      useCommonSide: 'သည့်အခါအပြိုင်အစွန်းဖြတ်သုံး',
      zeroTip: 'ပြင်ဆင်ခြားနားချက်ကိုလက်ဖြင့်၀သို့ပြောင်းပါ၊ ဖြတ်ပြီးအစွန်းသို့ပြုသည့်အခါဓားမြှောက်ကျော်ပါ၊ ဤလုပ်ဆောင်ချက်ဖွင့်ပြီးနောက်ဓားစောင်းမပြုပါနှင့်၊ သတိပြုပါ!',
      useTip: 'ဤလုပ်ဆောင်ချက်ဖွင့်ပြီးနောက်ဓားစောင်းမပြုပါနှင့်၊ သတိပြုပါ!',
      commonSpeed: 'အပြိုင်အစွန်းအရှိန်မြန်',
      highSpeed: 'အမြန်ပွတ်မီးဖြတ်အမြန်နှုန်း',
      min: 'မိနစ်',
      notWorkTip: 'ပြားပြုသည့်အခါအပြိုင်အစွန်းဖြတ်ပြည့်မီသည့်အခါအပြိုင်အစွန်းအရှိန်မသက်ရောက်',
      changeStartPoint: 'နှစ်ဌာနအစပြုအမှတ်ပြောင်း',
      changeStartPointTip: 'နှစ်ဌာနအစပြုအမှတ်ပြောင်းဖွင့်ပြီးနောက် XY ဝင်ရိုးပြောင်းလုပ်ဆောင်ချက်နှင့်မကိုက်ညီ၊ သတိထားသုံးပါ',
      flatOffset: 'စက်ပြင်ညီရွေ့',
      xRowChange: 'X ဝင်ရိုးကိုဩဒီနိတ်အခြေပြောင်း',
      bigplankPointChange: 'ကြီးပြားအနောက်မျက်နှာကိုဩဒီနိတ်အခြေပြောင်း',
      reverseXRowChange: 'X ကိုဩဒီနိတ်ပြောင်း',
      changebigplankPointTips: 'ဤလုပ်ဆောင်ချက်ဖွင့်ပြီးနောက် XY ဝင်ရိုးပြောင်းနှင့်နှစ်ဌာနအစပြုအမှတ်ပြောင်းနှင့်မကိုက်ညီ၊ သတိထားသုံးပါ',
      reverseYRowChange: 'Y ကိုဩဒီနိတ်ပြောင်း',
      plankMirrorTip: 'ဖြတ်စက်ပေါ်ပြုထားသောပြားများမှန်တွင်းပြုသည့်အခါဤလုပ်ဆောင်ချက်သုံးပါ',
      notSameSize: 'နှစ်ဌာနစားပွဲမျက်နှာအရွယ်မတူ',
      maxSize1: 'အလုပ်ဌာန၁အများဆုံးအရွယ်',
      notSameSizeTip: 'နှစ်ဌာနစားပွဲအရွယ်မတူဖွင့်ပြီးနောက်နှစ်ဌာနဖိုင်ပေါင်းခြင်းနှင့်မကိုက်ညီ၊ သတိထားသုံးပါ',
      maxSize2: 'အလုပ်ဌာန၂အများဆုံးအရွယ်',
      autoSelectTip: 'နှစ်ဌာနစက်နှစ်စားပွဲအရွယ်မတူသည့်အခါဤလုပ်ဆောင်ချက်သုံးပါကသက်ဆိုင်ရာဌာနကြီးပြားပြုရန်အလိုအလျောက်ရွေးမည်',
      bigFlatLimit: 'ကြီးဌာနသာကြီးပြားပြုသည်-ငယ်ဌာနမပြုနိုင်သောကြီးပြား:',
      surplusSetting: 'အကြွင်းဆက်တင်',
      surplusPosition: 'အကြွင်းထားရာနေရာ',
      cutHoleWay: 'ဖြတ်ဖောက်အပေါက်နည်း',
      knifeFlat: 'ဓားအခြေပြင်မျက်နှာ',
      flat: 'စားပွဲမျက်နှာ',
      plankFlat: 'ကြီးပြားမျက်နှာ',
      freeHeightZ: 'အချည်းနှီးZ အမြင့်',
      relativeHeight: 'ကြီးပြားအပေါ်မျက်နှာအမြင့်နှင့်နှိုင်းရှည်',
      cutDeepZ: 'ဖြတ်ဖောက်Z အနက်',
      cutDeepH: 'အပေါက်ဖောက်နည်း',
      setDisableDoubleSidedThroughHole: 'နှစ်ဘက်ဖောက်နှစ်ကြိမ်လှန်ဖောက်မသက်ရောက်သတ်မှတ်',
      addHolesToRulesDisableDoubleSided: 'အောက်ပါစည်းမျဉ်းသို့ သက်ဆိုင်ရာ ချိတ်ဆက်ပေါက် (ပြည့်စုံစွာဖောက်ထားသော အပေါက်) ထည့်ပြီးနောက် လှန်နှစ်ကြိမ်ဖောက်ခြင်း မသက်ရောက်ပါ',
      onceThrough: 'တစ်ကြိမ်ဖောက်',
      rollThrough: 'လှန်နှစ်ကြိမ်ဖောက်',
      cutDeepS: 'ချောင်းဖောက်နည်း',
      plankCutDirection: 'ပေါ်ဒ်ငယ်ဖြတ်ဦးတည်ချက်',
      clockDirSwitch: 'စိတ်ကြိုက်မီးအပေါက်/ချောင်းနှင့်အတွင်းအသွင်းဖြတ်ဦးတည်ချက်ပြောင်း',
      millHoleSlotDir: 'မီးအပေါက်ချောင်းဦးတည်ချက်',
      millInternalCurveDir: 'အတွင်းအသွင်းဖြတ်ဦးတည်ချက်',
      sDirection: 'နာရီလက်တံဦးတည်ချက်',
      nDirection: 'နာရီလက်တံပြောင်းပြန်',
      curveReplenish: 'အဝိုင်းထည့်ချက်ဖြတ်ချွန်းပြား',
      curveReplenishTip: 'ချွန်းပြားဖြတ်သည့်အခါအစွန်းညီပေါ်လာပါကဤလုပ်ဆောင်ချက်ရွေးနိုင်',
      noGen: 'G17/G18/G19 မျက်နှာညွှန်ကြားချက်မဖန်တီး',
      arcInstruction: 'အဝိုင်းထည့်ချက်ညွှန်ကြားချက်ရှေ့ဆက်',
      example: 'ဥပမာ',
      arcExample: 'G17G03 X100 Y100',
      curveCutTip: 'အဝိုင်းဖြတ်ခြင်းကို I၊ J ဖြင့်ပြ',
      coverRate: 'မီးချောင်းဖြတ်သည့်အခါဖြတ်ထပ်နှုန်း:',
      roughTip: 'ဓားမီးချောင်းသည့်အခါချောင်းအတွင်းအကြွင်းမျက်နှာရှိပါကဤလုပ်ဆောင်ချက်သုံးပါ',
      clearCurve: 'မီးချောင်းသည့်အခါမဆွဲထားသောချောင်းများကိုအဝိုင်းထောင့်အလိုအလျောက်ရှင်း:',
      curveUseTip: 'မီးချောင်းသည့်အခါအဝိုင်းထောင့်ရှင်းရန်ဤလုပ်ဆောင်ချက်ရွေးပါ၊ ဤလုပ်ဆောင်ချက်ချိတ်ဆက်ပစ္စည်းတွင်မသက်ရောက်',
      slotCutWay: 'မီးချောင်းဓားသွားနည်း',
      outToIn: 'အပြင်မှအတွင်းသို့မီးချောင်း',
      inToOut: 'အတွင်းမှအပြင်သို့မီးချောင်း',
      zShapProcess: 'ချောင်းဖောက်အပေါ်အောက်Z ပုံစံမီးချောင်း',
      zShapProcessTip: 'ရှေ့အနောက်ဆွဲဖောက်ချောင်းမီးချောင်းတွင်သာသက်ရောက်၊ ဓားလမ်းထပ်နှုန်းမူရင်းဓားအချင်းဝ',
      zSlotCuttingOverlapRate: 'Z ပုံစံမီးချောင်းဖြတ်ထပ်နှုန်း',
      zSlotCuttingOverlapRateTip: 'လက်ရှိထပ်နှုန်းကပြုပြင်အမြန်နှုန်းနှေးစေနိုင်၊ စက်စမ်းပြီးနောက်ပြုပါ။',
      slotWorkLimit: '(မီးချောင်းဓားသွားအလွှာအရေအတွက်>1 သည့်အခါသာသက်ရောက်)',
      minKnifeChange: 'ဖြတ်သည့်အခါဓားစောင်းချအမြန်နှုန်းအကောင်းဆုံးဖြစ်အောင်',
      preventBreakage: 'အနားချောင်းခြားသားပြားကျိုးခြင်းကာကွယ်',
      preventBreakageTip: 'ဤဆက်တင်သည် အစီအစဉ်ချစဉ်တွင် ရှေ့မျက်နှာရှိ ချောင်းများအတွက်သာ သက်ရောက်ပြီး "အထူးအပေါက်ချောင်းပြုမျက်နှာစိတ်ကြိုက်" လုပ်ဆောင်ချက်နှင့် ပူးတွဲအသုံးပြုနိုင်သည်',
      preventBreakageTip1: 'ချောင်းသည် ပျဉ်ပြားအစွန်းနှင့် အလွန်နီးကပ်နေပါက ဖြတ်တောက်စဉ် ထိုနေရာရှိ ခွဲတန်း (ကျန်ရှိသော ချိတ်ဆက်အပိုင်း) သည် ဖိအားစုစည်းမှုကြောင့် အလွယ်တကူ ကျိုးပျက်နိုင်သော အခြေအနေကို ဖြေရှင်းနိုင်သည်',
      preventBreakageDistance: 'ပျဉ်ပြားအစွန်းမှအကွာအဝေး',
      preventBreakageLength: 'အစွန်းနီးအပိုင်းအရှည်',
      preventBreakageSlot: 'ချောင်း',
      preventBreakageCutDeep: 'ပထမအကြိမ်ဖြတ်အနက်',
      workSpeedOp: 'ပြုပြင်အမြန်နှုန်းအကောင်းဆုံးဖြစ်အောင်',
      obliqueCut: 'ဖြတ်သည့်အခါဓားစောင်းချ',
      obliqueCutTip: 'ဓားစောင်းအမြန်နှုန်းအကောင်းဆုံးဖြစ်အောင်',
      obliqueThickLabel: 'စိတ်ကြိုက်ဓားစောင်းအကျိုးသက်ရောက်သောပျဉ်အထူ',
      obliqueThick: 'ဓားစောင်းအမြန်နှုန်းအကောင်းဆုံးဖြစ်အောင်',
      backObliqueThick: 'ဓားစောင်းအမြန်နှုန်းအကောင်းဆုံးဖြစ်အောင်',
      effectiveThickness: 'အနှုန်းအကောင်းဆုံးဖြစ်အောင်',
      effectiveThicknessTip: 'အနှုန်းအကောင်းဆုံးဖြစ်အောင်မှားနိုင်ပါသည်, ရိုက်ထည့်ပါ!',
      effectiveThicknessDuplicateTip: 'အနှုန်းအကောင်းဆုံးဖြစ်အောင်ထံမဖြစ်ရပါ၊ ပြင်ဆင်ပါ',
      obliqueCutData: 'ဓားစောင်းအကွာအဝေး',
      backOblique: 'အနောက်မျက်နှာအစွန်းပြင်ဓားစောင်းချ',
      obliqueSpeed: 'ဓားစောင်းအမြန်နှုန်း',
      obliqueSpeedTip: 'ဓားစောင်းအမြန်နှုန်း',
      arcSpeed: 'မျဉ်းကွေးပြုပြင်အမြန်နှုန်း',
      cuttingPreDistance: 'ဓားချမတိုင်မီအကွာအဝေး',
      backKnife: 'ဖြတ်ဓားကောက်နှေးမှု',
      openKnifeSpeed: 'ဓားကောက်အမြန်နှုန်း',
      retractionCompensation: 'ဖြတ်ဓားကောက်အကွာအဝေးပြန်လည်ထူထောင်',
      retractionCompensationTip: 'အများဆုံးတန်ဖိုး၂၀',
      cutCornerSlow: 'ဖြတ်ထောင့်နှေးမှု',
      addRow: 'အသစ်ထည့်',
      bettwenDistance: 'ထောင့်ရှေ့နောက်အကွာအဝေး',
      cuttingSpeed: 'ဖြတ်အမြန်နှုန်း',
      stepCutting: 'အလွှာခွဲဖြတ်',
      splitSlot: 'ချောင်းနှစ်ကြိမ်ဖြတ်',
      splitPlank: 'ပေါ်ဒ်ငယ်နှစ်ကြိမ်ဖြတ်',
      splitPlank2: 'ပေါ်ဒ်ငယ်နှစ်ကြိမ်ဖြတ်',
      minSafeThick: 'အထူသည်ထို့ထက်ကြီး',
      splitPlankTip: '(အသွင်းပြားတွင်မသက်ရောက်)',
      splitPlankTip2: '(မကောင်းမွန်သည်: ကံပြန်လည်ချိန်ဆက်မှု)',
      cutPlankMethod: 'ပေါ်ဒ်ငယ်နှစ်ကြိမ်ဖြတ်',
      cutPlankMethodTip: 'လေးနှစ်ကြိမ်ဖြတ်',
      cutPlankMethodTip2: 'နောက်ဆုံးနှစ်ကြိမ်ဖြတ်',
      specialShapCut: 'အသွင်းပြားနှစ်ကြိမ်ဖြတ်',
      specialShapCutTip: '(ဖွင့်ပြီးနောက်အသွင်းပြားအားလုံးနှစ်ကြိမ်ဖြတ်မည်)',
      bridgeRetention: 'တံတားချိတ်ဆက် အမှတ်ထားနည်း',
      bridgeRetentionTip: '(မှတ်ချက်: 1. ဤလုပ်ဆောင်ချက်သည် ပြင်ပအသွင်းပြားများကို ယာယီမပံ့ပိုးပါ။ 2. ဓားစောင်းချခြင်းကို မပံ့ပိုးပါ။ 3. ချိတ်ဆက်တံတားထုတ်လုပ်မည့် ပြားအနည်းဆုံးအရွယ်အစားမှာ 30mm ဖြစ်သည်။)',
      bridgeRetentionDesc: 'ဘုတ်အတွင်း အခေါင်းပေါက်များများရှိ၍ ဖြတ်လမ်းကြောင်းအား ထောက်ပံ့မှုမလုံလောက်သည့်အခါ ဘုတ်တုန်ခါခြင်း သို့မဟုတ် ရွေ့လျားခြင်းကို ကူညီဖြေရှင်းပေးသည်။',
      bridgePunchArea: 'ထိုးဖောက်ထားသောအပိုင်းသည် စုစုပေါင်းဧရိယာထက်ကျော်လွန်',
      bridgeSize: 'ချိတ်ဆက်တံတားအရွယ်အစား',
      bridgeGenMethod: 'ဖန်တီးပုံစံ',
      bridgeAddTip: 'အများဆုံး ၁၀ ခု ထည့်နိုင်သည်',
      bridgeCount: 'ချိတ်ဆက်တံတားအရေအတွက်',
      bridgePlankLength: 'ဘုတ်အရှည် (L)',
      maxWH: 'အရှည်သို့မဟုတ်အကျယ်သည်ထို့ထက်ငယ်',
      areaLimit: 'နှင့်ဧရိယာသည်ထို့ထက်ငယ်',
      secondDeep: 'ဒုတိယဖြတ်အနက်',
      splitPlankThickSetting: 'ဖြတ်တောက်အလွှာခွဲဖြတ်ဆက်တင်',
      saveCustomSpeedTip: 'ပြုပြင်အမြန်နှုန်းဗလာမရ',
      saveLayeredCuttingTip: 'ဖြတ်တောက်အလွှာခွဲဖြတ်သုံးလွှာစုစုပေါင်းပြားအထူနှင့်ညီရမည်',
      saveLayeredRepeatTip: 'တူညီပစ္စည်းအမြှီးအထူတွင်မတူညီအလွှာဒေတာမသတ်မှတ်ရန်အကြံပြု၊ ပိုဒေတာဖျက်ပါ!',
      splitPlankThick: 'မတူညီပြားအထူအလွှာခွဲဖြတ်',
      movePlankSetting: 'ပြားမပြေးအောင်ဆက်တင်',
      newCutSequence: 'ဖြတ်အယ်လ်ဂိုရီသမ်အသစ်',
      newCutSequenceText: 'မူရင်းကြီးပြားဗဟိုဗက်ကြူးစုပ်အားအပြင်းဆုံး၊ ဤနေရာပေါ်ဒ်ငယ်နောက်ဆုံးဖြတ်',
      positionTip: 'သက်ဆိုင်ရာနေရာကိုနှိပ်ပြီးရွေးနိုင်',
      suctionPosition: 'ဗက်ကြူးပြင်းစုပ်နေရာ',
      strongArea: 'ပြင်းစုပ်ဧရိယာ',
      minSuctionPlank: 'အနည်းဆုံးစုပ်ထားနိုင်ပြား',
      safeWidth: 'အကျယ်',
      safeHeight: 'အရှည်',
      safeTip: 'စုပ်မထားနိုင်ပြားကိုအရင်ဖြတ်',
      scattered_layout: 'ပေါ်ဒ်ငယ်ပြန့်ကျဲပြင်ဆင်',
      lastCutPointEnable: 'ကြီးမားသောဘုတ်ပေါ်ရှိ နောက်ဆုံးဖြတ်ရေးသေးငယ်သောဘုတ်၏ ဖြတ်ရေးအစက် စိတ်ကြိုက်ချိန်ညှိ',
      lastCutPointEnableTip: 'ဖွင့်လျှင်၊ ကြီးမားသောဘုတ်တိုင်းပေါ်ရှိ နောက်ဆုံးဖြတ်ရေးသေးငယ်သောဘုတ်၏ ဖြတ်ရေးအစက်သည် သတ်မှတ်ထားသောအစက်နေရာအရ ဖြစ်ပေါ်လာမည်',
      lastCutPoint: 'ဖြတ်ရေးအစက်တည်နေရာ',
      lastCutPointTip: 'ဖွင့်လျှင်၊ ကြီးမားသောဘုတ်တိုင်းပေါ်ရှိ နောက်ဆုံးဖြတ်ရေးသေးငယ်သောဘုတ်သည် ဤဖြတ်ရေးအစက်ကို အသုံးပြuilderွာမည်',
      leftTop: 'ဘယ်အပေါ်',
      rightTop: 'ညာအပေါ်',
      leftBottom: 'ဘယ်အောက်',
      rightBottom: 'ညာအောက်',
      specifyTheMaterial: 'ပစ္စည်းသတ်မှတ်',
      shapeSecondCutenable: 'အသွင်းပြားဒုတိယဖြတ်',
      addMaterial: 'ပစ္စည်းထည့်',
      plankMaterial: 'ပြားပစ္စည်း',
      specifyTheMaterialTip: 'ဖွင့်ပြီးနောက်ဇယားပစ္စည်းနှင့်ပြည့်မီပြားများသာဒုတိယဖြတ်သက်ရောက်',
      dispersePaibanTipOne: 'ဖွင့်ပြီးနောက်ကြီးပြားတစ်ချပ်တွင်အနည်းဆုံးစုပ်ထားနိုင်အရွယ်ပြည့်မီပြားတစ်ချပ်စီစီမည်',
      dispersePaibanTipTwo: '၂、သုံးပြီးနောက်ကြီးပြားအရေအတွက်တိုးနိုင်သတိပြုပါ',
      totalThickLimit: 'သုံးလွှာဖြတ်စုစုပေါင်းပြားအထူနှင့်ညီရမည်',
      offsetFollowStep: 'အစွန်းပြင်သည်အလွှာခွဲဖြတ်ကိုလိုက်',
      longPlankTip1: '၁、ဤလုပ်ဆောင်ချက်ဖွင့်/ပိတ်ပြီးနောက်သမိုင်းတွင် သိမ်းထားသော ပြင်ဆင်မှတ်တမ်းများကို NC ဆွဲသည့်အခါ ပြန်ပြင်ဆင်ရမည်',
      longPlankTip2: '၂、ဤလုပ်ဆောင်ချက်ဖွင့်ပြီးနောက်ဖြတ်တောက်ချိတ်ဆက်-ဗက်ကြူးပမ်ခဏရပ်တွင်ဗက်ကြူးပမ်ခဏရပ်ကုဒ်သတ်မှတ်ရမည်၊ မဟုတ်ရှည်ပြားဖြတ်ကွေးမရ',
      longPlankTip3: '၃、အောက်တွင်ဖွင့်ထားသော စစ်ထုတ်မှုအခြေအနေများကို အဆင့်လိုက် စနစ်တကျ စစ်ဆေးသည်၊ ယခင်အဆင့်စစ်ထုတ်မှုအခြေအနေများနှင့် ကိုက်ညီသည့်ပြားများသာ နောက်အဆင့်စစ်ထုတ်မှုအခြေအနေသို့ ဝင်ရောက်စိစစ်ခံရသည်။',
      secondCutting: 'ဒုတိယဖြတ်ပစ်မှတ်',
      normalPlank: 'ပုံမှန်ပြား',
      normalPlankTip: 'ပုံမှန်ပြား-ကက်ဘိနက်အတွင်းအလျားလိုက်ထောင်လိုက်ကား၊ ဖြတ်တောက်စာရင်းတွင်တိုက်ရိုက်ထည့်ထားပြား၊ ကက်ဘိနတံခါးမပါ',
      designatedTarget: 'သတ်မှတ်အရာဝတ္ထု',
      filterLevel1Label: 'အဆင့်တစ်စစ်ထုတ်',
      filterLevel1Category: 'ပြားအမျိုးအစား',
      filterLevel2Label: 'အဆင့်နှစ်စစ်ထုတ်',
      filterLevel2Category: 'အရွယ်အစားကန့်သတ်',
      filterLevel3Label: 'အဆင့်သုံးစစ်ထုတ်',
      filterLevel3Category: 'အခြား',
      specifiedBoardForceEnable: 'အရွယ်အစား/အခြားစစ်ထုတ်မှုကို လျစ်လျူရှု၊ အတင်းဖွင့်',
      curveMaterialFilterTip: '(「ပုံသဏ္ဌာန်မမှန်ပြား」ရွေးပြီးနောက် ပစ္စည်းစစ်ထုတ်မီ ပုံသဏ္ဌာန်မမှန်ပြားဖြစ်ရမည်)',
      cuttingSettings: 'ဖြတ်သတ်မှုဆက်တင်',
      plankSizeLimitSuffix: ' ပြား',
      specifiedBoard: 'ပြားအမည်သတ်မှတ်ဖြတ်',
      specifiedBoardTip: 'ဖွင့်ပြီးပြားအမည်တွင်အောက်ထည့်ထားပြားအမည်ပါသည့်အခါဒုတိယဖြတ်သက်ရောက်',
      addPlankName: 'ပြားအမည်ထည့်',
      plankNameEmpty: 'ပြားအမည်ဗလာမရ၊ ထည့်ပါ',
      plankNameRequired: 'အနည်းဆုံးပြားအမည်တစ်ခုထည့်ပါ',
      plankLongLimit: 'ရှည်ပြားရှည်ဘက်ကျော်သည့်အခါ',
      plankShortLimit: 'တိုဘက်ကျော်',
      cuttingSplit: 'နှစ်ကြိမ်ခွဲဖြတ်',
      longExpand: 'ပထမဖြတ်ထပ်မံ-ရှည်ဘက်ထပ်မံ',
      firstExpand: 'ပထမဖြတ်ထပ်မံ',
      longExpandTip: 'ရှည်ဘက်ထပ်မံ',
      longLimit: 'ရှည်ဘက်ကျော်',
      cuttingSplitTip: 'ရှည်ပြားနှစ်ကြိမ်ဖြတ်အခြေအနေ',
      shortExpand: 'တိုဘက်ထပ်မံ',
      expandTip: 'ရှည်/တိုဘက်အရွယ်တစ်ခုစီ x mm တိုး၊ အသွင်းရှည်ပြားရှည်တိုထပ်မံနှစ်ခုလုံးရှည်ဘက်ထပ်မံတန်ဖိုး',
      pumpOffWay: 'ဗက်ကြူးပိတ်နည်း',
      afterOnePlank: 'ရှည်ပြားတစ်ချပ်ဖြတ်ပြီးနောက်',
      afterAllPlank: 'ကြီးပြားတစ်ချပ်လုံးဖြတ်ပြီးနောက်',
      numberFixed: 'ဒသမနေရာထားရှိသည့်အရေအတွက်',
      bufferCode: 'ဓားချချောမောညွှန်ကြားချက်ဆက်တင်',
      layoutGap: 'ပြင်ဆင်ခြားနားချက်ဆက်တင်',
      layoutGapTip: 'သတိပြု-ပြင်ဆင်ခြားနားချက်၀သတ်မှတ်ပါကပြင်ဆင်ထပ်နိုင်သည်',
      wasteCutting: 'အကြွင်းအလိုအလျောက်ဖြတ်',
      zkPointCustomize: 'Z ချိန်းစောင်းအပေါက်ပြုလည်ခြင်းအခြေအမှတ်စိတ်ကြိုက်',
      sawSetting: 'ဆောက်ဖြတ်ဆက်တင်',
      cuttingLimit: 'ဖြတ်အရွယ်သည်ထို့ထက်ကြီး',
      waste: 'အကြွင်း',
      wasteSizeLimit: 'အနည်းဆုံးအရွယ်၁၀၀mm ထက်မငယ်ရ',
      topLeft: 'ဘယ်၊ အပေါ်',
      topLeftD: 'ဘယ်အပေါ်ထောင့်',
      bottomLeft: 'ဘယ်၊ အောက်',
      bottomLeftD: 'ဘယ်အောက်ထောင့်',
      topRight: 'ညာ၊ အပေါ်',
      topRightD: 'ညာအပေါ်ထောင့်',
      bottomRight: 'ညာ၊ အောက်',
      bottomRightD: 'ညာအောက်ထောင့်',
      firstTime: 'ပထမကြိမ်',
      secondTime: 'ဒုတိယကြိမ်',
      thirdTime: 'တတိယကြိမ်',
      startCutting: 'ဖြတ်စတင်',
      thickRange: 'အထူ ≥',
      longCut: 'ရှည်ပြားပြု',
      edgeSetting: 'အစွန်းပြင်ဆက်တင်',
      cuttingOrder: 'ဖြတ်အစဉ်:',
      cuttingOrderTip: 'ဤနည်းတွင်ပြားပြေးအန္တရာယ်ရှိ၊ သတိထားသုံးပါ',
      plankFirst: 'ပေါ်ဒ်ငယ်အရင်ဖြတ်',
      wasteFirst: 'အကြွင်းအရင်ဖြတ်',
      offTip: 'ပိတ်သည့်အခါဖြတ်ပါရာမီတာအစွန်းပြင်ဆက်တင်ကိုလိုက်မည်',
      edgeCutDirection: 'အစွန်းပြင်ဦးတည်ချက်',
      lGapTip: 'L အသွင်းအကြွင်းကြီးပြားချိုင့်ထားနေရာကိုတည်နေရာဆီလင်ဒါထောင့်ချိုးဦးတည်ချက်တွင်အလိုအလျောက်ညှိ၊ အမြှီးအကြွင်းကြီးပြားမပါ၊ xy ဝင်ရိုးပြောင်းနှင့်မကိုက်ညီ',
      cylinderDir: 'တည်နေရာဆီလင်ဒါဦးတည်ချက်',
      onlyLong: 'ရှည်ဘက်သာပြင်',
      backCutOrder: 'အနောက်မျက်နှာအစွန်းပြင်အစဉ်',
      backFirst: 'အနောက်မျက်နှာအစပြင်ပြန်',
      backSecond: 'အနောက်မျက်နှာအပေါက်ချောင်းပြုပြီးနောက်အစွန်းပြင်',
      frontReCut: 'ရှေ့မျက်နှာပြန်ပြင်',
      frontReCutTip: 'တည်နေရာဆီလင်ဒါအစွန်းချောအောင်လုပ်၊ မှတ်တိုင်မရအောင်',
      useNewCut: 'အစွန်းပြင်စည်းမျဉ်းအသစ်ဖွင့်',
      newCutTip: 'နှစ်ဘက်ပြုကြီးပြားရှေ့မျက်နှာတွင်အစွန်းပြင်အရွယ်တစ်ခုထပ်ပြင်သည့်အခါသုံးပါ',
      fixedTip: 'သတိပြု-ထားရှိသည့်နေရာသည်၀သို့မဟုတ်၁ပါကပြင်ဆင်ထပ်နိုင်သည်',
      cuttingSlow: 'ဖြတ်ဖောက်သည်းပြားထဲသို့ တားဆီးခြင်း',
      holeSlow: 'သော့ချိတ်ချိတ်သည်ပြားထဲသို့ တားဆီးခြင်း',
      slotSlow: 'အကူဝင်/မီးလ်ချိတ်/မီးလ်အကူဝင် ပြားထဲသို့ တားဆီးခြင်း',
      slowCode: 'တားဆီးချက်များအသုံးပြုခြင်း',
      code: 'ညွှန်ကြားချက်',
      bufferOffset: 'ပြားထဲသို့ တားဆီးခြင်းအရွယ်အစားကို ပြောင်းလဲခြင်း',
      zkRotatePoint: 'လည်ပတ်ရည်ညွှန်းအမှတ်',
      zkRotateDir: 'လည်ပတ်ထောင့်တိုးမြှင့်ခြင်းဦးတည်ချက်',
      restSizeLimit: 'ကျန်ရှိအရွယ်အစားထက်နည်းသည်',
      useSaw: 'ဆားကြိတ်ဓားသုံးပါ',
      unGenSawPath: 'အလျားလိုက်ဆားကြိတ်လမ်းမဖြစ်စေရ',
      suitMachine: 'အလူမီနီယမ်အပြည့်ပေါင်းချောင်းပြားပြုပြင်ခြင်းနှင့်ကိုက်ညီသည်',
      plankBack: 'ကြီးမားသောပြားနောက်ဘက်',
      plankLeft: 'ကြီးမားသောပြားဘယ်ဘက်',
      plankRight: 'ကြီးမားသောပြားညာဘက်',
      plankFront: 'ကြီးမားသောပြားရှေ့ဘက်',
      frontSide: 'ရှေ့ဘက်',
      backSide: 'နောက်ဘက်',
      rightSide: 'ညာဘက်',
      leftSide: 'ဘယ်ဘက်',
      singleMachineLimit: 'တစ်ဖက်သားပြားရှေ့တွင်အစွန်းညှိလမ်းဖြစ်စေပြီးဦးစွာအစွန်းညှိပါ',
      singleMachineLimitTip: 'ဤလုပ်ဆောင်ချက်သည်စနစ်တပ်စက်သို့မဟုတ်ဆားကြိတ်ဖြတ်ခြင်းနှင့်မသက်ဆိုင်ပါ',
      setBatchPositionWaring: 'အကြံပြုချက်: ဖြတ်ချက်အမှတ်မုဒ်ပြင်ဆင်ခြင်းပယ်ဖျက်လိုပါကညာဘက်ရှိဖြတ်ချက်အမှတ်ပြင်ဆင်ခလုတ်ကိုဖြည်ပါ',
      setBatchPosition: 'ဖြတ်ချက်အမှတ်များအစုလိုက်ပြင်ဆင်ပါ',
      setBatchPositionAs: 'ဖြတ်ချက်ဦးတည်ချက်ပြင်ဆင်ပါ:',
      activeBatchPosition: 'ပြားငယ် {activePartCount}ချပ်ရွေးချယ်ပြီးပါပြီ',
      specialFrontSide: 'အပိုင်းအခြားသတ်မှတ်ထားသောအထူးအခေါင်းများကိုကြီးမားသောပြားရှေ့တွင်ဦးစားပေးသည်',
      rollCountTip: 'ထွင်းထုစက်ဖြင့်အမှန်တကယ်ပြုပြင်မှုအရပြားလှန်အရေအတွက်တွက်ချက်ပါ',
      specialFrontSideTip: 'အပိုင်းအခြားတွင်ကြီးမားသောပြားရှေ့တွင်အထူးအခေါင်းဦးစားပေးခြင်းသို့မဟုတ်အပိုင်းအခြားဖွင့်ပြီးထွင်းထုစက်တွင်အနောက်ဘက်အခေါင်းပြုပြင်မှုအရလှန်အရေအတွက်တွက်ချက်ခြင်းဖွင့်ထားသောကြောင့်လက်ရှိထုတ်လုပ်မှုလိုင်းပြောင်းခြင်းမပံ့ပိုးပါ',
      doubleTrim: 'နှစ်ဖက်ပြားအစွန်းညှိခြင်း',
      trim: 'အစွန်းညှိခြင်း',
      trimTwoSide: 'နှစ်ဘက်ညှိပါ',
      trimFourSide: 'လေးဘက်ညှိပါ',
      rightInmShow: 'ညာဘက်ပုံတွင်ပြထားသည့်အတိုင်း',
      currentTrimDir: 'လက်ရှိရွေးထားသောအစွန်းညှိဦးတည်ချက်အတွက်',
      cylinderTip: 'ဆလင်ဒါတည်နေရာသတ်မှတ်ရန်',
      onlyShort: 'အတိုအစွန်းများကိုသာညှိပါ',
      singleTrim: 'တစ်ဖက်သားပြားအစွန်းညှိလမ်းဖြစ်စေခြင်း',
      hierarchyCutTwice: 'အခေါင်းမြှောင်ခြင်းနှင့်အလွှာညွှန်းဖြတ်ခြင်း',
      knifeDia: 'ဓားအချင်းသည်ထက်နည်းသို့မဟုတ်ညီမျှသည်',
      slotDeep: 'အခေါင်းအနက်သည်ထက်ကြီးသို့မဟုတ်ညီမျှသည်',
      cutTwiceSlot: 'အလွှာဖြတ်ခြင်းပြုလုပ်သည့်အခါ',
      twiceSlotDeep: 'ဒုတိယအလွှာဖြတ်ချက်အနက်မှာ',
      cutTwiceCondition: 'ဖြတ်ချက်အခြေအနေ',
      zkPointCustomizeTip: 'XY ဝင်ရိုးအပြန်အလှန်ဖွင့်ခြင်းသည်ပြုပြင်မှုဦးတည်ချက်နှင့်ရည်ညွှန်းအမှတ်ပြောင်းပြန်ဖြစ်စေသည်',
      zkPointCustomizeTip1: 'XY ဝင်ရိုးအပြန်အလှန်ဖွင့်ထားသောကိရိယာများတွင်ဤလုပ်ဆောင်ချက်အလုပ်မလုပ်ပါ',
      isCustom: 'စိတ်ကြိုက်ပြင်ဆင်ခြင်းဖွင့်ပါ',
      useCutCon: 'ဆားကြိတ်ဖြတ်ချက်အခြေအနေသုံးပါ',
      singleSetPlankSizeSpeed: 'ပြားငယ်အရွယ်အစားအတိုင်းအတာအလိုက်ပြုပြင်မှုအမြန်နှုန်းသတ်မှတ်ပါ',
      singleSetPlankSizeSpeedTip: '(1. အောက်ပါအရွယ်အစားနှင့်ကိုက်ညီသောပြားငယ်ကိုသတ်မှတ်အမြန်နှုန်းဖြင့်ပြုပြင်မည်။ 2. ပြားငယ်သည်တစ်ချိန်တည်းစည်းမျဉ်းများစွာနှင့်ကိုက်ညီပါကအစောပိုင်းအစဉ်လိုက်စည်းမျဉ်းအကျိုးသက်ရောက်သည်။ 3. ဤအင်္ဂါရပ်သည်ဆားကြိတ်ဖြတ်ခြင်းနှင့်မသက်ဆိုင်ပါ။)',
      addSpeedRules: 'စည်းမျဉ်းထည့်ပါ',
      speedRules: 'စည်းမျဉ်း',
      shortSideSize: 'အတိုဘက်အရွယ်အစား',
      lessThanEqual: 'ထက်နည်းသို့မဟုတ်ညီမျှ',
      and: 'နှင့်',
      longSideSize: 'အရှည်ဘက်အရွယ်အစား',
      processingSpeed: 'ပြုပြင်မှုအမြန်နှုန်း',
      trimLenCompensation: 'အစွန်းညှိအရှည်ပြန်လည်ထူထောင်ခြင်း:',
      trimGenerateAPath: 'အစွန်းညှိတန်ဖိုး 0 သည်လမ်းမဖြစ်စေပါ:',
      cuttingMethod: 'ဖြတ်နည်း',
      horizontalCutting: 'အလျားလိုက်ဖြတ်',
      verticalCutting: 'ဒေါင့်လိုက်ဖြတ်',
      openKnifeDistance: 'ဗီရိုခန္ဓာကိုယ်ကုဒ်ကို ဖြင့် ပါဝင်သည်များကို ရှာဖွေရန်'
      },
    labelingSettings: {
      title: 'အညွှန်းသတ်မှတ်ချက်များ',
      output: 'အလိုအလျောက်အညွှန်းဖိုင်ထုတ်ပါ',
      specification: 'အညွှန်းဖိုင်ဖော်မတ်',
      codeFrontGenerate: 'အညွှန်းကုဒ်မတိုင်မီအလိုအလျောက်အစာထည့်ကုဒ်ထုတ်ပါ',
      templateOffline: 'အသုံးပြုထားသောတမ်းပလိတ်အော့ဖ်လိုင်းဖြစ်နေသည်။',
      templateNotSupport: 'ဤတမ်းပလိတ်ကို မပံ့ပိုးပါ၊ ပြန်ရွေးပါ!',
      rollLabelling: 'ပြန်လှန်အညွှန်းသတ်မှတ်ချက်များ',
      flipSetting: {
        title: 'ပြန်လှန်သတ်မှတ်ချက်များ',
        engravingFlipProcess: 'ထွင်းထုစက်ပြန်လှန်ပြုပြင်အညွှန်းမုဒ်ဖွင့်ပါ',
        flipTip: 'ထွင်းထုစက်ပြန်လှန်ပြုပြင်လိုသည့်အခါဤလုပ်ဆောင်ချက်ဖွင့်ပါ'
        },
      rotateSetting: {
        title: 'အညွှန်းလည်ပတ်သတ်မှတ်ချက်များ',
        rotateTip: 'လိုအပ်ချက်အရလည်ပတ်အခြေအနေဖွင့်ပါ၊ တစ်ချိန်တည်းဖွင့်ပါကရွေးထားသောတန်ဖိုးဦးစားပေးအကျိုးသက်ရောက်သည်',
        horizontal: 'ပြားအလျားဘက်',
        vertical: 'ပြားဒေါင်လိုက်ဘက်',
        either: 'ပြားအလျားသို့မဟုတ်ဒေါင်လိုက်ဘက်'
        },
      countertopSetting: {
        title: 'အလုပ်စားပွဲသတ်မှတ်ချက်များ',
        startPoint: 'အလုပ်နေရာစတင်အမှတ်:',
        upLeft: 'ဘယ်အပေါ်ထောင့်',
        upRight: 'ညာအပေါ်ထောင့်',
        downLeft: 'ဘယ်အောက်ထောင့်',
        downRight: 'ညာအောက်ထောင့်',
        baseExchange: 'ကိုဩဒိနိတ်အခြေအပြန်အလှန်:',
        exchangeX: 'x ဝင်ရိုးအပြန်အလှန်',
        exchangeY: 'y ဝင်ရိုးအပြန်အလှန်'
        },
      offset: 'အညွှန်းကိုဩဒိနိတ်ရွေ့ခြင်း',
      offsetTip: 'အများအားဖြင့်အညွှန်းကိုဩဒိနိတ်သည်ပြားငယ်အလယ်တွင်ရှိပြီးကိရိယာအချို့ပြင်ဆင်ချို့တဲ့သည်',
      label_rotate_offset: 'လည်ပတ်ပြီးနောက်အညွှန်းရွေ့ခြင်း',
      label_rotate_offset_tip: 'အညွှန်းလည်ပတ်မတိုင်မီနှင့်ပြီးနောက်ရွေ့ခြင်းတည်နေရာကွာခြားမှုကြီးသည့်အခါပြင်ဆင်ပါ',
      label_rotate_offset_err_tip: 'အညွှန်းလည်ပတ်ကိုဩဒိနိတ်ရွေ့ခြင်းဖွင့်ပြီးနောက် X နှင့် Y ဝင်ရိုးကိုဩဒိနိတ်ရွေ့ခြင်းလိုအပ်သည်',
      imgSetting: {
        title: 'အညွှန်းပုံသတ်မှတ်ချက်များ',
        suffix: 'အညွှန်းပုံနောက်ဆက်တွဲ:',
        code: 'ပုံကုဒ်နည်းလမ်း:',
        codeTip: 'png၊ jpeg သည်တပ်ဆင်ပုံပုံကုဒ်ဖော်မတ်ကိုတစ်ပြိုင်နက်ပြင်ဆင်မည်၊ ထည့်သွင်းမိုးတိမ်တပ်ဆင်ခြင်းသည်ဤအင်္ဂါရပ်မပံ့ပိုးပါ',
        imgRatio: 'အညွှန်းပုံအဖြေရှင်းချက်:',
        slowDown: 'အညွှန်းပုံများထုတ်ခြင်းထိရောက်မှုလျော့နည်းစေမည်',
        color: 'အစစ်အရောင်',
        bit: 'အဖြူအမဲ',
        resolution: 'အညွှန်းပုံအဖြေရှင်းချက်',
        resolutionPlaceholder: 'အဖြေရှင်းချက်',
        labelPool: 'ဒေတာအညွှန်းကန်ရေကန်',
        showKey: 'ပြသသည့်အကွက်များ',
        dragTip: 'အညွှန်းကန်ရေကန်အတွင်းအညွှန်းများဆွဲချနိုင်သည်',
        labelImgName: 'အညွှန်းပုံအမည်',
        labelImgNameErrTip: 'အညွှန်းပုံအမည်ဗလာမဖြစ်ရ',
        labelTip1: 'စိတ်ကြိုက်ပြင်ဆင်သည့်အခါ【ပြားဘားကုဒ်】သို့မဟုတ်【အညွှန်းအစဉ်နံပါတ်】တစ်ခုသုံးရမည်၊ သို့မဟုတ်ပုံထပ်ခြင်းပြဿနာဖြစ်နိုင်သည်',
        labelTip3: '【အညွှန်းအစဉ်နံပါတ်】 သည် ဖြတ်တောက်စာရင်းရှိ ပေါ်ဒ်ငယ်များ၏ အပေါ်မှ အောက်သို့ အစဉ်လိုက် နံပါတ်ဖြစ်ပြီး၊ ပြင်ဆင်မှုစာမျက်နှာတွင် ထည့်သော ပေါ်ဒ်ငယ်များတွင် ဤဒေတာမရှိပါ',
        labelTip2: '3. အညွှန်းစက်စနစ်တမ်းပလိတ်တွင်ဤအင်္ဂါရပ်အကျိုးမသက်ရောက်ပါ',
        delimiter: 'ခွဲခြားသင်္ကေတ:',
        inputTip: '/ : ? < > | . ” * စသည့်စာလုံးများထည့်သွင်းမပံ့ပိုးပါ',
        numStart: 'အညွှန်းအစဉ်နံပါတ်စတင်တန်ဖိုး',
        example: 'စိတ်ကြိုက်အညွှန်းပုံအမည် (နမူနာ)',
        stockNumOffset: 'ကြီးမားသောပြားအစဉ်နံပါတ်ပြန်လည်ထူထောင်သည့်ဂဏန်းသို့ရောက်သည်',
        divideFolders: 'ကြီးမားသောပြားများအလိုက်အညွှန်းပုံများကိုမတူညီသောဖိုလ်ဒါများခွဲပါ',
        foldersTip1: 'မှတ်ချက်: 1. ဤအင်္ဂါရပ်ကိုဖြတ်စက်ဖိုင်ပေါင်းခြင်းအင်္ဂါရပ်နှင့်အတူအသုံးမပြုနိုင်ပါ',
        foldersTip2: '2. ဤအင်္ဂါရပ်သည်ထည့်သွင်းမိုးတိမ်တပ်ဆင်ခြင်းအတွက်အချိန်မတိုင်မီအကျိုးမသက်ရောက်သေးပါ',
        stickIntoFolders: 'အညွှန်းဖိုင်များကိုသက်ဆိုင်ရာကြီးမားသောပြား၏အညွှန်းပုံဖိုလ်ဒါထဲထည့်ပါ:',
        stickTip1: 'သတိပြုပါ: 1. ဤအင်္ဂါရပ်သည NC ဒေါင်းလုဒ်နှင့်အတူအညွှန်းထုတ်ခြင်းအင်္ဂါရပ်နှင့်အတူအသုံးပြုရမည်',
        stickTip2: '2. အသုံးပြုထားသောအညွှန်းတမ်းပလိတ်ရှိဖိုင်ထုတ်ခြင်းစည်းမျဉ်းတွင် "တစ်ဖိုင်ထုတ်ပါ" ရွေးရမည်မှဤအင်္ဂါရပ်အကျိုးသက်ရောက်မည်',
        stickTip3: '3. ဤအင်္ဂါရပ်သည်ထည့်သွင်းမိုးတိမ်တပ်ဆင်ခြင်းအတွက်အချိန်မတိုင်မီအကျိုးမသက်ရောက်သေးပါ'
        },
      pdfSetting: {
        title: 'တံဆိပ် PDF ဆက်တင်များ',
        pdfLabelName: 'PDF ဖိုင်အမည်',
        example: 'စိတ်ကြိုက်တပ်ဆင်ပုံဖိုင်အမည် (ဥပမာ)',
        address: 'ဆိုင်ရာအကွေးအဝေါ်',
        orderNo: 'မှာယူသည်းခံစာမျက်နှာအမည်',
        firstFolder: 'တစ်နေရာအထိ အကွေးအဝေါ်',
        customerName: 'မှာယူသည်းခံစာမျက်နှာအမည်'
        },
      paibanImgSetting: {
        title: 'တပ်ဆင်ပုံသတ်မှတ်ချက်များ',
        tip: 'စိတ်ကြိုက်တပ်ဆင်ပုံထုတ်ခြင်းဖွင့်ပြီးဖြစ်သည်။ အောက်ရှိသတ်မှတ်တမ်းပလိတ်ထုတ်မရပါ။ ထုတ်လိုပါကတပ်ဆင်စာမျက်နှာပိုမိုသတ်မှတ်ချက်တွင်စိတ်ကြိုက်တပ်ဆင်ပုံထုတ်ခြင်းပိတ်ပါ',
        reparation: 'တပ်ဆင်ပုံအစဉ်နံပါတ်အလိုအလျောက်ပြန်လည်ထူထောင်ခြင်းသို့',
        figure: 'ဂဏန်းနေရာ',
        inputTip: '၁-၉၉ ကြားဂဏန်းထည့်ပါ',
        paibanImg: {
          export: 'တပ်ဆင်ပုံထုတ်ပါ',
          prefix: 'တပ်ဆင်ပုံအမည်ရှေ့ဆက်',
          size: 'တပ်ဆင်ပုံအရွယ်အစား',
          format: 'တပ်ဆင်ပုံဖော်မတ်',
          directional: 'တပ်ဆင်ပုံဦးတည်ချက်',
          vertical: 'ဒေါင်လိုက်',
          horizontal: 'အလျားလိုက်'
          }
        },
      autolabel: 'အလိုအလျောက်အညွှန်းအစဉ်သတ်မှတ်ချက်',
      customTemp: 'စိတ်ကြိုက်တမ်းပလိတ်များအတွက်သာအကျိုးသက်ရောက်သည်',
      cuttingLabelOder: 'ဖြတ်ချက်အစဉ်အတိုင်းအညွှကပ်ပါ',
      labelToUp: 'တပ်ဆင်ရလဒ်အရအောက်မှ အပေါ်သို့အညွှကပ်ပါ',
      labelToDown: 'တပ်ဆင်ရလဒ်အရအပေါ်မှ အောက်သို့အညွှကပ်ပါ',
      labelDodge: 'အညွှန်းအလိုအလျောက်ရှောင်ခြင်း',
      nolabelForsurplus: 'ကျန်ပြားအတွက်အညွှန်းဖိုင်မထုတ်ပါ',
      settingValue: 'သတ်မှတ်တန်ဖိုးရွေးပါ',
      enabelTip: 'ဖွင့်ပြီးပါကပြားငယ်အောက်ပါသတ်မှတ်တန်ဖိုးများနှင့်ကိုက်ညီပါကအညွှန်းလည်ပတ်မည်',
      fixedHori: 'အညွှန်းအလျားဘက်နှင့်ပြားငယ်သတ်မှတ်ဘက်ပြိုင်ရွေးပါ',
      fixedHoriTip: 'အကြောမဲ့ပြားငယ်များအတွက်သာ။ ဖွင့်ပါကအညွှန်းကပ်သည့်အခါအညွှန်းအလျားဘက်နှင့်ပြားငယ်သတ်မှတ်ဘက်ပြိုင်လည်ပတ်မည်',
      tagHori: 'အညွှန်းအလျားဘက်',
      effectiveTarget: 'အကျိုးသက်ရောက်သည့်ပစ်မှတ်',
      allPlank: 'ပြားငယ်အားလုံး',
      notcarePlank: 'အကြောမဲ့ပြားငယ်များသာ'
      },
    drillSettings: {
      title: 'အပေါက်ဖောက်စက်သတ်မှတ်ချက်များ',
      enable: 'အပေါက်ဖောက်ပက်ကေ့ချ်ဖွင့်ပါ',
      toolTable: {
        use: 'ဖွင့်ပါ',
        number2: 'အလုပ်နေရာ ၂ အပေါက်ဖောက်နံပါတ်',
        number: 'အပေါက်ဖောက်နံပါတ်',
        diameter: 'အပေါက်ဖောက်ချွန်အချင်း',
        xOffset: 'X ရွေ့ခြင်း',
        yOffset: 'Y ရွေ့ခြင်း',
        moveZF: 'Z ဝင်ရိုးအမြန်ရွေ့အမြန်နှုန်း',
        feedRate: 'Z ဝင်ရိုးပြုပြင်မှုအမြန်နှုန်း',
        moveF: 'XY ဝင်ရိုးအမြန်ရွေ့အမြန်နှုန်း',
        benchmarkDrill: 'အခြေခံအပေါက်ဖောက်',
        addKnife: 'ကိရိယာထည့်ပါ',
        deleteKnife: 'ကိရိယာဖျက်ပါ'
        },
      prefix: 'အပေါက်ဖောက်ရှေ့ဆက်',
      suffix: 'အပေါက်ဖောက်နောက်ဆက်',
      startCode: 'အပေါက်ဖောက်စတင်ကုဒ်',
      endCode: 'အပေါက်ဖောက်အဆုံးကုဒ်',
      combineKnife: 'အပေါက်ဖောက်ပေါင်းစပ်ဖြတ်ချက်',
      combineTable: {
        prefix: 'အပေါက်ဖောက်နံပါတ်ရှေ့ဆက်',
        suffix: 'အပေါက်ဖောက်နံပါတ်နောက်ဆက်',
        mainHole: 'အဓိကအပေါက်',
        extraHole: 'အခြားအပေါက်',
        notes: 'ပေါင်းစပ်မှတ်ချက်',
        firstUseNotes: 'ပထမအသုံးမှတ်ချက်',
        addExtraHole: 'အခြားအပေါက်ထည့်ပါ',
        deleteExtraHole: 'အခြားအပေါက်ဖျက်ပါ',
        example: 'နမူနာ'
        },
      tagPool: {
        drillRowNumber: 'အပေါက်ဖောက်တန်းနံပါတ်'
        },
      processSetting: {
        title: 'ပြုပြင်မှုသတ်မှတ်ချက်များ',
        mode: 'အပေါက်ဖောက်ပြုပြင်မုဒ်',
        processTip: 'ဤမုဒ်ရွေးပါကအပေါက်ဖောက်ပေါင်းစပ်ဖြတ်ချက်အင်္ဂါရပ်အကျိုးမသက်ရောက်ပါ',
        recentHole: 'အနီးကပ်အပေါက်ဖောက် (အမြန်ကိရိယာလဲ)',
        groupHole: 'အမျိုးအစားအလိုက်ဖောက် (တစ်မျိုးပြီးမှကိရိယာလဲ)',
        drill_benchmark: 'ကိရိယာသတ်မှတ်အခြေခံပေါင်းစပ်',
        drill_benchmark_Tip: '（သတိပြုပါ：ဤနည်းရွေးပါကအပေါက်ဖောက်ပေါင်းစပ်ကိရိယာသတ်မှတ်အင်္ဂါရပ်အကျိုးမသက်ရောက်ပါ）',
        mainHole: 'အဓိကအပေါက်',
        secondaryHole: 'အခြားအပေါက် (အမြီးအပေါက်)'
        },
      changeBenchDrillTip: 'ဤရွေးချယ်မှုမပြုမီအပေါက်ဖောက်နံပါတ်ထည့်ပါ'
      },
    NCExportSettings: {
      jumpSkipTip2: 'ကြီးမားသောပြားအရောင်၊ ထူအမျိုးအစား၊ ပစ္စည်းအလိုက်မတူညီသောဖိုလ်ဒါများခွဲပါ (အညွှန်းဖိုင်များပါ)၊ အရွယ်တူကြီးပြားဖြတ်စာဖိုင်များကိုတစ်ဖိုလ်ဒါတွင်ထားပါ',
      title: 'NC ထုတ်သတ်မှတ်ချက်များ',
      tab1: 'ဖြတ်စက်ဖိုင်အမည်သတ်မှတ်ချက်များ',
      tab2: 'ဖြတ်စက်ဖိုင်အမည်ပေါင်းခြင်း',
      tab3: 'ဖြတ်စက်ဖိုင်မှတ်ချက်များ',
      tab4: 'ဖြတ်စက်ဖိုင်အမျိုးအစားများ',
      tab5: 'ဖြတ်စက်ဖိုလ်ဒါများ',
      tab6: 'ပြုပြင်ညွှန်ကြားချက်သတ်မှတ်ချက်များ',
      tab7: 'ဖိုင်ဖော်မတ်သတ်မှတ်ချက်များ',
      fileNameSettings: {
        twoStationAutoSort: 'နှစ်နေရာအလိုအလျောက်စီခြင်း',
        reparation: 'ပြားအစဉ်နံပါတ်ဂဏန်းအရေအတွက်ပြန်လည်ထူထောင်ခြင်းသို့',
        figure: 'ဂဏန်းနေရာ',
        labelerBegin: 'အညွှန်းစက်ရှေ့ဆက်',
        machineCenter: 'ပြုပြင်မှုဗဟိုရှေ့ဆက်',
        front: 'ရှေ့ဘက်:',
        back: 'နောက်ဘက်:',
        customizeName: 'စိတ်ကြိုက်ဖိုင်အမည် (ဖော်မတ်):',
        example: 'စိတ်ကြိုက်ဖိုင်အမည် (နမူနာ):',
        emptyTip: 'ရှေ့နှင့်နောက်ဖိုင်အမှတ်အသားနှစ်ခုလုံးတစ်ချိန်တည်းဗလာမဖြစ်ရ',
        labelPool: 'ဒေတာအညွှန်းကန်ရေကန်',
        dragTip: 'အညွှန်းကန်ရေကန်မှအညွှန်းများကိုဆွဲသို့မဟုတ်ကလစ်နှင့်ထည့်သွင်းဘောက်စ်သို့ကူးနိုင်သည်'
        },
      fileMerge: {
        engravingMerge: 'ဖြတ်စက်ဖိုင်ပေါင်းခြင်း',
        zfMerge: 'ရှေ့နှင့်နောက်ဘက်ပေါင်းခြင်း',
        singleMerge: 'တစ်နေရာပေါင်းခြင်း',
        doubleMerge: 'နှစ်နေရာပေါင်းခြင်း',
        fEndCode: 'နောက်ဘက်အဆုံးကုဒ်',
        zBeginCode: 'ရှေ့ဘက်စတင်ကုဒ်',
        displayfbInfo: 'ဖိုင်အမည်တွင်ရှေ့နှင့်နောက်ဘက်အချက်အလက်ပြပါ',
        fBeginCode: 'နောက်ဘက်စတင်ကုဒ်',
        zEndCode: 'ရှေ့ဘက်အဆုံးကုဒ်'
        },
      marginalNotes: {
        addPlankInfo: 'ဖြတ်တောက်ဖိုင် အစတွင် လက်ရှိ ကြီးမားပြား ပစ္စည်းအပိုင်း အချက်အလက်များ ထည့်ပါ:',
        plankInfo: 'ကြီးမားပြား အချက်အလက်များ:',
        addStationCodeFirst: 'ဖြတ်စက်ဖိုင်အစတွင်အလုပ်နေရာကုဒ်ထည့်ပါ:',
        addStationCodeSecond: 'ဖြတ်တောက်ဖိုင်တွင် ကိရိယာပြောင်းမီ အလုပ်ခုံ(စတေရှင်) ကုဒ် ထည့်ပါ:'
        },
      fileType: {
        zAddtion: 'Z ကိုဩဒိနိတ် အပိုဖြည့်စွက်ချက်:',
        addSemicolon: 'NC စာကြောင်းတိုင်းအဆုံးတွင်စီမီကိုလုံထည့်ပါ:',
        semicolonTip: 'ဤခဲတံအမှတ်အသားပါကနွားချိုလက်ကိုင်ပြုပြင်ဖိုင်များလည်းအကျိုးသက်ရောက်မည်',
        fileName: 'ဖိုင်အမည်',
        defaultName: 'ပုံသေဖိုင်အမည်',
        dedicatedName: 'ရှင်းဟွေးကိရိယာအတွက်သီးသန့်ဖိုင်အမည်',
        xhNotes: 'ရှင်းဟွေး E2-9 မှတ်ချက်',
        format: 'ထုတ်သွင်းမည့် ထွင်းစက် ဖိုင်ဖော်မတ်',
        example: 'ဖိုင်နမူနာ: NC ဖိုင်',
        stillGenerate: 'နောက်ဘက်မပြုပြင်သည့်တိုင်နောက်ဘက်အဆုံးကုဒ်ပါသောနောက်ဘက် NC ဖိုင်ထုတ်ပါ',
        generateTip: 'ဒီလုပ်ဆောင်ချက်ကို ဖိုင်ပေါင်း (merge) လုပ်ဆောင်ချက်နဲ့ အတူတကွ အသုံးပြုလို့မရပါ',
        fileNameErrTip: 'ဖိုင်အမည်တွင် အောက်ပါ အက္ခရာများထဲက မည်သည့်အက္ခရာမဆို ပါဝင်ခွင့်မရှိပါ: / : * ? "'
        },
      categorize: 'ကြီးမားပြား၏ အရောင်၊ ပစ္စည်းနှင့် အထူအတိုင်း မတူညီသော ဖိုင်တွဲများအဖြစ် ခွဲထားပါ (တပ်ဖဲလ်ဖိုင်များကိုလည်း အတူတကွ):',
      simplifyG: 'လုပ်ဆောင်မှု G-ညွှန်ကြားချက် အတိုကောက်',
      ZToW: 'ကုဒ်ကို Z ဝင်ရိုးမှ W ဝင်ရိုးသို့ပြောင်းပါ',
      knives: 'အတန်းလိုက် အပေါက်ဖောက်စက် ကိရိယာ',
      lineBreakSetting: 'အတန်းခွဲဖော်မတ်သတ်မှတ်ချက်များ',
      codeFormatSetting: 'ဖိုင်ကုဒ်ဖော်မတ်သတ်မှတ်ချက်များ',
      utf8bom: 'BOM ပါ UTF-8',
      oneCodeSetting: 'ပြားဘားကုဒ်သတ်မှတ်ချက်များ',
      simplifyOneCode: 'အတိုကောက်ဖော်မတ်အညွှန်းဘားကုဒ်ထုတ်ပါ',
      codeLocation: 'ကုဒ်တည်နေရာသတ်မှတ်ချက်များ',
      generateLocation: 'နောက်ဘက်အဆုံးကုဒ်မတိုင်မီအလုပ်နေရာအဆုံးကုဒ်ထုတ်ပါ',
      emergencySetting: 'အရေးပေါ်သတ်မှတ်ချက်များ',
      show: 'အရေးပေါ်သတ်မှတ်ချက်ပြပါ',
      emergencyCode: 'အရေးပေါ်ကုဒ်',
      params: 'ပါရာမီတာများ',
      emergencyTip: 'အရောင်းနောက်ပိုင်းဝန်ထမ်းများပူးပေါင်းခြင်းဖြင့်အချို့သောအင်္ဂါရပ်များယာယီအကောင်အထည်ဖော်နိုင်သည်',
      holeSetting: 'အပေါက်ဖောက်ဖိုင်သတ်မှတ်ချက်များ',
      holeFileCategorize: 'အပေါက်ဖောက်ဖိုင်များကိုမတူညီသောအမိန့်များအလိုက်ဖိုလ်ဒါများတွင်သီးခြားထားပါ',
      holeTip: 'ထည့်သွင်းအကြံပြုချက်ကိုယ်အမှုဆောင်မိုးတိမ်တပ်ဆင်ခြင်းတွင်အကျိုးမသက်ရောက်ပါ',
      specialCodeErr: 'အထူးစာလုံးများမပံ့ပိုးပါ!',
      copySuccess: 'ကူးယူအောင်မြင်ပါသည်!',
      copyErr: 'ကူးယူမှုမအောင်မြင်ပါ၊ အညွှန်းဆွဲကြည့်ပါ!',
      lengthLimit: '၁၅ လုံးသာထည့်သွင်းပံ့ပိုးသည်!',
      plankInfo: 'ပြားအချက်အလက်',
      otherInfo: 'အခြားအချက်အလက်',
      uniqueBarCode: 'ပြားအတွက်ထူးခြားဘားကုဒ်',
      uniqueBarCodeForPack: 'ပြားဘားကုဒ်ထူးခြား (ထုပ်ပိုးခြင်းအတွက်သာ)',
      machineOrder: 'ဖြတ်စက်ဖိုင်အမည်မှပြုပြင်အစဉ်နံပါတ်ထုတ်ပါ',
      folderSetting: 'အရွယ်တူပြားများ၏ဖြတ်စာဖိုင်များကိုတစ်ဖိုလ်ဒါတွင်ထားပါ',
      labelImageINCFolder: 'အညွှန်းပုံများနှင့်အညွှန်းဖိုင်များကို NC ဖိုလ်ဒါတွင်ထားပါ',
      custom: 'စိတ်ကြိုက်',
      folderSettingTip: 'မှတ်ချက်: ထည့်သွင်းတပ်ဆင်ခြင်းသည်ဤအင်္ဂါရပ်ကိုအချိန်မတိုင်မီမပံ့ပိုးသေးပါ',
      settingMoveTip: 'မူရင်း "{func}" လုပ်ဆောင်ချက်ကို "{module}" စာမျက်နှာသို့ရွှေ့ပြီးပါပြီ!',
      fileManagerFunction: 'မတူညီသောအမိန့်များအလိုက်အပေါက်ဖောက်ဖိုင်များကိုသီးခြားဖိုလ်ဒါများတွင်ထားပါ',
      gotoSetting: 'သတ်မှတ်ချက်သို့သွားပါ',
      singleFileTitle: 'တစ်ဖိုင်ပြုပြင်သတ်မှတ်ချက်များ',
      slectSingleProcess: 'သီးခြားထုတ်လုပ်မှုလုပ်ငန်းစဉ် ရွေးချယ်ပါ',
      slectSingleProcessTip: 'ငွေပေးရသော ဒုတိယအဆင့် လုပ်ငန်းစဉ်များ ရှိနေပါသည်၊ ဖျက်ပြီး ပြန်သိမ်းပါ',
      setSingleRegularSize: 'သီးခြားထုတ်လုပ်မှုအတွက် ပုံမှန်အပေါက်/အထစ် အရွယ်အစား သတ်မှတ်ပါ',
      holeRange: 'အပေါက် သက်ရောက်မှု အပိုင်းအခြား',
      slotRange: 'အထစ် သက်ရောက်မှု အပိုင်းအခြား',
      holeRangeTip: 'အပေါက် သက်ရောက်မှု အပိုင်းအခြားကို ဗလာမထားရ၊ ဖြည့်ပါ!',
      slotRangeTip: 'အထစ် သက်ရောက်မှု အပိုင်းအခြားကို ဗလာမထားရ၊ ဖြည့်ပါ!',
      yhzc: 'အကွေးအပိုင်းရှိ တည့်အထစ်',
      xbgy: 'စောင်း Haitang ထောင့်နှင့် စောင်းလက်ကိုင်',
      nbyx: 'အတွင်းပိုင်း ပုံမှန်မဟုတ်သော ပုံသဏ္ဍာန်',
      secondaryProcessingMerge: 'ဒုတိယအဆင့် လုပ်ငန်းဖိုင်များ ပေါင်းစည်းခြင်း',
      secondaryProcessingMergeName: 'ပေါင်းစည်းဖိုင်အမည်',
      secondaryProcessingMergeTip: 'ဖွင့်ထားပါက တင်ပို့ဘုတ်တွင် ဒုတိယအဆင့် လုပ်ငန်းစဉ်များစွာရှိလျှင် တစ်ဖိုင်တည်းသို့ ပေါင်းစည်းသည်',
      singleFileSetting: 'ချောမွေ့အစွန်း၊ ပန်းထောင့်နှင့်စောင်းလက်ကိုင်ပါသောတစ်ဖိုင်ပြုပြင်ထုတ်ပါ',
      straightArcSlot: 'ချိုးကွေးအစိတ်အပိုင်းများရှိဖြောင့်အခေါင်းများပါတစ်ဖိုင်ပြုပြင်ထုတ်ပါ'
      },
    aioMachineSetting: {
      openFunction: 'ချိတ်ဆက်ရန်အောက်ပါလုပ်ဆောင်ချက်များဖွင့်ရမည်',
      openCarving: 'ထွင်းထုစက်ဖွင့်ပါ',
      xyReverseFunction: 'XY ဝင်ရိုးအပြန်အလှန်လုပ်ဆောင်ချက်',
      carvingStartSet: 'ထွင်းထုစက်စတင်တည်နေရာသတ်မှတ်ပါ',
      rightTop: 'ညာအပေါ်ထောင့်',
      carvingEdgeSet: 'ထွင်းထုစက်ရှေ့ဘက်အစွန်းညှိတန်ဖိုးပြင်ဆင်ပါ',
      finalEdgeSame: 'စုစုပေါင်းအစွန်းညှိတန်ဖိုးနှင့်တူသည်',
      beginCode: 'ပရိုဂရမ်စတင်ကုဒ်',
      endCode: 'ပရိုဂရမ်အဆုံးကုဒ်',
      drillHole: 'အပေါက်ဖောက်',
      pullTrough: 'အချိုးဆွဲခြင်း',
      showDataTemp: 'ဒေတာနမူနာပြပါ',
      dataTemp: 'ဒေတာနမူနာ',
      title: 'တစ်ကိုယ်တည်းစက်ဆက်တင်း',
      outputFile: 'တစ်ကိုယ်တည်းစက်အသုံးပြုဖိုင်ထုတ်ပါ',
      outputFileTips: 'တစ်ကိုယ်တည်းစက်ဖွင့်ပြီး XY ပြောင်းလဲဖိုင်ပေါင်းခြင်း၊ ပုံမမှန်အပေါက်မထိုးခြင်းနှင့်မကိုက်ညီ၊ သတိဖြင့်သုံးပါ',
      fileType: 'ဖိုင်ဖော်မတ်',
      select: 'ကျေးဇူးပြု၍ရွေးပါ',
      diameter: 'အစွန်းညှိဓားအချင်း',
      jidongTip: 'ဂျီဒုံတစ်ကိုယ်တည်းစက်သုံးပါက ထွင်းစက်အခြေနေကို ညာအပေါ်ထောင့်သတ်မှတ်ပြီး A လုပ်ဆောင်ချက်ဖွင့်ပါ',
      skill: 'လုပ်ဆောင်ချက်',
      clampHandLength: 'ညှပ်လက်အလျား(L)',
      clampHandWidth: 'ညှပ်လက်အကျယ်(W)',
      clampHandMargin1: 'ညှပ်လက်၁အနားကြား(H1)',
      clampHandMargin2: 'ညှပ်လက်၂အနားကြား(H2)',
      duchClampHand: 'အပေါက်အချိုးညှပ်လက်နေရာရှောင်ခြင်း',
      clampHandDirection: 'ညှပ်လက်ဦးတည်ချက်',
      left: 'ဘယ်ဘက်',
      right: 'ညာဘက်',
      top: 'အပေါ်ဘက်',
      bottom: 'အောက်ဘက်'
      },
    oneDragTwo: {
      title: 'တစ်ဆွဲနှစ်ထွင်းစက်',
      outputMachineFile: 'တစ်ဆွဲနှစ်ထွင်းစက်ဖိုင်ထုတ်ပါ',
      outputMachineFileTips: 'တစ်ဆွဲနှစ်ထွင်းစက်ဖွင့်ပြီး ဖိုင်ပေါင်းခြင်းနှင့်မကိုက်ညီ၊ သတိဖြင့်သုံးပါ',
      fileType: 'ဖိုင်ဖော်မတ်',
      select: 'ကျေးဇူးပြု၍ရွေးပါ',
      machineStart: 'အလုပ်ဌာနအစအမှတ်',
      positionClose: 'ပိတ်သောအခါ ကတ်တင်းပါရာမီတာရှိအလုပ်ဌာနအစအမှတ်အတိုင်းလိုက်မည်',
      engravingPlus: 'အမြန်ထွင်းစက်'
      },
    sawEngraving: {
      title: 'ဆောက်ထွင်းစက်',
      preLayNav: 'ဆောက်ထွင်းစက်ဆက်တင်း',
      preLayKnifeInput: 'ဆောက်ဓားအလျားလိုက်ညှပ်ဓားအချင်း',
      enableSaw: 'ဆောက်ထွင်းစက်ဖွင့်ပါ',
      sawAioTip: 'ချိပ်ပလိတ်တစ်ကိုယ်တည်း AIO ထွက်ခွင့်မရှိပါ၊ ဖွင့်ရန် အရောင်းဌာနကို ဆက်သွယ်ပါ',
      cutSet: 'ဂဟေပြားကတ်တင်းဆက်တင်း',
      weldingPlank: 'ဂဟေပြားကတ်တင်း',
      doorFrame: 'ဂဟေပြားကတ်တင်း',
      doorFrameTip1: 'ဆောက်ဓားအသုံးပြုချက်',
      doorFrameTip2: '2.ဆောက်ဓားအသုံးပြုချက် 3.ဆောက်ဓားအသုံးပြုချက်',
      sawUsing: 'ဆောက်ဓားအသုံးပြုချက်',
      trim: 'အစွန်းညှိခြင်း',
      cutBlank: 'ကတ်တင်းနှင့်အတုံးချခြင်း',
      backTrimOblique: 'နောက်မျက်နှာအစွန်းညှိခြင်း',
      holeSlotOblique: 'နောက်မျက်နှာအစွန်းညှိခြင်း',
      plankThicknessUnit: 'ပြားအရောင်ခြင်းကို အမှန်တကျဆိုးသည်',
      sawUseCond: 'ဆောက်ဓားသုံးစွဲအခြေအနေ',
      exportPartData: 'ပြားငယ်ဒေတာဖိုင်ထုတ်ပါ(ban၊ mpr၊ xml စသည်)',
      sawAioTip2: 'ပြားမလှန်သည့်ဆောက်တစ်ကိုယ်တည်းစက်နှင့်ကိုက်ညီ',
      hasUsing: 'အသုံးပြုနိုင်သည့်လမ်းကြောင်းရှိလျှင်သုံးပါ',
      onlyUse: 'လိုအပ်မှသာသုံးပါ',
      cutMethod: 'ကတ်တင်းနည်းလမ်း',
      oneKnifePull: 'ဓားတစ်ချက်ဖြင့်ကြီးပြားဖြတ်ခြင်း',
      onlyOneKnifePull: 'လိုအပ်မှဓားတစ်ချက်ဖြင့်ဖြတ်မည်',
      enableSawThick: 'ဆောက်ဓားအထူအစီအစဉ်ဖွင့်ပါ',
      edgedDir: 'ပိတ်ပြီးပြန်မဖြတ်သည့်ကြီးပြားအစွန်း',
      sameWidthPart: 'ကြီးပြားတစ်ချပ်တွင်အကျယ်တူပြားငယ်များသာစီပါ',
      emptyPath: 'ကတ်တင်းစဉ်ဗလာလမ်းကြောင်းမထုတ်ပါ',
      sawUsePlank: 'ဂဟေပြားများတွင်သာဆောက်ဓားဖြင့်ကတ်တင်းပါ',
      paibanGap: 'ဂဟေပြားအစီအစဉ်ကြားအကွာအဝေး',
      minSurplusWidthDiff: 'အကြွင်းအကျန်ကိုက်ညီအကျယ်ကွာခြားချက်အနည်းဆုံး',
      minSurplusWidthDiffTip: 'ပြားငယ်နှင့်အကြွင်းအကျန်အကျယ်ကွာခြားချက်ဤတန်ဖိုးထက်နည်းမှသာအကြွင်းပေါ်တွင်ထားမည်',
      sawReplaceEnable: 'ကတ်တင်းဦးတည်ချက်အောက်မှ အပေါ်သို့၊ ပြားများကိုအကျယ်ဖြင့်ဦးစွာစီပြီးအလျားဖြင့်စီပါ',
      minSawLength: 'ကတ်တင်းဦးတည်ချက်အောက်မှ အပေါ်သို့၊ ပြားများကိုအကျယ်ဖြင့်ဦးစွာစီပြီးအလျားဖြင့်စီပါ',
      keepDistance: 'ပြားများကိုအကျယ်ဖြင့်ဦးစွာစီပြီးအလျားဖြင့်စီပါ',
      keepDistanceTip: 'မှတ်ချက်: ပြားများကိုအကျယ်ဖြင့်ဦးစွာစီပြီးအလျားဖြင့်စီပါ',
      sortByLength: 'ပြားအလျားအလိုက်စီပါ',
      sortByLengthTip: 'ကတ်တင်းဦးတည်ချက်အောက်မှ အပေါ်သို့၊ ပြားများကိုအကျယ်ဖြင့်ဦးစွာစီပြီးအလျားဖြင့်စီပါ',
      plankAtTop: 'ပြားငယ်အပေါ်တွင်ထားပါ',
      plankAtBottom: 'ပြားငယ်အောက်တွင်ထားပါ',
      useSawTipOne: 'ဖွင့်ပြီးနောက် ဂဟေပြားဂုဏ်သတ္တိရှိပြားငယ်များသာဆောက်ဓားဖြင့်ကတ်တင်းမည်၊ ဂဟေမပြားများကိုဖြောင့်ဓားဖြင့်ဖြတ်မည်',
      useSawTipTwo: 'ကြီးပြားအစီအစဉ်ကိုဖွင့်ပြီးနောက် စံကြီးပြားမသုံးပါ၊ ရောစပ်အစီအစဉ်လိုပါက အထူးကြီးပြားတွင်ဂဟေနှင့်ပျားအုံပြားဒေတာထည့်ပါ',
      useSaiTipThree: 'ဤလုပ်ဆောင်ချက်ဖွင့်ပြီးနောက် အစီအစဉ်သည် ဆောက်ဖြတ်အစီအစဉ်ကိုသုံးရမည်',
      surplusStoreAndLabeling: 'ဖြတ်ပြီးအကြွင်းကိုသိုလှောင်ပြီးတံဆိပ်ရိုက်နိုင်သည်',
      surplusMinLength: 'အကြွင်းအကျန်အသုံးပြုနိုင်အနည်းဆုံးအလျား',
      surplusMinSize: 'အကြွင်းအကျန်အသုံးပြုနိုင်အနည်းဆုံးအဝေး',
      crossCutOnlyMinSurplusSize: 'အကြွင်းအကျန်သည် အသုံးပြုနိုင်အနည်းဆုံးအရွယ်အစားကိုဖြစ်မှ မျဉ်းဖြတ်လမ်းကြောင်းကိုဖန်တီးပါမည်',
      surplusStoreAndLabelingTip: '၁、ကြီးပြားအပေါ်/အောက်တွင်အပြာရောင်အကြွင်းနေရာထုတ်မည်၊ ပုံမှန်သိုလှောင်နိုင်ပြီးတံဆိပ်ရိုက်နိုင်သည်',
      surplusStoreAndLabelingTip2: '၂、ဂဟေပြားများတွင် "အကြွင်းအလိုအလျောက်ဖြတ်ခြင်း" မအလုပ်မလုပ်ပါ）',
      surplusStoreAndLabelingTip3: '（ဖွင့်ပြီးနောက်',
      backCutSurplus: 'ပြောင်းပြန်ဘက်မှအကြွင်းဖြတ်ယူခြင်း',
      cutSurplusTip: 'ဖွင့်ပြီးနောက် ပြောင်းပြန်ဘက်အစွန်းညှိအစဉ်ကို "ပြောင်းပြန်အချိုးကတ်တင်းပြီးနောက်ညှိပါ" သတ်မှတ်ပါ',
      top: 'အပေါ်ဘက်',
      bottom: 'အောက်ဘက်',
      left: 'ဘယ်ဘက်',
      right: 'ညာဘက်',
      dockTip: 'ဂဟေပြားကတ်တင်းအတွက် လေးဘက်ပိတ်ပြီးအစွန်းညှိသကဲ့သို့၊ လက်ဖြင့်တစ်တန်းအစီအစဉ်လုပ်ပါ',
      sawToLayoutTip: 'ဖွင့်ပြီးနောက် အစီအစဉ်တွင်ပြားငယ်များကြားဆောက်ဓားအထူနှင့်ညီသည့်ကတ်တင်းချောင်းသာချန်မည်',
      sawToLayoutTip2: 'ဆောက်ဖြတ်အစီအစဉ်သည် ယခုအချိန်တွင်အတုံးချဓားသတ်မှတ်ခြင်းမပံ့ပိုးပါ',
      tempPaiabanTip: 'ဆောက်ဓားကတ်တင်းဖွင့်ပြီးနောက် အစီအစဉ်တွင်တိုက်ရိုက်ပုံမမှန်ပြားထည့်ခြင်းမပံ့ပိုးပါ၊ ထည့်လိုပါက ကတ်တင်းစာရင်းသို့သွားပြီးထည့်ပြီးအစီအစဉ်လုပ်ပါ',
      generateCutSurplusPath: 'အကြွင်းကိုဦးစွာဖြတ်သည့်အလျားလိုက်ကတ်တင်းလမ်းကြောင်းထုတ်ပါ',
      curSurplusPathTip: 'ဖွင့်ပြီးနောက် ပြောင်းပြန်ဘက်အစွန်းညှိအစဉ်ကို "ပြောင်းပြန်အပေါက်/အချိုးကတ်တင်းပြီးနောက်ညှိပါ" သတ်မှတ်ပါ'
      },
    robotArmDocking: {
      autoLine: 'အလွန်တော့မြန်ဆန်စက်လက်မောင်းချိတ်ဆက်ခြင်း',
      autoLineTip: 'အလွန်တော့မြန်ဆန်စက်လက်မောင်းချိတ်ဆက်ခြင်းမပံ့ပိုးပါ၊ အလွန်တော့မြန်ဆန်စက်လက်မောင်းချိတ်ဆက်ခြင်းမပံ့ပိုးပါ',
      title: 'စက်လက်မောင်းချိတ်ဆက်ခြင်း',
      enable: 'စက်လက်မောင်းချိတ်ဆက်ခြင်းဖွင့်ပါ',
      enableTip: 'ဖွင့်ပြီးနောက် ထုတ်လုပ်မှုဖိုင်ထုတ်သည့်အခါ စက်လက်မောင်းချိတ်ဆက်ဖိုင်ထုတ်မည်'
      },
    laserCuttingMachine: {
      title: 'လေဆာကတ်တင်းတစ်ကိုယ်တည်းစက်',
      enable: 'လေဆာတစ်ကိုယ်တည်းစက်ဖွင့်ပါ',
      backSafeHeight: 'ပြောင်းပြန်ဘက်အလုပ်မလုပ်သည့်အခါ Z အမြင့်(H)',
      laserDistance: 'အရှေ့/ပြောင်းပြန်ဘက်ကတ်တင်းစဉ် လေဆာဓားနှင့်ပြားမျက်နှာပြင်ကြားအကွာအဝေး',
      coordinateAxis: 'ကိုဩဒိနိတ်ဝင်ရိုး',
      xAxis: 'X',
      yAxis: 'Y',
      zAxis: 'Z',
      cuttingSettings: 'ကတ်တင်းဆက်တင်း',
      backKnifeStore: 'ပြောင်းပြန်ဘက်ဓားသိုလှောင်ရုံ',
      noSupportOriginalMaterialKnife: '"အရင်းအမြစ်အတုံးချဓားရွေးချယ်ခြင်း" လုပ်ဆောင်ချက်ယခုမပံ့ပိုးပါ',
      laserKnifeTip: 'အတုံးချခြင်း：အတွင်းမထိုးသည့်ပုံမမှန်များကိုကတ်တင်းရန်သုံးပါ',
      laserKnifeTip2: 'လေဆာဓား：ထိုးပြီးအပေါက်/အချိုး၊ အတွင်းပုံမမှန်၊ အပြင်ကွေးကြောင်းအတုံးချခြင်း',
      laserKnifeTip3: 'မှတ်ချက်：ပြောင်းပြန်ဘက် Z ဝင်ရိုးသည် စားပွဲမျက်နှာပြင်မှအကွာအဝေးနှင့်ကိုက်ညီသည့်ဆက်စပ်ကိုဩဒိနိတ်ကိုပုံမှန်သုံးသည်',
      laserKnifeTip4: 'ဓားအရေအတွက် ၁ ထက်နည်းမရပါ',
      laserKnifeTip5: 'အတုံးချဓားကိုဖျက်မရပါ',
      laserKnifeTip6: 'အတုံးချခြင်းအတွက်ဓားရွေးချယ်မထားသည်တွေ့ရှိပါသည်၊ အနည်းဆုံးဓားတစ်ချောင်းရွေးပါ',
      laserKnifeTip7: 'လေဆာဓားသည် အတွင်းမဖြတ်ပြီးပုံမမှန်များကိုမကတ်တင်းနိုင်၊ "အတုံးချခြင်း" ရွေးချယ်မှုကိုအလိုအလျောက်ဖြုတ်ပြီး',
      laserKnifeTip8: 'ဓားသိုလှောင်ရုံတွင် "အတုံးချခြင်း" ရွေးချယ်မှုရှိဓားများရွေးပါ၊ မဟုတ်ပါကအတွင်းမဖြတ်ပြီးပုံမမှန်များကိုမကတ်တင်းနိုင်',
      laserKnifeTip9: 'အတုံးချဓားသိုလှောင်ရုံလေဆာဓားအချင်းနှင့် လေဆာတစ်ကိုယ်တည်းစက်လေဆာဓားအချင်းမကိုက်ညီ၊ စစ်ဆေးပါ',
      laserKnifeTip10: 'အတုံးချဓားသိုလှောင်ရုံအတုံးချဓားအချင်းနှင့် လေဆာတစ်ကိုယ်တည်းစက်အတုံးချဓားအချင်းမကိုက်ညီ၊ စစ်ဆေးပါ',
      laserKnifeTip11: 'ပစ္စည်းချိတ်ဆက်ပါရာမီတာပြင်ဆင်ပြီး၊ ပြန်အစီအစဉ်လုပ်ပါ',
      noLaserPermission: 'လေဆာတစ်ကိုယ်တည်းစက်သုံးခွင့်မရှိပါ၊ သုံးမည့်အချိန်မတိုင်မီ ရောင်းချရေးနှင့်ဆက်သွယ်ပြီးအသုံးပြုခွင့်ဝယ်ပါ',
      laserOpenCode: 'လေဆာအပြင်အဆင်ခံကုဒ်',
      laserCloseCode: 'လေဆာအပြင်အဆင်ခံကုဒ်',
      laserToolSettings: 'လေဆာအပြင်အဆင်ခံကုဒ်'
      },
    firstSave: 'အသုံးပြုသူပထမဆုံးကမ္ဘာလုံးဆိုင်ရာအစီအစဉ်သုံးနေသည်တွေ့ရှိပါသည်၊ ဆက်တင်သိမ်းပြီးနောက် ဖိုင်ရှိအစွန်းညှိဦးတည်ချက်သင့်မသင့်သတိပြုပြီးမလိုအပ်သည့်ဆုံးရှုံးမှုရှောင်ပါ',
    knives: {
      xOffset1: 'X ကိုဩဒိနိတ်ရွေ့ခြင်း',
      yOffset1: 'Y ကိုဩဒိနိတ်ရွေ့ခြင်း',
      zOffset1: 'Z ကိုဩဒိနိတ်ရွေ့ခြင်း',
      insert: 'အတန်းထည့်ပါ',
      delete: 'အတန်းဖျက်ပါ',
      tip: '（မှတ်ချက်：ဓားသိုလှောင်ရုံအချက်အလက်ပြင်ဆင်ပြီး ဆက်တင်ညှိပြီးနောက် ကန်တင်းအစီအစဉ်ထုတ်လုပ်သူများသည် နောက်ဆုံးပြောင်းလဲမှုအသုံးပြုရန် ကန်တင်းကလိုင်းယင့်ပြန်စပါ）',
      number: 'နံပါတ်',
      name: 'အမည်',
      diameter: 'ဓားအချင်းΦ',
      sawDiameter: 'ဆောက်ဓားအထူΦ',
      cutting: 'အတုံးချခြင်း',
      use: 'အသုံးပြုချက်',
      moveZF: 'Z ဝင်ရိုးအမြန်ရွေ့အမြန်နှုန်း',
      axis_offset: 'ဝင်ရိုးရွေ့ခြင်းဆက်တင်',
      arc_radius: 'ချိုးကွေးအချင်းဝက်ဆက်တင်',
      cutZF: 'Z ဝင်ရိုးကတ်တင်းအမြန်နှုန်း',
      moveF: 'XY ဝင်ရိုးအမြန်ရွေ့အမြန်နှုန်း',
      cutF: 'XY ဝင်ရိုးကတ်တင်းအမြန်နှုန်း',
      startCode: 'ဓားလဲခြင်းစတင်ကုဒ်',
      stopCode: 'ဓားလဲခြင်းပြီးဆုံးကုဒ်',
      startCode2: 'အလုပ်ဌာန၂ဓားလဲခြင်းစတင်ကုဒ်',
      stopCode2: 'အလုပ်ဌာန၂ဓားလဲခြင်းပြီးဆုံးကုဒ်',
      knifeLength: 'ဓားအလျား',
      maximum_single_depth: 'တစ်ကြိမ်ကတ်တင်းအများဆုံးအနက်',
      specialShapeKnifeTip: 'အတွင်းပုံမမှန်များအတွက်သာသက်ရောက်သည်',
      preStartCode: 'ကြိုတင်စတင်ကုဒ်',
      punchHoles: 'အပေါက်ဖောက်ခြင်း',
      pullSlots: 'Pull Slot',
      millHoles: 'အပေါက်မေးလ်လင်းခြင်း',
      millSlots: 'ချောင်းဖရီးဇ်ခြင်း',
      sawBlade: 'လွှဓားပြား',
      doubleSaw: 'နှစ်စခန်း မတူညီသော ကိရိယာပြောင်း စတင်ကုဒ်ကို ဖွင့်ပါ',
      singleStation: 'တစ်ဌာန',
      doubleStation: 'နှစ်စခန်း',
      sawBladeTip: 'ဤလုပ်ဆောင်ချက်သည် ၁-မှ-၂ ထွင်းထုစက်များနှင့် အော်လ်-အင်-ဝန် စက်များတွင် မအလုပ်လုပ်ပါ',
      serialNum: 'အမှတ်စဉ်',
      sawWidth: 'ဓားအကျယ်',
      sawType: 'ဆောက်ဓားအမျိုးအစား',
      cutDirection: 'ကတ်တင်းဦးတည်ချက်',
      moveSpeed: 'ဗလာသွားအမြန်နှုန်း',
      cutSpeed: 'ကတ်တင်းအမြန်နှုန်း',
      endCode: 'ဓားလဲခြင်းပြီးဆုံးကုဒ်',
      sawDownCode: 'ဓားချကုဒ်',
      sawUpCode: 'ဓားရုပ်သိမ်းကုဒ်',
      abscissa: 'အလျားကိုဩဒိနိတ်ရှေ့ဆက်',
      ordinate: 'ဒေါင်လိုက်ကိုဩဒိနိတ်ရှေ့ဆက်',
      sawHor: 'အလျားလိုက်ဆောက်ဓား',
      sawVer: 'ဒေါင်လိုက်ဆောက်ဓား',
      towardsZero: '၀အမှတ်ကိုဩဒိနိတ်ဆီကတ်တင်းပါ',
      awayFromZero: '၀ကိုဩဒိနိတ်မှဝေးရာသို့ကတ်တင်းပါ',
      diameterDesc: 'ဓားအချင်းΦ',
      xOffset: 'အလျားလိုက်ကိုဩဒိနိတ်ရွေ့ခြင်း',
      yOffset: 'ဒေါင်လိုက်ကိုဩဒိနိတ်ရွေ့ခြင်း',
      zOffset: 'အမြင့်ကိုဩဒိနိတ်ရွေ့ခြင်း',
      offsetX: 'ရွေ့ခြင်း X',
      offsetY: 'ရွေ့ခြင်း Y',
      offsetZ: 'ရွေ့ခြင်း Z',
      offsetNo: 'ရွေ့ခြင်းနံပါတ်',
      knifeWidth: 'ဓားအကျယ်',
      drill: 'ဓားချခြင်း',
      cut: 'ကတ်တင်းခြင်း',
      speed: 'အမြန်နှုန်း',
      type: 'အမျိုးအစား',
      millHoleSlot: 'အပေါက်/အချိုးမေးလ်လင်းခြင်း',
      rapidFeedSpeed: 'အမြန်ကျွေးအမြန်နှုန်း',
      typeOption1: 'အပ်ချွန်',
      typeOption2: 'မေးလ်လင်းဓား',
      typeOption3: 'ပုံသဏ္ဍာန်ဓား',
      typeTip: 'ဓားအမျိုးအစားသတ်မှတ်ပြီးနောက် အပေါက်/အချိုးသည် ကတ်တင်းရန်သက်ဆိုင်ရာဓားအမျိုးနှင့်ကိုက်ညီမည်'
      },
    other: {
      title: 'အခြား',
      tip: 'တစ်ဌာနပစ္စည်းအတွက် ဌာန၁နှင့်ဌာန၂နှစ်ခုလုံးတွင် တူညီသည့်အလိုအလျောက်အစာထည့်ကုဒ်ထည့်ရမည်'
      }
    },
  sideHoleMachine: {
    moreSetting: 'ပိုမိုပေါ်ပေါက်များ',
    sideStartCode: 'မြင်ခြင်းစနစ်ကို မြင်ခြင်းစနစ်သို့ ပြောင်းလဲသည့် ကုဒ်ကို ဖန်တီးသည်',
    useArcCode: 'ဝိုင်းကွေးဖြတ်ရန် အာ့ခ် အင်တာပိုလေးရှင်း အမိန့်ကို အသုံးပြုပါ',
    coordSwitch: 'ကိုဩဒိနိတ် အခြေခံအမှတ် ပြောင်းလဲခြင်း',
    updownCoordSwitch: 'အမြင့်-အနိမ့် ကိုဩဒိနိတ် အခြေခံအမှတ် ပြောင်းလဲခြင်း',
    xCoordSwitch: 'အလျားလိုက် ကိုဩဒိနိတ် အခြေခံအမှတ်များကို လဲလှယ်ပါ',
    yCoordSwitch: 'ဒေါင်လိုက် ကိုဩဒိနိတ် အခြေခံအမှတ်များကို လဲလှယ်ပါ',
    knifes: {
      number: 'အမှတ်',
      diameter: 'ဓားအကျယ်',
      type: 'အမျိုးအစား',
      moveSpeed: 'အမြန်ထိုးကျွေး အမြန်နှုန်း',
      doSpeed: 'ပြုပြင်မှု အမြန်နှုန်း',
      startCode: 'ဓားလဲခြင်း စတင်ကုဒ်',
      endCode: 'ဓားလဲခြင်း ပြီးဆုံးကုဒ်'
      },
    ymSetting: 'Yimu ချိတ်ဆက်မှု ဆက်တင်များ',
    flanking: 'ဘေးဖက် ပြုပြင်မှု',
    frontProcess: 'အရှေ့ဖက် ပြုပြင်မှု',
    oldSetting: 'ဗားရှင်းဟောင်း ဆက်တင်များ',
    equipParamsSetting: 'စက်ပစ္စည်း ပါရာမီတာ ဆက်တင်များ',
    holeSetting: 'အပေါက်ထိုး ဆက်တင်များ',
    raminoSetting: 'Ramino ချိတ်ဆက်မှု ဆက်တင်များ',
    mortiseTenonSetting: 'တံချောင်း-အပေါက် (Mortise & Tenon) ချိတ်ဆက်မှု ဆက်တင်များ',
    straight: 'တန်းပုံစံ',
    eccentric: 'ဗဟိုလွဲ ပုံစံ',
    pbSize: 'အပေါ်/အောက် ပျက်ဘုတ် အရွယ်အစား',
    slotOverlapRate: 'ချောင်းဖရီးဇ် ထပ်ဆင့်နှုန်း',
    breakingBoardDirection: 'အပေါ်/အောက် ပျက်ဘုတ် ဦးတည်ချက်',
    coordinateValue: 'ကိုဩဒိနိတ် တန်ဖိုး',
    codeFormat: 'ဖိုင် အင်ကုဒ်ဖော်မတ်',
    suffixSetting: 'ဖိုင် နောက်ဆက် ဆက်တင်များ',
    insertRow: 'အတန်း ထည့်ရန်',
    deleteRow: 'အတန်း ဖျက်ရန်',
    equipmentParams: {
      equipPauseCode: 'စက်ပစ္စည်း ရပ်နားကုဒ်',
      wiggleCode: 'လှုပ်ယမ်းကုဒ်',
      equipStartCode: 'စက်ပစ္စည်း စတင်ကုဒ်:',
      flipPauseCode: 'လှန်ရာတွင် ရပ်နားကုဒ်',
      equipEndCode: 'စက်ပစ္စည်း အဆုံးကုဒ်:',
      equipStartCodePlaceholder: 'စက်ပစ္စည်း စတင်ကုဒ်ကို ထည့်ပါ',
      retractingCode: 'ဓားပြန်ဆုတ် အမိန့်ကုဒ်',
      retractingCodePlaceholder: 'ဓားပြန်ဆုတ် အမိန့်ကုဒ်ကို ထည့်ပါ',
      flipPauseCodePlaceholder: 'လှန်ရာတွင် ရပ်နားကုဒ်ကို ထည့်ပါ',
      equipEndCodeTip: 'စက်ပစ္စည်း အဆုံးကုဒ်ကို ထည့်ပါ',
      sideChangeSetting: 'ဘေးဖက် မျက်နှာပြောင်း ဆက်တင်',
      workTip: 'စံသတ်မှတ်အနေဖြင့် ဘယ်ဘက် ① မှ စ၍ နာရီလက်တံပြန် ဦးတည်ချက်အတိုင်း ပြုပြင်သည်',
      frontTurnCode: 'အပေါ်ဘက် စတင်ကုဒ်:',
      frontTurnEndCode: 'အပေါ်ဘက် အဆုံးကုဒ်',
      frontTurnCodePlaceholder: 'အပေါ်ဘက် စတင်ကုဒ်ကို ထည့်ပါ',
      frontTurnEndCodePlaceholder: 'အပေါ်ဘက် အဆုံးကုဒ်ကို ထည့်ပါ',
      leftTurnCode: 'ဘယ်ဘက် စတင်ကုဒ်:',
      leftTurnEndCode: 'ဘယ်ဘက် အဆုံးကုဒ်:',
      leftTurnCodePlaceholder: 'ဘယ်ဘက် စတင်ကုဒ်ကို ထည့်ပါ',
      leftTurnEndCodePlaceholder: 'ဘယ်ဘက် အဆုံးကုဒ်ကို ထည့်ပါ',
      downTurnCode: 'အောက်ဘက် စတင်ကုဒ်:',
      downTurnEndCode: 'အောက်ဘက် အဆုံးကုဒ်:',
      downTurnCodePlaceholder: 'အောက်ဘက် စတင်ကုဒ်ကို ထည့်ပါ',
      downTurnEndCodePlaceholder: 'အောက်ဘက် အဆုံးကုဒ်ကို ထည့်ပါ',
      rightTurnCode: 'ညာဘက် စတင်ကုဒ်:',
      rightTurnEndCode: 'ညာဘက် အဆုံးကုဒ်:',
      rightTurnCodePlaceholder: 'ညာဘက် စတင်ကုဒ်ကို ထည့်ပါ',
      rightTurnEndCodePlaceholder: 'ညာဘက် အဆုံးကုဒ်ကို ထည့်ပါ',
      topFlipCode: 'လှန်ကုဒ် - အပေါ်',
      downFlipCode: 'လှန်ကုဒ် - အောက်',
      leftFlipCode: 'လှန်ကုဒ် - ဘယ်',
      rightFlipCode: 'လှန်ကုဒ် - ညာ',
      cylinderOutCode: 'ဆီလင်ဒါ ထုတ်ကုဒ်',
      cylinderbackCode: 'ဆီလင်ဒါ ပြန်ဆုတ်ကုဒ်',
      cylinderbackDirective: 'ဆီလင်ဒါ ပြန်ဆုတ် အမိန့်',
      moveDirective: 'ရွှေ့ရန် အမိန့်',
      moveAxisCode: 'ရွှေ့ အက်ဆစ်',
      pushAxisCode: 'ဆီလင်ဒါ တွန်းအက်ဆစ်',
      swingAxisCode: 'လှုပ်ယမ်းအက်ဆစ်',
      moveCode: 'ရွှေ့ကုဒ်',
      punchCode: 'ပြုပြင်မှုကုဒ်',
      free: 'ဗလာသွား',
      punchPart: 'ပြုပြင်မှု အပိုင်း',
      cutFaceCode: 'ပြုပြင် ပလိန်းကုဒ်',
      horVerCutFace: 'အလျားလိုက်/ဒေါင်လိုက် ပလိန်း',
      horCutFace: 'အလျားလိုက်/အမြင့်-အနိမ့် ပလိန်း',
      verCutFace: 'ဒေါင်လိုက်/အမြင့်-အနိမ့် ပလိန်း',
      specifySmallBoardMaterialNoCut: 'သတ်မှတ်ထားသော သေးငယ်ဘုတ် ပစ္စည်း မဖြတ်တောက်',
      specifySmallBoardMaterialNoCutTip: 'ပစ္စည်းအမျိုးအစားတွင် သက်ဆိုင်ရာ ကီးဝေါ့ဒ် ပါရှိသော ဘုတ်များသည် ၅/၆ မျက်နှာဒရင်ဖြင့် ပြုပြင်ထားသော အပေါက်/ချောင်း ဖိုင်များသာ ထုတ်ပေးမည်၊ မဖြတ်တောက်ပါ',
      addMaterialKeyword: 'ပစ္စည်း ကီးဝေါ့ဒ် ထည့်ပါ',
      keyword: 'ကီးဝေါ့ဒ်'
      },
    tagPool: 'ဒေတာ တက်ဂ် အစု',
    dragTip: 'တက်ဂ်အစုအတွင်းရှိ တက်ဂ်များကို ဆွဲယူနိုင်သည်',
    knives: 'ပြုပြင် ဓားကိရိယာ:',
    directives: 'ပြုပြင် အမိန့်များ:',
    slot: 'တည့်တည့်ချောင်း ပြုပြင်မှု',
    cirWork: 'ဝိုင်းကွေး ပြုပြင်မှု',
    cirInter: 'ဝိုင်းကွေး အင်တာပိုလေးရှင်း',
    cirOption1: 'နာရီလက်တံလိုက်: G03 နာရီလက်တံပြန်: G02',
    cirOption2: 'နာရီလက်တံလိုက်: G02 နာရီလက်တံပြန်: G03',
    coordinate: {
      xPointSymbol: 'အလျားလိုက် ကိုဩဒိနိတ်:',
      yPointSymbol: 'ဒေါင်လိုက် ကိုဩဒိနိတ်:',
      zPointSymbol: 'အမြင့်-အနိမ့် ကိုဩဒိနိတ်:',
      upright: 'အပေါင်းတန်ဖိုး',
      negative: 'အနုတ်တန်ဖိုး'
      },
    encodeFormat: {
      format: 'ဖိုင် အင်ကုဒ် ဖော်မတ်:',
      wrap: 'လိုင်းပြောင်း အက္ခရာ ဖော်မတ် ဆက်တင်:',
      formatOption1: 'UTF-8 ဖော်မတ်',
      formatOption2: 'ANSI ဖော်မတ်'
      },
    suffix: 'ဖိုင် နောက်ဆက် (suffix) ဆက်တင်:',
    enableFP: 'ရှေ့မျက်နှာ ပြုပြင်မှုကို ဖွင့်ပါ',
    slotSetting: 'ချောင်းဆွဲ ဆက်တင်',
    slotMillSetting: 'ချောင်းဆွဲ/အပေါက်-ချောင်းဖရီးဇ် ဆက်တင်',
    millSlot: 'အပေါက်နှင့် ချောင်း ဖရီးဇ်ခြင်းကို ထောက်ပံ့သည်',
    millingSlotOverlapRate: 'ချောင်းဖရီးဇ် ထပ်နေမှုနှုန်း',
    millingHoleSlotOverlapRate: 'အပေါက်/ချောင်းဖရီးဇ် ထပ်နေမှုနှုန်း',
    takeUpDirective: 'ဓားပြန်ဆုတ် အမိန့်',
    workSeparately: 'ရှေ့/နောက် မျက်နှာ ထိုးဖောက်ချောင်းကို အပိုင်း၂ပိုင်း ခွဲ၍ ပြုပြင်သည်',
    secondSlotLong: 'ဒုတိယ အပိုင်း ချောင်းအရှည်',
    enableOld: 'ဘေးအပေါက်စက် ဆက်တင်အဟောင်းကို ဖွင့်ပါ',
    default: 'စံသတ်မှတ် ဆက်တင်',
    customizable1: 'စိတ်ကြိုက် ၁',
    customizable2: 'စိတ်ကြိုက် ၂',
    customizable3: 'စိတ်ကြိုက် ၃',
    customizable4: 'စိတ်ကြိုက် ၄',
    knifeSetting: 'ဓားကိရိယာ ဆက်တင်',
    soltTip: '(အပေါက်/ချောင်းဖရီးဇ် ပါဝင်သည်)',
    specialSetting: 'အထူး ဆက်တင်',
    ramino: 'Ramino',
    sun: 'တံဆစ်-ချောင်း (Mortise & Tenon)',
    please: 'မကြာမီ လာမည်',
    designatedKnives: 'သတ်မှတ်ဓား',
    designated: 'သတ်မှတ်',
    workOrder: 'ပြုပြင် အမိန့်',
    other: 'အခြား',
    nameSetting: 'နောက်ဆက်အမည် (suffix) ဆက်တင်',
    repeatErr: 'နံပါတ် ထပ်နေသည်၊ ပြန်လည်သတ်မှတ်ပါ'
    },
  electronicSaw: {
    importMaterial: 'ကုန်ကြမ်းစာရင်း တင်သွင်းပါ',
    formSetting: 'အီလက်ထရွန်းနစ် လွှ ဖောင် ဆက်တင်',
    fileFormat: 'ဖြတ်တောက်စာရင်း အထွက်ဖိုင် ဖော်မတ်:',
    isSmallFile: 'သေးငယ်ဘုတ် ရုပ်ပုံဖိုင် ထုတ်ပါ:',
    fileGroupRule: 'အီလက်ထရွန်းနစ်လွှ ဖိုင်များကို အရောင်/ပစ္စည်း/ဘုတ်အထူအလိုက် ဇယားခွဲပါ:',
    roomsByCategory: 'အီလက်ထရွန်းနစ်လွှ ဖိုင်များကို အခန်းအလိုက် ဇယားခွဲပါ:',
    delimiter: 'ခွဲခြားအမှတ်:',
    fileName: 'ဖြတ်တောက်စာရင်း ဖိုင်အမည်:',
    fineNameTip: 'ဖြတ်တောက်စာရင်း ဖိုင်အမည် မဗလာဖြစ်ရပါ!',
    fileNamePlaceholder: 'စိတ်ကြိုက် ဖြတ်တောက်စာရင်း',
    outputFileEncoding: 'အထွက်စာရင်း အင်ကုဒ် ဖော်မတ်:',
    utf8: 'BOM ပါသော UTF-8',
    cellTab: 'ဆဲလ် တැබ်(	) ကို ဖန်တီးပါ:',
    texture: 'အရုပ်အဆင်း(纹理) ဖော်ပြပုံ:',
    special: 'အထူးပုံစံ(异形) ဖော်ပြပုံ:',
    notSpecial: 'အထူးပုံစံ မဟုတ်ပါ',
    genSimpleLabelBarcode: 'ရိုးရှင်းဖော်မတ် တက်ဂ် ဘားကုဒ် ဖန်တီး',
    uniqueBarCode: 'ဘုတ်အစိတ်အပိုင်း ဘားကုဒ် တစ်မူထူးခြား',
    uniqueBarCodeTip: 'ဖွင့်ပြီးနောက် “ရိုးရှင်းဖော်မတ် တက်ဂ် ဘားကုဒ်ဖန်တီး” လုပ်ဆောင်ချက် မအလုပ်လုပ်တော့ပါ',
    roboticArmDocking: 'စက်လက်မောင်း ချိတ်ဆက်မှု',
    customeForm: 'စိတ်ကြိုက် ဖောင်',
    tagPool: 'ဒေတာ တက်ဂ် အစု',
    tagPoolTips: 'တက်ဂ်အစုမှ တက်ဂ်များကို ဆွဲယူရန် သို့မဟုတ် နှိပ်၍ ကူးယူနိုင်သည်',
    displayHead: 'ဇယားခေါင်းစီး မပြပါ',
    addTableHead: 'ဇယားခေါင်းစီး ထည့်ပါ',
    deleteTableHead: 'ဇယားခေါင်းစီး ဖျက်ပါ',
    generateExample: 'အထွက်ဖောင် နမူနာ ဖန်တီး',
    importExample: 'ဖောင် နမူနာ တင်သွင်း',
    importExampleTip: 'တင်သွင်းထားသော ဖောင်နမူနာသည် အီလက်ထရွန်းနစ်လွှ စိတ်ကြိုက်ပြုလုပ်ရာတွင် ကိုးကားရန်သာ ဖြစ်သည်',
    importExampleErrTip: 'ကုန်ကြမ်းစာရင်းကို မတင်သွင်းရသေးပါ၊ အရင်ဆုံး ကုန်ကြမ်းစာရင်းကို တင်သွင်းပါ',
    outputExample: 'အထွက်ဖောင် နမူနာ',
    outputExampleTip: 'စိတ်ကြိုက်ဖောင်၏ အထွက် နမူနာ',
    outputExampleErrTip: 'အထွက်ဖောင် နမူနာကို မဖန်တီးရသေးပါ၊ အရင်ဆုံး ဖန်တီးပါ',
    defaultTableHead: 'စံသတ်မှတ် ဇယားခေါင်းစီး',
    deleteHeadErrTip: 'ဖျက်ရန် ဇယားခေါင်းစီး မရှိပါ!',
    genNonString: 'စာသားမဟုတ်သော ဒေတာအမျိုးအစား ဖန်တီး',
    genNonStringTip: 'ဖန်တီးထားသော ဇယားဒေတာကို အီလက်ထရွန်းနစ်လွှ မဖတ်နိုင်ပါက ဤကို ဖွင့်၍ စမ်းကြည့်ပါ',
    revertWidth: 'အလျား纹(横纹) ဘုတ်၏ အလျား/အနံ ကို လဲလှယ်'
    },
  lockModal: {
    passwordInput: 'စကားဝှက်ကို ထည့်ပါ',
    lockPassword: 'သော့ဖွင့် စကားဝှက်',
    lockPasswordInput: 'သော့ဖွင့် စကားဝှက်ကို ထည့်ပါ',
    passwordInputPlaceholder: 'ဂဏန်း ၄ လုံး စကားဝှက်ကို ထည့်ပါ',
    editPassword: 'စကားဝှက် ပြောင်းရန်',
    confirmPassword: 'စကားဝှက် အတည်ပြုရန်',
    setLockPwd: 'သော့ဖွင့် စကားဝှက် သတ်မှတ်ရန်',
    pwdFormatErr: 'စကားဝှက် ဖော်မတ် မမှန်ပါ',
    sendMessageTo: 'SMS အတည်ပြုကုဒ်ကို ပို့မည့်နေရာ',
    captchaPlaceholder: 'အတည်ပြုကုဒ်ကို ထည့်ပါ',
    sendCaptcha: 'အတည်ပြုကုဒ် ပို့ရန်',
    sendSeccess: 'SMS ပို့ခြင်း အောင်မြင်သည်',
    sendFail: 'SMS ပို့၍မရပါ၊ နောက်မှ ပြန်စမ်းပါ',
    updateSeccess: 'စကားဝှက် သတ်မှတ်မှု အောင်မြင်သည်',
    editSuccess: 'စကားဝှက် ပြောင်းလဲမှု အောင်မြင်သည်',
    lockSeccess: 'သော့ဖွင့် အောင်မြင်သည်',
    lock: 'သော့ဖွင့်',
    lockSeccessTip: 'သော့ခတ် အောင်မြင်သည်',
    inputErrLimit: 'လက်ရှိ မှားယွင်းမှုအကြိမ်ရေ ကန့်သတ်ချက်သို့ ရောက်ပြီးပါပြီ၊ သော့ဖွင့် စကားဝှက်ကို ပြန်သတ်မှတ်ပါ!'
    },
  dock56Drill: {
    equipType: 'စက်ပစ္စည်း အမျိုးအစား',
    equipment: 'စက်ပစ္စည်း',
    fiveDock: '၅ မျက်နှာ ဒရိလ်',
    sixDock: '၆ မျက်နှာ ဒရိလ်',
    fileType: 'ဖန်တီးမည့် ဖိုင်အမျိုးအစား',
    templateOffline: 'အသုံးပြုနေသော တမ်းပလိတ်ကို ရပ်ဆိုင်းထားပြီးပါပြီ!',
    showExample: 'ဒေတာ နမူနာ ပြရန်',
    conNoticeTip: 'ချိတ်ဆက်ရာတွင် သတိပြုရန်:',
    conNoticeTip1: '1、"XY အက်ဆစ်လဲလှယ်" ကို ဖွင့်ထားသော ထွင်းထုစက်များတွင် ရှေ့/နောက် မျက်နှာလဲလှယ် ၅/၆ မျက်နှာဒရိလ် အထူးတမ်းပလိတ်ကို သုံးရမည်',
    conNoticeTip2: '2、၅/၆ မျက်နှာဒရိလ်တွင် ဘုတ်၏ အထူးပုံစံ(异形) ကို ပြရန်/ပြုပြင်ရန် တမ်းပလိတ်ထဲတွင် အထူးပုံစံဒေတာကို သတ်မှတ်ရမည်',
    conNoticeTip3: '3、၅/၆ မျက်နှာဒရိလ်ကို ပထမဆုံး သုံးသည့်အခါ သို့မဟုတ် တမ်းပလိတ်ပြောင်းပြီးနောက် <span style="color:#f00">ကဘီနက် စမ်းသပ်ထုတ်လုပ်မှု</span> ပြုလုပ်ပြီး မှန်ကန်မှုကို အတည်ပြုပြီးမှ ပုံမှန်ထုတ်လုပ်ပါ',
    conNoticeTip4: '4、စမ်းသပ်ထုတ်လုပ်ရာတွင် ရှေ့/နောက် အပေါက်-ချောင်းများ၏ အရွယ်/အနက်/မျက်နှာ/တည်နေရာ မှန်ကန်မှုကို သေချာစစ်ဆေးပါ၊ <span style="color:#f00">ကဘီနက် မီရ러(ပြန်ပုံ)</span> ဖြစ်ခြင်းကို ရှောင်ပါ',
    example: 'ဒေတာ နမူနာ',
    commonSetting: 'အထွေထွေ ပါရာမီတာ ဆက်တင်',
    throughHoleSetting: 'ထိုးဖောက်အပေါက်ကို နှစ်ဖက်မှ ခွဲ၍ ထိုးဖောက်',
    throughSlotSetting: 'ထိုးဖောက်ချောင်းကို နှစ်ဖက်မှ ခွဲ၍ ထိုးဖောက်/တိုင်',
    nonHolesNotFiles: 'စတုဂံဘုတ်တွင် အပေါက်/ချောင်းမရှိပါက ဖိုင်မထုတ်ပါ:',
    frontFileIdentifier: 'ရှေ့မျက်နှာ ဖိုင်အမှတ်အသား:',
    oppositeFileIdentifier: 'နောက်မျက်နှာ ဖိုင်အမှတ်အသား:',
    oppositeFileIdentifierTips: 'ဖန်တီးပုံ: မူလ 13 လုံး ဘုတ်ကုဒ် + အမှတ်အသားအက္ခရာ',
    arcDescription: 'ဝိုင်းကွေး ဖော်ပြပုံ',
    linePoints: 'မျဉ်းပိုင်းဖွဲ့စည်းပုံ ဖော်ပြချက်',
    arcCommand: 'ဝိုင်းကွေး အမိန့် ဖော်ပြချက်',
    slotWidthSplit: 'ကျယ်သောချောင်းကို ကျဉ်းချောင်းများ အများအပြားအဖြစ် ခွဲ၍ ပြုပြင်:',
    slotSplitWidth: 'ခွဲပြီးနောက် တစ်ချောင်းချင်း အကျယ်:',
    mm: 'မှတ်ချက်: ခွဲသည့်အရာသည် ပုံမှန် စတုဂံချောင်းများသာ ဖြစ်သည်',
    isNotMergeSlot: 'အနီးချင်း အကျယ်/အနက် တူညီသောချောင်းများကို တစ်ချောင်းတည်းအဖြစ် ဆက်တိုင်ပြုလုပ်:',
    slotPunchTip: 'ဤလုပ်ဆောင်ချက်သည် စိတ်ကြိုက်တမ်းပလိတ်သုံးသော နောက်ဘုတ်ချောင်းနှင့် အံဆွဲအောက်ဘုတ်ချောင်းများတွင်သာ သက်ရောက်သည်',
    sizeRange: 'အနီးချင်း အရွယ်အစား ≤',
    enableWorningTip: 'ဤလုပ်ဆောင်ချက်နှင့် “ရှေ့ဖက်အနား တင်ထားရာဦးတည်ချက်” ကို တပြိုင်နက်မဖွင့်နိုင်ပါ',
    longDirection: 'ဘုတ် အရှည်ဘက် တင်ထားရာဦးတည်ချက်',
    horizontal: 'အလျားလိုက်',
    vertical: 'ဒေါင်လိုက်',
    slotDirection: '၅/၆ မျက်နှာဒရိလ် ချောင်း သို့မဟုတ် အထူးပုံစံ တင်ထားရာဦးတည်ချက်',
    default: 'စနစ် စံသတ်မှတ်',
    frontLeft: 'ရှေ့ နှင့် ဘယ်',
    frontRight: 'ရှေ့ နှင့် ညာ',
    backLeft: 'နောက် နှင့် ဘယ်',
    backRight: 'နောက် နှင့် ညာ',
    frontDirection: 'ရှေ့ဖက်အနား တင်ထားရာဦးတည်ချက်',
    enableTip: 'မှတ်ချက်: Cloud Layout တွင်သာ သက်ရောက်သည်',
    fixedOn: 'တပ်ဆင်ထားရာ:',
    front: 'ရှေ့ဘက်',
    back: 'နောက်ဘက်',
    left: 'ဘယ်ဘက်',
    right: 'ညာဘက်',
    coordinateValue: 'ကိုဩဒိနိတ်တန်ဖိုး ဒသမထားမည့် အရေအတွက်:',
    decimalPlaces: 'ဒသမနေရာ',
    slotLengthCompensation: 'ချောင်းအရှည် ထပ်ဖြည့် (補偿)',
    curveholesLengthCompensation: 'အတွင်းပိုင်း အပြားမညီ ပုံသဏ္ဍာန် ချွန်ထောင့်သန့်စင် (清角)',
    slotCompensationEqualZero: 'အနားကွာအဝေး 0 ဖြစ်သော ချောင်းအနား ထပ်ဖြည့် (补偿)',
    slotCompensationNotEqualZero: 'အနားကွာအဝေး 0 မဟုတ်သော ချောင်းအနား ထပ်ဖြည့် (补偿)',
    slotCompensationTip: 'ဖြတ်တောက်ပြီးနောက် မပြတ်သန့်သော သေးငယ်ဝိုင်းထောင့် သို့မဟုတ် အရှည်မလုံလောက်ပါက ဤလုပ်ဆောင်ချက်ကို သုံးပါ',
    curveholesCompensationEqualZero: 'အနားကွာအဝေး 0 ဖြစ်သော အတွင်းပိုင်း အပြားမညီ အနား ထပ်ဖြည့် (补偿)',
    curveholesCompensationTip: 'အကြံပြုထည့်ရန်: အတွင်းပိုင်း အပြားမညီ ဖရီးဇ်ဓား၏ အချင်းဝက်တန်ဖိုး',
    curveholesCompensationTip2: 'ဘုတ်အပြင်ဘက် အစွန်းရေခဲတန်း (rectangular edge) အတိုင်း အတွင်းအပြားမညီကို ပြုပြင်ရာတွင် မပြတ်သန့်သော သေးငယ်ဝိုင်းထောင့် ထွက်လာပါက ဤလုပ်ဆောင်ချက်ကို သုံးပါ',
    specialParameter: 'အထူး ပါရာမီတာ ဆက်တင်',
    output5FDrillSlotKnifeCode: 'XML2 ချောင်းဖရီးဇ် ဓားကိရိယာ နံပါတ်',
    output5FDrillShapeKnifeCode: 'XML2 ပုံဖရီးဇ် ဓားကိရိယာ နံပါတ်',
    plankTexture: 'XML2 ဘုတ် အထည်အသား (纹理)',
    offset: 'XML2 ပုံဖရီးဇ် ဓားကိရိယာ ထပ်ဖြည့် (补偿)',
    mprConHoleDir: '၅/၆ မျက်နှာဒရင် MPR ဖိုင် ဘေးအပေါက် Z ကိုဩဒိနိတ် အခြေခံမျက်နှာပြင်',
    plankTop: 'ဘုတ် အပေါ်မျက်နှာပြင်',
    plankBottom: 'ဘုတ် အောက်မျက်နှာပြင်',
    codeInfo: 'ban ဖော်မတ်ဖိုင်တွင် Code အချက်အလက် ပါဝင်သည်:',
    bomFile: 'bom ဖော်မတ်ဖိုင် ထုတ်ပါ:',
    plankHeight: 'ဘုတ်အမြင့် ဖော်ပြချက်:',
    plankNum: 'ဘုတ်နံပါတ် ဖော်ပြချက်:',
    backZpoint: 'နောက်မျက်နှာ ချောင်း Z ကိုဩဒိနိတ်:',
    plankThick: 'ဘုတ်အထူ',
    slotDeep: 'ချောင်းအနက်',
    outputMprFile: 'ဖိုင်အမျိုးအစား',
    oldMPR: 'MPR အဟောင်း',
    newMPR: 'MPR အသစ်',
    mprFileZside: '၅/၆ မျက်နှာဒရင် MPR ဖိုင် ဘေးအပေါက် Z အက်ဆစ် အခြေခံမျက်နှာပြင်',
    fileTypeOffline: 'လက်ရှိရွေးထားသော ၅/၆ မျက်နှာဒရင် ဖိုင်အမျိုးအစားကို ပိတ်သိမ်းထားပြီးဖြစ်သည်၊ အတည်ပြုပါ!',
    permissionErr: 'ကိုယ်ရေးအချက်အလက် ပျောက်ဆုံးသွားသည်၊ ဤစာမျက်နှာကို Guigui မှ ပြန်ဖွင့်ပါ!',
    banFileSetting: 'ban ဖော်မတ်ဖိုင် ဆက်တင်',
    banFileCodeInfo: 'ban ဖော်မတ်ဖိုင်တွင် Code အချက်အလက် ပါဝင်သည်:',
    huahuaLine: 'Huahua အလိုအလျောက် လိုင်း',
    huahuaLineTip: '(တံဆိပ်ပေါ်တွင် သက်ဆိုင်ရာဒေတာကို အလိုအလျောက် ထည့်ပေးမည်）',
    huahuaPartFlag: {
      longSide: 'ရှည်ဘက် <',
      shortSide: 'သို့မဟုတ် တိုဘက် <',
      partFlag: 'ရှိသော ဘုတ်များအတွက် သေးဘုတ်အမှတ်အသား ထုတ်ပေးပါ',
      tip: '（တံဆိပ်ပေါ်တွင် “ဘုတ်အမှတ်အသား-သေးဘုတ်မှတ်တံဆိပ်” ဒေတာကို ထည့်ရမည်၊ Huahua အလိုအလျောက်လိုင်း ဖိုင်တွင် သက်ဆိုင်ရာဒေတာကို အလိုအလျောက် ထည့်ပေးမည်）'
      },
    plankPutWay: 'ဘုတ်ထားပုံ နည်းလမ်း',
    plankPutWayTip: 'လက်ရှိထုတ်လုပ်မှုလိုင်းသည် အလိုအလျောက်လိုင်းဖွင့်ထားပါက ပလင်းကို သီးခြားစီမံခြင်းမထောက်ပံ့ပါ',
    autoHandle: 'ကလမ်ကို အလိုအလျောက် ရှောင်ရန်',
    manualHandle: 'လက်ဖြင့် ရှောင်ရန် ဆက်တင်',
    fixedFront: 'ရှေ့ အပြီးသတ်အနား (封边) ကို တည်ငြိမ်ထား',
    plankNamePlacement: 'ဘုတ်အမည်အလိုက် ထားရှိခြင်း',
    plankNamePlacementTip1: '1. ဆက်တင်ပြီးနောက် ဘုတ်အမည်တွင် သတ်မှတ်ထားသော အကွက်ပါပါက ထိုဘုတ်၏ သက်ဆိုင်ရာ အနားကို စက်၏ သတ်မှတ်ထားသော ဘက်တွင် ချိတ်ထားမည်',
    plankNamePlacementTip2: '2. ဤဆက်တင်၏ ဦးစားပေးအဆင့်သည် အပေါ်ရှိ ဘုတ်ထားပုံ နည်းလမ်း ဆက်တင်ထက် မြင့်သည်',
    plankNamePlacementTip3: '3. ဤလုပ်ဆောင်ချက်သည် cloud တင်ဆက်မှုအတွက်သာ အကျိုးသက်ရောက်ပြီး လက်ရှိထုတ်လုပ်မှုလိုင်းတွင် Huahua အလိုအလျောက်လိုင်း ဖွင့်ထားပါက ဘုတ်ထားပုံကို သီးခြား ဆက်တင်ခြင်း မထောက်ပံ့ပါ',
    addRow: 'အတန်း ထည့်ရန်',
    plankNameTip: 'ဘုတ်အမည်ကို ထည့်သွင်းပါ',
    plankSide: 'ဘုတ်အနား',
    deviceSide: 'စက်တွင် ချိတ်ထားခြင်း',
    weldingPlatePlacementEnable: 'ဘုတ်ပြုပြင်မှုအခြေခံကို တည်ငြိမ်ထား',
    onlyBluen: 'Cloud Layout တွင်သာ သက်ရောက်သည်',
    fixedEdge: 'ရှေ့ အပြီးသတ်အနား (封边) ကို တည်ငြိမ်ထား',
    fixedEdgeRule: 'မှတ်ချက်: ဘုတ်ပြုပြင်မှုအခြေခံကို သတ်မှတ်ပါ',
    fixedEdgeRuleItem1: 'ကလမ်ရှိသောဘက်ကို အလိုအလျောက် ရှောင်ရှားပြီး ဘုတ်ပြုပြင်မှုကို လွယ်ကူစေသည်',
    fixedEdgeRuleItem2: 'အပြီးသတ်အနား (封边) ကို အလိုအလျောက် ရှောင်ရှားပြီး ဘုတ်ပြုပြင်မှုကို လွယ်ကူစေသည်',
    fixedEdgeRuleItem3: 'အပြီးသတ်အနား (封边) ကို အလိုအလျောက် ရှောင်ရှားပြီး ဘုတ်ပြုပြင်မှုကို လွယ်ကူစေသည်',
    fixedEdgeRuleItem4: 'အောင်မြင်သည့် အခြေခံကို သတ်မှတ်ပါ',
    satisfiedCondition: 'အောင်မြင်သည့် အခြေခံကို သတ်မှတ်ပါ',
    handDirection: 'ကလမ် တည်နေရာ ဦးတည်ချက်',
    handleMachineTip: 'လှည့်ပတ်ခြင်းဖြင့် အပေါက်/ချောင်းနှင့် အပြားမညီပုံသဏ္ဍာန်များသည် ကလမ်ရှိသောဘက်ကို အလိုအလျောက် ရှောင်ရှားပြီး ဘုတ်ပြုပြင်မှုကို လွယ်ကူစေသည်',
    handleWidth: 'ကလမ် အကျယ်',
    handleLength: 'ကလမ် အရှည်',
    handleMaxWidth: 'စက်က ပြုပြင်နိုင်သော အများဆုံး အကျယ်',
    usefulRange: 'သက်ရောက်မည့် အကွာအဝေး',
    plankLongSide: 'ဘုတ် ရှည်ဘက်',
    usefulRangeTip: 'ဘုတ် ရှည်ဘက်ထားခြင်းကို ဖွင့်ထားပြီး ဘုတ်၏ ရှည်ဘက်သည် ဤသက်ရောက်မည့် အကွာအဝေးအတွင်း ရှိပါက ချောင်းနှင့် အပြားမညီထားရာနေရာကို ဦးစွာ ဆုံးဖြတ်မည်',
    moveTip: 'ရှေ့/နောက် ဖိုင်အမှတ်အသား လုပ်ဆောင်ချက်ကို အောက်ပါနေရာသို့ ပြောင်းရွှေ့ပြီးဖြစ်သည်',
    millingOuter: 'ပြင်ပ အပြားမညီသာ ချောင်းဖရီးဇ်ခြင်း',
    millingInner: 'အတွင်းပိုင်း အပြားမညီပုံသဏ္ဍာန် ဖရီးဇ်ခြင်း',
    drilling: 'အပေါက် ပြုလုပ်ခြင်း',
    slotting: 'ချောင်း ပြုလုပ်ခြင်း',
    knivesTip1: '1၊ အပြားမညီ ဖရီးဇ်ဓားကို သတ်မှတ်ပြီးနောက် ဖြတ်တောက်လမ်းကြောင်းသည် ဓား၏ အချင်းဝက်ကို အလိုအလျောက်补偿 လုပ်ပေးမည်',
    knivesTip2: '2၊ အပြားမညီ ဖြတ်တောက်မှုသည် XY ဝင်ရိုး အပြန်အလှန် ပြောင်းလဲနိုင်သော ကတ်တင်/雕刻စက်များကို ယာယီ မထောက်ပံ့သေးပါ',
    internalCutting: 'အတွင်းပိုင်း အပြားမညီ ဖြတ်တောက်ရာတွင် ဓားချခြင်းနှင့် ဓားပြန်ယူခြင်းတို့သည် ဘုတ်အတွင်းဘက်တွင်ပင် ဖြစ်သည်',
    externalCutting: 'ပြင်ပ အပြားမညီ ဖြတ်တောက်ရာတွင် ဓားချခြင်းနှင့် ဓားပြန်ယူခြင်းတို့သည် ဘုတ်အပြင်ဘက်တွင် ဖြစ်သည်',
    externalCuttingDirection: 'ပြင်ပ အပြားမညီ ဖြတ်တောက်ရာတွင် အပြားမညီ ပါဝင်သော ဘက်အစွန်းတစ်လျှောက်လုံးကို တပြိုင်နက် ဖြတ်တောက်မည်',
    allExternalCutting: 'ပြင်ပ အပြားမညီ အားလုံး',
    onlyArcExternalCutting: 'ပြင်ပ ဝိုင်းကွေး (အာ့ခ်) အပြားမညီသာ'
    },
  doorWallCabinet: {
    tempErrTip: 'တံခါး-နံရံ-ဗီရို ပေါင်းစည်းစက်အတွက် အသုံးပြုမည့် ပုံစံ(template) ကို မထည့်ထားသောကြောင့် လုပ်ငန်းဖိုင်ကို ထုတ်မရပါ။ မှတ်ချက် - ထည့်သွင်းပြီးနောက် ပြန်လည် အပြင်အဆင်ချရန် လိုအပ်သည်။',
    title: 'တံခါး၊ နံရံနှင့် ဘီရို ပေါင်းစည်းစက်',
    guifang: 'စတုရန်းညှိခြင်း',
    processingTechnology: 'ပြင်ပနိုင်ငံရေး ဆိုင်ရာ',
    longPlateSecondarySquaring: 'မူရင်း ဖော်မတ်ဖြင့် ဖိုင်ထုတ်ပါ',
    slotOnDoorPlate: 'တံခါးပြင်ပီးမညီသာ အာ့ခ်ကွေးကွေးပီးမညီသာ',
    setting: 'တံခါး၊ နံရံနှင့် ဘီရို ပေါင်းစည်းစက် ဆက်တင်'
    },
  PTP: {
    title: 'PTP',
    outputFileFormat: 'ထုတ်ဖိုင် ဖော်မတ်',
    outputDefaultFileFormat: 'မူရင်း ဖော်မတ်ဖြင့် ဖိုင်ထုတ်ပါ',
    outputMPRFormat: 'MPR ဖော်မတ်ဖိုင် ထုတ်ပါ',
    fileFormatSettings: 'ဖိုင်ဖော်မတ် ဆက်တင်',
    wrapSettings: 'လိုင်းအဆုံးသတ် (newline) ဖော်မတ် ဆက်တင်:',
    enCodeSettings: 'ဖိုင် Encoding ဖော်မတ် ဆက်တင်:',
    utf8bom: 'BOM ပါသော UTF-8',
    partCoordinate: 'သေးဘုတ် ကိုဩဒိနိတ်',
    xPointSymbol: 'အလျားတန်း (X) ကိုဩဒိနိတ်:',
    yPointSymbol: 'ဒေါင်လိုက် (Y) ကိုဩဒိနိတ်:',
    zPointSymbol: 'မြှောက်/ချ (Z) ကိုဩဒိနိတ်:',
    upRight: 'အပြုတန်ဖိုး',
    negative: 'အနှုတ်တန်ဖိုး',
    plankMirroring: 'ဘုတ် မီရರ್/ပြန်လှန်',
    plankMirrorSetting: 'ဘုတ် မီရರ್ ဆက်တင်:',
    xAxis: 'X ဝင်ရိုး မီရರ್',
    yAxis: 'Y ဝင်ရိုး မီရರ್',
    mirrorTip: '（ဘုတ်ကို မီရರ್/ပြန်လှန် လုပ်သည့်အခါ ဤလုပ်ဆောင်ချက်ကို သုံးပါ）',
    knifeTable: {
      type: 'အမျိုးအစား',
      diameter: 'အချင်းΦ',
      offsetX: 'အော့ဖ်ဆက် X',
      offsetY: 'အော့ဖ်ဆက် Y',
      offsetZ: 'အော့ဖ်ဆက် Z',
      offsetNo: 'အော့ဖ်ဆက် နံပါတ်',
      drillVelocity: 'ဓားချနှုန်း [F]mm/min',
      cutVelocity: 'ပြုပြင်နှုန်း [F]mm/min',
      rotationSeep: 'လည်ပတ်နှုန်း [S]r/min',
      insertRow: 'အတန်း ထည့်ပါ',
      deleteRow: 'အတန်း ဖျက်ပါ'
      },
    labelPool: 'ဒေတာ တံဆိပ်စု',
    dragTip: 'တံဆိပ်စုထဲမှ တံဆိပ်들을 Input box ထဲသို့ ဆွဲချ သို့မဟုတ် နှိပ်၍ ကူးယူနိုင်သည်',
    procedure: 'ပရိုဂရမ်',
    beginCode: 'ပရိုဂရမ် စတင်ကုဒ်:',
    endCode: 'ပရိုဂရမ် အဆုံးကုဒ်:',
    zzdKnifeBeginCode: 'ပင်မဝင်ရိုးဓား လဲစတင်ကုဒ်:',
    spindleCutter: 'ပင်မဝင်ရိုးဓား',
    zzdKnifeEndCode: 'ပင်မဝင်ရိုးဓား လဲအဆုံးကုဒ်:',
    verticalDrill: 'တည်တံ့ဒရင်',
    czzBeginCode: 'တည်တံ့ဒရင် စတင်ကုဒ်:',
    czzEndCode: 'တည်တံ့ဒရင် အဆုံးကုဒ်:',
    czzKnifeBeginCode: 'တည်တံ့ဒရင် ဓားလဲ စတင်ကုဒ်:',
    czzKnifeEndCode: 'တည်တံ့ဒရင် ဓားလဲ အဆုံးကုဒ်:',
    sidetrack: 'ဘေးဒရင်',
    czBeginCode: 'ဘေးဒရင် စတင်ကုဒ်:',
    czEndCode: 'ဘေးဒရင် အဆုံးကုဒ်:',
    czKnifeBeginCode: 'ဘေးဒရင် ဓားလဲ စတင်ကုဒ်:',
    czKnifeEndCode: 'ဘေးဒရင် ဓားလဲ အဆုံးကုဒ်:',
    pauseCode: 'ရပ်နားကုဒ်:',
    zSafeHeight: 'ဘေးကင်းအကွာအဝေး',
    spindleKnife: 'ပင်မစပင်ဒယ်ဓားနှင့် တည်တံ့ဒရင် Z အက်ဆစ် ဘေးကင်းအမြင့်',
    sideDrillZ: 'ဘေးဒရင် Z အက်ဆစ် ဘေးကင်းအမြင့်',
    sideDrillXY: 'ဘေးဒရင် X/Y အက်ဆစ် ဘေးကင်းအကွာအဝေး',
    auxiliaryFunction: 'အကူအညီ လုပ်ဆောင်ချက်',
    xhDedicatedInfo: 'Xinghui စက်များအတွက် သီးသန့် အချက်အလက် ထုတ်ပေးခြင်း',
    xhCheckBox: 'ဒေတာ:',
    outputSettings: 'ထုတ်ရန် ဆက်တင်:',
    partExegesis: 'ဖိုင်အတွင်း သေးဘုတ် အရွယ်အစား မှတ်ချက် ထုတ်ပေး',
    knifeNo: 'ဓားကိရိယာ နံပါတ်',
    specailKnifeNo: 'အပြားမညီ ပြုပြင်ဓား နံပါတ်:',
    slotKnifeNo: 'ချောင်းဖြတ်ဓား နံပါတ်:',
    fileNamePlaceholder: 'စိတ်ကြိုက် ဖြတ်တောက်စာရင်း',
    slotDrill: 'တည့်ညှိဓား'
    },
  glassEquip: {
    title: 'မှန်ဖြတ်စက်',
    fileType: 'ပြုပြင်ဖိုင် အမျိုးအစား:',
    sizeReparation: 'ပြားအရွယ်အစား ထပ်ဖြည့် (补偿):',
    cutPreSpace: 'ဖြတ်တောက်ရန် ကြိုတင်ထားသော အကွာအဝေး:',
    divideIntoFolders: 'မှန်၏ အရောင်/ပစ္စည်း/အထူ အလိုက် ဖိုင်များကို မတူညီသော ဖိုလ်ဒါများသို့ ခွဲပါ:'
    },
  translate: {
    search: 'စကားလုံးရှာရန် တရုတ်စာ သို့မဟုတ် တရားဝင်ဘာသာပြန်ကို ထည့်ပါ',
    en: 'အင်္ဂလိပ်',
    es: 'စပိန်ဘာသာ',
    ar: 'အာရဗီဘာသာ',
    kz: 'ကာဇက်',
    vi: 'ဗီယက်နမ်',
    th: 'ထိုင်း',
    id: 'အင်ဒိုနီးရှား',
    ug: 'ဝီဂါ',
    customTranslate: 'နှိပ်၍ စိတ်ကြိုက်ဘာသာပြန် ထည့်နိုင်သည်',
    customText: 'စိတ်ကြိုက်ဘာသာပြန်',
    text: 'တရုတ်',
    targetLang: 'တရားဝင်ဘာသာပြန်',
    zh_hant: 'တရုတ်(ရိုးရာ)'
    },
  preLayoutSetting: {
    title: 'ကြိုတင်အပြင်အဆင် ဆက်တင်',
    titleTip: 'အပြင်အဆင် ပါရာမီတာ들을 အရင်ကြိုတင်သတ်မှတ်ပြီး အရင်အပြင်အဆင်လုပ်ကာ နောက်မှ ထုတ်လုပ်မှုလိုင်းကို ရွေးနိုင်သည်',
    settingTip: 'ထုတ်လုပ်မှုဖိုင်ကို ထုတ်ရန် ထုတ်လုပ်မှုလိုင်းအတွင်း သတ်မှတ်ထားသော ပါရာမီတာများသည် အောက်ပါ ကြိုတင်အပြင်အဆင် ပါရာမီတာများနှင့် တစ်လျှောက်တည်း ဖြစ်ရမည်၊ ကတ်တင်းစက်တွင်သာ သက်ရောက်သည်',
    emptyKnife: 'ဓားကိရိယာ မဖြည့်ထားပါ',
    noModify: 'ဆက်တင်များ မပြောင်းလဲပါ၊ သိမ်းရန်မလိုပါ',
    reSet: 'ပြန်လည်သတ်မှတ်ရန်',
    gayPosition: 'မီးခိုးရောင် စတုရန်းကွက်များဖြင့် ကျန်ပစ္စည်း တင်ထားရာနေရာကို ပြောင်းနိုင်သည်',
    surplusPosition: 'လက်ရှိ ကျန်ပစ္စည်း တင်ထားရာနေရာ ဖြစ်သည်',
    click: 'နှိပ်ပါ',
    grayStart: 'မီးခိုးရောင် စတုရန်းကွက်များဖြင့် စခန်း၏ စတင်မှတ်ကို ပြောင်းနိုင်သည်',
    currentStart: 'လက်ရှိ စခန်း၏ စတင်မှတ် ဖြစ်သည်',
    holeSlotSetting: 'အပေါက်/ချောင်း ထိုးဖောက်လုပ်ငန်း ဆက်တင်များ',
    knifeDiameter: 'ဖြတ်တောက်ဓား အချင်း',
    currentVersion: 'လက်ရှိဗားရှင်း',
    on: 'ဖွင့်',
    off: 'ပိတ်',
    firstShort: 'ပထမဆုံးဖြတ်တောက်ခြင်း-တိုဘက် ထည့်ပမာဏ',
    firstLong: 'ပထမဆုံးဖြတ်တောက်ခြင်း-ရှည်ဘက် ထည့်ပမာဏ',
    cuttingSplitLong: 'ရှည်ဘုတ်ကို နှစ်ကြိမ်ဖြတ်တောက်ခြင်း-ရှည်ဘက် ကျော်လွန်',
    cuttingSplitShort: 'ရှည်ဘုတ်ကို နှစ်ကြိမ်ဖြတ်တောက်ခြင်း-တိုဘက် ကျော်လွန်',
    plankThick: 'ပုံမှန်ဘုတ် အထူ ≥ ',
    singleDoorThick: 'တံခါးဘုတ် အထူ ≥ ',
    normalPlank: 'ပုံမှန်ဘုတ်',
    confilictTip: 'ဆက်တင် ထိခိုက်မှုများ ရှိသည်: {confilictTotal} ခု',
    selectLine: 'ထုတ်လုပ်မှုလိုင်းကို ရွေးပါ',
    selectLinePlaceholder: 'ထုတ်လုပ်မှုလိုင်းကို ရွေးချယ်ပါ',
    lineConfilictTip: 'ရွေးထားသော ထုတ်လုပ်မှုလိုင်းသည် {line} နှင့် ထိခိုက်နေသည်',
    preWay: 'ကြိုတင်အပြင်အဆင် ပုံစံ',
    paibanErrTip: 'ရှည်ဘုတ် ပြုပြင်ရာတွင်【ရှည်/တိုဘက် ထည့်ပမာဏ】ပြောင်းလဲပါက အပြင်အဆင် မအောင်မြင်နိုင်သည်',
    paibanTip: 'ယခုအပြင်အဆင်တွင် ဘုတ်ကြီးပစ္စည်းအတွက် ဖြတ်တောက်ဓားကို သတ်မှတ်ထားသဖြင့် ပြန်လည်အပြင်အဆင်လုပ်ရန်လိုသည်',
    reLayout: 'လက်ရှိ ထုတ်လုပ်မှုလိုင်းဖြင့် ပြန်လည်အပြင်အဆင်လုပ်ပါ',
    fetchErr: 'ကြိုတင်အပြင်အဆင် ဆက်တင်များကို ရယူ၍မရပါ',
    resetSuccess: 'ပြန်လည်သတ်မှတ်မှု အောင်မြင်သည်',
    resetConfirm: 'သမိုင်းဗားရှင်းသို့ ပြန်လည်ပြောင်းမည်မှာ သေချာပါသလား？',
    prolineName: 'ထုတ်လုပ်မှုလိုင်း အမည်',
    layoutGap: 'အပြင်အဆင် အကွာအဝေး',
    generalThickness: 'ဒုတိယဖြတ်တောက် 대상-ပုံမှန်ဘုတ် အထူ',
    cutGeneralPlank: 'ဒုတိယဖြတ်တောက် 대상-ပုံမှန်ဘုတ်',
    cutSingleDoor: 'ဒုတိယဖြတ်တောက် 대상-တံခါးပြား',
    secondary_cutting_board_list: 'သတ်မှတ်ထားသော ဘုတ်အမည်များနှင့် ဖြတ်တောက်မည့် ဘုတ်အပိုင်းအမည်များ စာရင်း',
    changeProline: 'ထုတ်လုပ်မှုလိုင်းကို ပြောင်းပါ',
    backTip: 'ထုတ်လုပ်မှုလိုင်းရွေးရန် အလုံးစုံအပြင်အဆင်သို့ ပြန်သွားပါ',
    preLayout: 'ကြိုတင်အပြင်အဆင် ပုံစံအတိုင်း အပြင်အဆင်လုပ်ပါ',
    preWayEmpty: '(ဗလာ)ကြိုတင်အပြင်အဆင် ပုံစံ',
    specialConfilictTip: 'ဝိုင်းကွေး ဖရီးဇ်အောက် လုပ်ငန်းစဉ်သည် အပြင်အဆင်ရလဒ်ကို သက်ရောက်သဖြင့် ပြန်လည်အပြင်အဆင်လုပ်ရန်လိုသည်'
    },
  lunbo: {
    tips: 'အသုံးပြုရန် အကြံဉာဏ်များ',
    introduction: 'လုပ်ဆောင်ချက် မိတ်ဆက်',
    qtDownloadText: 'နွေးထွေးသော သတိပေးချက်: ဒေါင်းလုဒ်ဖိုင် မပြည့်စုံပါက Cloud Layout ဝဘ်ဆိုဒ်သို့ သွားပြီး ဒေါင်းလုဒ်လုပ်ပါ!'
    },
  sendModal: {
    paibanImgType: 'အပြင်အဆင်ပုံ ဖိုင်အမျိုးအစား'
    },
  authenticationModal: {
    title: 'QR ကုဒ်စကင်ဖတ်၍ ခွင့်ပြုချက် အတည်ပြုခြင်း',
    tip: 'ခွင့်ပြုချက်အောင်မြင်မီ ဒိုင်ယာလော့ကို မပိတ်ပါနှင့်！',
    countdownTip: '{countdown} အပြီး သက်တမ်းကုန်မည်',
    refreshTip: 'QR ကုဒ်ကို အသစ်ပြန်တင်ပါ',
    qrcodeTip: 'WeChat ဖြင့် QR ကုဒ်ကို စကင်ဖတ်ပြီး လုပ်ဆောင်ချက်ကို ပြီးစီးပါ',
    qrcodeTip2: 'စကင်ဖတ်ပြီး သိမ်းဆည်းမှု မအောင်မြင်ပါက “Guigui အထွေထွေ ဆက်တင်များ - အသုံးပြုသူ ခွင့်ပြုချက် ဆက်တင်များ” တွင် စနစ်ပြင်ဆင်ခွင့်ကို သင့်အား ခွင့်ပြုပေးရပါမည်။',
    waiting: 'စကင်ဖတ်ရန် စောင့်နေသည်',
    scanning: 'စကင်ပြီးပြီး၊ အတည်ပြုရန် စောင့်နေသည်',
    success: 'အတည်ပြုမှု အောင်မြင်သည်',
    error: 'အတည်ပြုမှု မအောင်မြင်ပါ',
    expired: 'QR ကုဒ် သက်တမ်းကုန်ပြီးပြီ',
    tip2: 'သင့်အကောင့်ဒေတာ လုံခြုံရေးအတွက် လက်ရှိ လုပ်ဆောင်သူ အချက်အလက်ကို အတည်ပြုရန် လိုအပ်သည်',
    tip3: 'စမ်းသပ် ထုတ်လုပ်ရေးဗီရိုသည် ဖြစ်ရမည်၊ {fontStyleStart}မမျှတသော ဗီရိုခန္ဓာကိုယ်၊ ဗီရို ကြေးပြန်ချိန်မှု ရှောင်ရှားရန်{fontStyleEnd} ပြဿနာ'
    },
  printTag: {
    dualLanguageTip: 'တရုတ်-အင်္ဂလိပ် နှစ်ဘာသာ လေဘယ်လ် ဖန်တီးခွင့်မရှိပါ၊ လက်ရှိတွင် ကြည့်ရှုမှုသာ ရနိုင်သည်။ တရားဝင် အသုံးပြုလိုပါက အရောင်းဌာနကို ဆက်သွယ်ပါ~',
    generateDualLanguageTagTip: 'တရုတ်-အင်္ဂလိပ် နှစ်ဘာသာ လေဘယ်လ်များ ဖန်တီးရန်',
    dualLanguageTip2: 'ဤလုပ်ဆောင်ချက်သည် အခပေးဖြစ်သည်။ အသုံးမပြုမီ ဖွင့်လှစ်ရန် အရောင်းဌာနကို ဆက်သွယ်ပါ~',
    effectiveDataSource: 'အကျိုးပြုသည့် ဒေတာအခြေခံ',
    partName: 'ဘုတ်အမည်'
    },
  userAccessToken: {
    createTime: 'ဖန်တီးသည့်အချိန်',
    lastUsedTime: 'နောက်ဆုံးအသုံးပြုချိန်',
    expireTime: 'သက်တမ်းကုန်ဆုံးချိန်',
    status: 'အခြေအနေ',
    tokenNamePlaceholder: 'တိုကင်အမည်ထည့်ပါ',
    expireTimeSelectPlaceholder: 'သက်တမ်းကုန်ဆုံးချိန်ကို ရွေးချယ်ပါ',
    securityBannerTip: 'သင့် ကိုယ်ပိုင်ဝင်ရောက်မှတ်တမ်းကို အခြားသူများနှင့် မျှဝေမထားပါနှင့် သို့မဟုတ် ဘရောက်ဖာတွင် သို့မဟုတ် အခြားကလိုင်ကုဒ်တွင် အထွက်မပေးပါနှင့်။ အကောင့်လုံခြုံရေးအတွက် လူသိရှင်ကြား ပေါက်ကြားသော မှတ်တမ်းများကို တွေ့ရှိပါက အလိုအလျောက် ပိတ်သွားနိုင်သည်။',
    expired: 'သက်တမ်းကုန်ပြီ',
    valid: 'အာမခံ',
    remove: 'ဖယ်ရှားပါ',
    previewOnceWarning: 'ဤတိုကင်ကို တစ်ကြိမ်သာ ပြသပါသည်။ ဤလျှို့ဝှက်ချက်ကို လုံခြုံ၍ ရယူနိုင်သော နေရာတွင် သိမ်းပေးပါ။ အခြားသူများနှင့် မျှဝေမထားပါနှင့် သို့မဟုတ် ဘရောက်ဖာတွင် သို့မဟုတ် အခြားကလိုင်ကုဒ်တွင် အထွက်မပေးပါနှင့်။',
    token: 'တိုကင်',
    deleteConfirm: 'ဤတိုကင်ကို ဖျက်မည်လား?',
    userAccessToken: 'အသုံးပြုသူ ဝင်ရောက်တိုကင်',
    dayUnit: 'ရက်',
    custom: 'စိတ်ကြိုက်',
    previewModalTitle: 'ကိုယ်ပိုင်ဝင်ရောက်မှတ်တမ်း အသစ်',
    addModalTitle: 'ကိုယ်ပိုင်ဝင်ရောက်မှတ်တမ်း အသစ်ထည့်ပါ'
    },
  bujianStore: {
    inputPlaceholder: 'ဗီရိုခန္ဓာကိုယ်ကုဒ်ကို ဖြင့် ပါဝင်သည်များကို ရှာဖွေရန်',
    noData: 'မှတ်ချက်များမရှိပါ',
    loadingErr: 'ဗီရိုခန္ဓာကိုယ်ကုဒ်ကို ဖြင့် ပါဝင်သည်များကို ရှာဖွေရန်',
    bujianStore: 'ဗီရိုခန္ဓာကိုယ်ကုဒ်ကို ဖြင့် ပါဝင်သည်များကို ရှာဖွေရန်',
    awaitStore: 'ဗီရိုခန္ဓာကိုယ်ကုဒ်ကို ဖြင့် ပါဝင်သည်များကို ရှာဖွေရန်',
    noDrag: 'ဗီရိုခန္ဓာကိုယ်ကုဒ်ကို ဖြင့် ပါဝင်သည်များကို ရှာဖွေရန်',
    outOfCanvas: 'ဗီရိုခန္ဓာကိုယ်ကုဒ်ကို ဖြင့် ပါဝင်သည်များကို ရှာဖွေရန်'
    },
  alginTexture: {
    tip: 'လက်ရှိလုပ်ဆောင်ချက်သည် ပေါ်ဒ်၏ အမျက်အသားညီညွတ်မှု အချက်အလက်ကို ဖျက်ပစ်မည်။ ဆက်လုပ်မည်လား အတည်ပြုပါ။',
    tip2: 'လက်ရှိလုပ်ဆောင်ချက်သည် ပေါ်ဒ်များကြားရှိ အနံ့ကို ပြောင်းလဲပေးပြီး အရင်းအမြစ်များကို ဖြစ်ပေါ်စေပါမည်။ ဆက်လုပ်မည်လား အတည်ပြုပါ။',
    group: 'အမျက်အသားညီညွတ်မှု အစု',
    groupTemp: 'အမျက်အသားညီညွတ်မှု အစု တစ်ခု',
    textureAlignmentPlank: 'အရောင်ရင်းညှိပြားကို ရွှေ့၍ မရပါ'
    },
  customizeFolder: {
    customizeFolder: 'ဖိုင်ဆောင်ကို စိတ်ကြိုက်ပြုလုပ်မည်',
    customizeFolderTip: 'သတိပြုပါ-ဖိုင်ဆောင်ကို စိတ်ကြိုက်ပြုလုပ်ပြီးနောက် ယခင်ကသတ်မှတ်ထားသည့်ဖိုင်ဆောင်ခွဲခြားမှုစည်းမျဉ်းများသည် ပါဝင်မည်မဟုတ်ပါ',
    processingFilesTitle: 'ဖိုင်ဒေတာကိုအလုပ်လုပ်သည်',
    dragToFolderTip: 'ဘယ်ဘက်ရှိဖိုင်ဆောင်သို့ဆွဲပြီးဆွဲတင်ခြင်းဖြင့် subfolder သို့မဟုတ် file အဖြစ်သတ်မှတ်နိုင်သည်',
    folderNameEmpty: 'ဖိုင်ဆောင်အမည်က ცარიနေခြင်းမရနိုင်ပါ',
    folderNameExists: 'တူညီသောအမည်ရှိသည့်ဖိုင်ဆောင်ရှိသည်',
    fileNotFound: 'မှန်ကန်သောဖိုင်ကိုရယူရန်မအောင်မြင်ပါ',
    fileCannotBeClassified: 'ဤအမျိုးအစားဖိုင်ကို အမျိုးအစားခွဲထားသည့်ဖိုင်ဆောင်တစ်ခုစီအောက်တွင်ထားရန်မရနိုင်ပါ',
    cannotAddAtThisPosition: 'ဒီနေရာတွင်ထည့်ရန်မရနိုင်ပါ',
    fileAlreadyExists: '【{name}】သည်ဤဖိုင်ဆောင်၌ရှိပြီးဖြစ်သည်',
    confirmDeleteFolder: 'ဤဖိုင်ဆောင်ကိုဖျက်ရန်သေချာပါသလား?',
    confirmDeleteItem: '【{name}】ကိုဖျက်ရန်သေချာပါသလား?',
    confirmDeleteFolderWithChildren: 'ဤဖိုင်ဆောင်အောက်တွင် အခြားဖိုင်ဆောင်များ/ဖိုင်များရှိသည်၊ ၎င်းကိုဖျက်ရန်သေချာပါသလား?',
    deleteFile: 'ဖိုင်ဖျက်ပါ',
    addSubFolder: 'ဖိုင်ဆောင်ခွဲထည့်ပါ',
    editFolder: 'ဖိုင်ဆောင်ကိုတည်းဖြတ်ပါ',
    deleteFolder: 'ဖိုင်ဆောင်ဖျက်ပါ',
    rootCannotDelete: 'အမြစ်ဒါရိုက်တိုရီကိုဖျက်ဆီးရန်မရနိုင်ပါ',
    newFolder: 'ဖိုင်ဆောင်အသစ်',
    fileUsedCanDrag: 'အသုံးပြုပြီး - ထပ်ခါထပ်ခါဆွဲပနိုင်သည်',
    fileDraggable: 'ဆွဲတင်နိုင်သည်',
    addFileToFolder: '【{fileName}】 ကို {folderName} သို့ထည့်ပါ',
    addFolderTitle: 'ဖိုင်ဆောင်ထည့်ပါ',
    editFolderTitle: 'ဖိုင်ဆောင်ကိုတည်းဖြတ်ပါ',
    folderNameLabel: 'ဖိုင်ဆောင်အမည်',
    folderNamePlaceholder: 'ဖိုင်ဆောင်အမည်ကိုထည့်ပါ',
    sequenceStartLabel: 'တိုးလာသော序号စတင်တန်ဖိုး',
    classifyMethodLabel: 'ခွဲခြားနည်းလမ်း',
    nameLengthLimitLabel: 'အက္ခရာအရှည်ကန့်သတ်ချက်',
    tagInsertTip: 'ဖိုင်ဆောင်အမည်ထဲသို့ထည့်ရန် tag ကိုနှိပ်ပါ',
    classifyTagInsertTip: 'ဖိုင်ဆောင်အမည်ထဲသို့ထည့်ရန် tag ကိုနှိပ်ပါ၊ ဖိုင်များကို သတ်မှတ်ထားသည့် tag အရ ခွဲခြားမည်',
    engraving_front: 'မှနှင်းစက်၏ရှေ့ဘက်ဖိုင်',
    engraving_opposite: 'မှနှင်းစက်၏နောက်ဘက်ဖိုင်',
    engraving_merge: 'မှနှင်းစက်၏ပေါင်းစည်းထားသည့်ဖိုင်',
    engraving_mill: 'ဒုတိယအလုပ်လုပ်မှုနွားခွေးနှေးရာနေရာ',
    engraving_haitang: 'ဒုတိယအလုပ်လုပ်မှုဘက်ထောင့်Haitangဖိုင်',
    engraving_arc_slot: 'ဒုတိယအလုပ်လုပ်မှု milling fundus arc slot',
    engraving_line_slot: 'ဒုတိယအလုပ်လုပ်မှုကိုယ်ပိုင်သတ်မှတ်ဓားလမ်း',
    engraving_straight_arc_slot: 'ဒုတိယအလုပ်လုပ်မှု arc bending ပိုင်း straight slot',
    engraving_frame_door: 'ဒုတိယအလုပ်လုပ်မှု bone door ဖိုင်',
    engraving_inner_shape: 'ဒုတိယအလုပ်လုပ်မှု inner shape',
    engraving_hole: 'ဒုတိယအလုပ်လုပ်မှု regular hole',
    engraving_slot: 'ဒုတိယအလုပ်လုပ်မှု regular slot',
    engraving_single_file_merge: 'ဒုတိယအလုပ်လုပ်မှု file merge',
    electronic_saw: 'အီလက်ထရွန်းစောက်ဖိုင်',
    glass: 'ဖန်ခွက်ဖြတ်စက်ဖိုင်',
    glass_machine: 'ဖန်ခွက်ဖြတ်စက်',
    side_machine: 'ဘေးတွင်းတူးစက်ဖိုင်',
    side_machine_xml3: 'ဗားရှင်းဟောင်းဘေးတွင်းတူးစက် XML3 ဖိုင်',
    side_machine_txt: 'ဗားရှင်းဟောင်းဘေးတွင်းတူးစက် TXT ဖိုင်',
    side_machine_nc: 'ဗားရှင်းဟောင်းဘေးတွင်းတူးစက် NC ဖိုင်',
    dock56F: 'ငါး/ခြောက်ဘက်တူးဖိုင်',
    ptp: 'PTP ဖိုင်',
    aio: 'all-in-one စက်ဖိုင်',
    aio_anc: 'အရာအားလုံးပေါင်းစပ် စက်၏ ရှေ့ဘက် ANC ဖိုင်',
    labeling_1: 'တံဆိပ်ကပ်စက်ဖိုင် 1',
    labeling_2: 'တံဆိပ်ကပ်စက်ဖိုင် 2',
    labeling_3: 'တံဆိပ်ကပ်စက်ဖိုင် 3',
    robotic_arm: 'စက်လက်ဖိုင်',
    label_image: 'တံဆိပ်ပုံဖိုင်',
    label_pdf: 'တံဆိပ် PDF ဖိုင်',
    paiban_image: 'ပုံစီချထားသော ပုံဖိုင်',
    paiban_pdf: 'ပုံစီချထားသော ပုံ PDF ဖိုင်',
    engraving: 'မှနှင်းစက်',
    electronic: 'အီလက်ထရွန်းစောက်',
    side_hole: 'ဘေးတွင်းတူးစက်',
    drilling: 'ငါး/ခြောက်ဘက်တူး',
    labeling: 'တံဆိပ်ကပ်စက်',
    robotic: 'စက်လက်',
    label: 'တံဆိပ်',
    warningTip: 'သတိပြုပါ-ကွင်းချုပ်ကွင်း 【{}】 နှင့်၎င်းတို့၏အကြောင်းအရာများကို မပြတ်သားစေရပါ၊ လက်ဖြင့်ဖျက်ခြင်း သို့မဟုတ် ထပ်ထည့်ခြင်း မပြုပါနှင့်!',
    fileClassifyError: 'ဤဖိုင်ကို {classifyNames} အရခွဲခြား၍မရနိုင်ပါ',
    folderClassifyByTextureColorThickSize: 'အရောင်၊ ပစ္စည်း၊ အထူ၊ ကြီးမားသောဘုတ်အရွယ်အစားအရ မတူညီသောဖိုင်ဆောင်များအဖြစ်ခွဲခြားပါ (တံဆိပ်ဖိုင်များအတူတကွ)',
    unnamed: 'မည无闻',
    specialText: 'အထူး',
    surplusText: 'ပစ္စည်းပိုလျှံ',
    normalText: 'ပုံမှန်',
    plankText1: 'ပေါ်ဒ်',
    resetTemplate: 'ပစ္စည်းပိုလျှံ',
    resetTemplateConfirm: 'ပုံစံခွက်ကို ပြန်ချိန်ထားကြောင်း အတည်ပြုခဲ့ပြီလား။',
    clearTemplate: 'ပုံစံခွက်ကို ရှင်းလင်းပါ',
    clearTemplateConfirm: 'ပုံစံခွက်ကို ရှင်းလင်းရန် သေချာပါသလား။',
    legendFixedFolder: 'သတ်မှတ်ဖိုင်ဆောင်',
    legendClassifyFolder: 'အမျိုးအစားခွဲထားသော ဖိုင်ဆောင်',
    legendFixedTag: 'သတ်မှတ်ဒေတာ',
    legendNormalTag: 'ဒိုင်နမစ်ဒေတာ',
    legendClassifyTag: 'အမျိုးအစားခွဲထားသော ဒိုင်နမစ်ဒေတာ',
    door_wall_aio: 'တံခါး၊ နံရံနှင့် ဘီရို ပေါင်းစည်းစက်',
    noPermission: 'လက်ရှိတွင် စိတ်ကြိုက်ဖိုင်တွဲ အသုံးပြုခွင့် မရှိပါ။ အသုံးမပြုမီ ဝယ်ယူရန် အရောင်းဌာနကို ဆက်သွယ်ပါ။',
    enableCustomFolder: 'စိတ်ကြိုက်ဖိုင်တွဲ ဖွင့်ပါ',
    exporttagTip: 'တက် PDF နှင့် ပုံတို့ကို တစ်ပြိုင်နက်တည်း တင်ပို့သည့်အခါ၊ PDF ကို မူရင်းအားဖြင့် ပေးပို့သည်'
    },
  paibanTask: {
    pausedTip: 'ပိတ်ထားသော အလုပ်',
    continueTip: 'အလုပ်ကို ဆက်သွယ်ပါ',
    completed: 'အောင်မြင်ခဲ့သည်',
    failed: 'အလုပ်မအောင်မြင်ခဲ့သည်',
    paused: 'ပိတ်ထားသော အလုပ်',
    pending: 'အလုပ်ကို ဆက်သွယ်ပါ',
    running: 'အလုပ်ကို ဆက်သွယ်ပါ',
    extraTip: 'ပုံတည်ချက်သည် အထက်ပါအနိမ့်ကျတို့သည် နောက်ဆုံးပတ်လည်အသုံးပြုခဲ့သည်။ အသုံးပြုခြင်းအားလုံးအဆင်ပြေပြီးလည်း အကြောင်းအရာများကို အကြောင်းအရာများကို မှတ်ချက်အသစ်ထဲသို့ သိမ်းဆည်းပေးပါ~',
    taskStatus: 'အလုပ်အခြေခံ',
    createTaskTip: 'ပုံတည်ချက်သည် အထက်ပါအနိမ့်ကျတို့သည် နောက်ဆုံးပတ်လည်အသုံးပြုခဲ့သည်။ အသုံးပြုခြင်းအားလုံးအဆင်ပြေပြီးလည်း အကြောင်းအရာများကို အကြောင်းအရာများကို မှတ်ချက်အသစ်ထဲသို့ သိမ်းဆည်းပေးပါ~',
    taskBatchTitle: 'တာဝန်အစုအဝေး',
    relatedOrderNosTitle: 'ဆက်စပ်အော်ဒါနံပါတ်များ',
    progressTitle: 'အပြင်အဆင်တိုးတက်မှု',
    boardCountTitle: 'ဘုတ်အသုံးပြုမှု ဗဟိုင်းစွာပြုလုပ်ထားသောဧရိယာ',
    optimizedAreaTitle: 'ဘုတ်အကောင်းဆုံးဖြစ်အောင်လုပ်ထားသောဧရိယာ',
    productionLineTitle: 'ထုတ်လုပ်ရေးလိုင်း',
    operationTitle: 'လုပ်ဆောင်ချက်',
    optimizeRateTitle: 'ဘုတ်အကောင်းဆုံးဖြစ်အောင်လုပ်ခြင်းနှုန်းကို ရှင်းလင်းစစ်ဆေးပါ',
    optimizeRateTip: 'အလုပ်ကို ဆက်သွယ်ပါမှားသည်။အလုပ်ကို ဆက်သွယ်ပါမှားသည်။',
    optimizeRateTip2: 'အပြင်အဆင်တိုးတက်မှုကို အထက်ပါအနိမ့်ကျတို့သည် နောက်ဆုံးပတ်လည်အသုံးပြုခဲ့သည်။ အသုံးပြုခြင်းအားလုံးအဆင်ပြေပြီးလည်း အကြောင်းအရာများကို အကြောင်းအရာများကို မှတ်ချက်အသစ်ထဲသို့ သိမ်းဆည်းပေးပါ~',
    boardCountTip: 'အပြင်အဆင်တိုးတက်မှုကို အထက်ပါအနိမ့်ကျတို့သည် နောက်ဆုံးပတ်လည်အသုံးပြုခဲ့သည်။ အသုံးပြုခြင်းအားလုံးအဆင်ပြေပြီးလည်း အကြောင်းအရာများကို အကြောင်းအရာများကို မှတ်ချက်အသစ်ထဲသို့ သိမ်းဆည်းပေးပါ~',
    optimizedAreaTip: 'အကောင်းဆုံးဖြစ်အောင်လုပ်ထားသောဧရိယာကို အထက်ပါအနိမ့်ကျတို့သည် နောက်ဆုံးပတ်လည်အသုံးပြုခဲ့သည်။ အသုံးပြုခြင်းအားလုံးအဆင်ပြေပြီးလည်း အကြောင်းအရာများကို အကြောင်းအရာများကို မှတ်ချက်အသစ်ထဲသို့ သိမ်းဆည်းပေးပါ~',
    paibanSettingTip: 'ပုံတည်ချက်သည် အထက်ပါအနိမ့်ကျတို့သည် နောက်ဆုံးပတ်လည်အသုံးပြုခဲ့သည်။ အသုံးပြုခြင်းအားလုံးအဆင်ပြေပြီးလည်း အကြောင်းအရာများကို အကြောင်းအရာများကို မှတ်ချက်အသစ်ထဲသို့ သိမ်းဆည်းပေးပါ~',
    dataException: 'အလုပ်ကို ဆက်သွယ်ပါမှားသည်။အလုပ်ကို ဆက်သွယ်ပါမှားသည်။'
    },
  paibanSetting: {
    advancedSetting: 'မြင့်မားသော ပုံတည်ချက်များ',
    advancedFeature: 'မြင့်မားသော ပုံတည်ချက်များ',
    surplusCutSpeedUp: 'အလုပ်ကို ဆက်သွယ်ပါမှားသည်။အလုပ်ကို ဆက်သွယ်ပါမှားသည်။',
    surplusCutSpeedUpTip4: 'လုပ်ဆောင်ချက်ဖြစ်စေရန် အဆင့်မြှင့်တင်နေပါသည်။ မကြာခင်တွေ့ရအောင်မြင်ပါစေ။',
    surplusCutSpeedUpTip: 'ပိုလျှံပစ္စည်း အပြင်အဆင် အကွာအဝေးကို အလိုအလျောက် 0 သတ်မှတ်သည်',
    surplusCutSpeedUpTip2: 'ပိုလျှံပစ္စည်းဖြတ်တောက်မှုသည် ဖြတ်ပြီးသားနှင့် အနားသတ်လမ်းကြောင်းများကို အလိုအလျောက်ကျော်၍ ထိရောက်မှုကို မြှင့်တင်သည်',
    surplusCutSpeedUpTip3: 'ဤလုပ်ဆောင်ချက်သည် အောင်မြင်သည်အထိုင်းအမှတ်များအတွက်ထားသည် (အပြိုင်အစွန်းဖြတ်နှင့်အပြိုင်အစွန်းအရှိန်မြှင့်လုပ်ဆောင်ချက်များနှင့်အတူအသုံးမပြုနိုင်သေးပါ)',
    surplusCutSpeedUpTip5: 'အောင်မြင်သည်အထိုင်းအမှတ်များအတွက်ထားသည်',
    featureDisplay: 'လုပ်ဆောင်ချက် ပြသခြင်း',
    featureDisplayTip: 'ဤစာမျက်နှာသည် လုပ်ဆောင်ချက်ဝင်ပေါက် ပြသခြင်းကိုသာ ထိန်းချုပ်ပြီး လုပ်ဆောင်ချက်ကိုယ်တိုင်၏ ဖွင့်ထားမှုနှင့် ပါရာမီတာ ဆက်တင်များကို မပြောင်းလဲပါ'
    },
  alignedPlan: {
    deepSearch: 'အောင်မြင်သည်အထိုင်းအမှတ်များအတွက်ထားသည်',
    deepSearchTip: 'အထူးလုပ်ဆောင်ချက်- ပြန်လည်စီစဉ်ခြင်းဖြင့် တွက်ချက်မှုအနက်ကို တိုးမြှင့်၍ ပိုကောင်းသော ရလဒ်ရယူနိုင်သည်',
    deepSearchTip2: 'Deep Search အဆင့်မြှင့်ပြီးနောက် ပြန်စီစဉ်၍ တွက်ချက်မှုအနက် တိုးနိုင်သည်။ ယခု စမ်းသုံးနိုင်သည်',
    deepSearchTip3: 'Deep Search က ပိုချွေတာသော အစီအစဉ် ပေးသည်',
    deepSearchTip4: 'Deep Search စီစဉ်ခွင့် မရှိသေးပါ။ ဝယ်ယူရန် အရောင်းနှင့် ဆက်သွယ်ပါ။',
    deepSearchTip5: 'Deep Search အဆင့်မြှင့်ပြီးနောက် သီးသန့်ဆာဗာတွက်ချက်အား ရရှိပြီး အရည်အသွေး တိုးတက်သည်။ ယခု ကြိုတင်ကြည့်နိုင်သည်'
    }
  }